const signUp = {
  HI: "ยินดีต้อนรับสู่ Healthnex",
  SIGN_UP_TO_JOIN_US: "ลงทะเบียนเพื่อเข้าร่วมกับเรา",
  USER_PROFILE: "ข้อมูลผู้ใช้",
  LOGIN_CREDENTIALS: "ข้อมูลเข้าสู่ระบบ",
  CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
  PLEASE_ENTER_YOUR_USERNAME: "กรุณากรอกชื่อผู้ใช้",
  PLEASE_ENTER_YOUR_PASSWORD: "กรุณากรอกรหัสผ่าน",
  PLEASE_CONFIRM_YOUR_PASSWORD: "กรุณายืนยันรหัสผ่าน",
  PLEASE_ENTER_YOUR_EMAIL: "กรุณากรอกอีเมล",
  PLEASE_ENTER_YOUR_PHONE:
    "กรุณากรอกหมายเลขโทรศัพท์ออสเตรเลียที่ถูกต้อง เช่น 0412345678",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE:
    "เช่น ผู้เชี่ยวชาญด้านแพทย์แผนจีน",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "กรุณาแนะนำตัวเองโดยย่อ",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "เช่น แพทย์แผนจีนเป็นศาสตร์ที่ใช้หลักการทางธรรมชาติผสมผสานกับการเปลี่ยนแปลงทางสรีรวิทยาและพยาธิวิทยาต่าง ๆ ของร่างกาย",
  HERBAL_MEDICINE: "การรักษาด้วยยาสมุนไพรจีน",
  SIGN_UP: "ส่งและลงทะเบียน",
  PURCHASE_AND_SIGN_UP: "ซื้อและลงทะเบียน",
  SIGN_UP_AS_PRACTITIONER: "ลงทะเบียนเป็นแพทย์",
  USERNAME_ALLOW_U_TO_LOGIN_TO_HEALTHNEXT_PLS_DONT_START_WITH_NUMBER:
    "ชื่อผู้ใช้ที่ใช้เข้าสู่ระบบ Healthnex ต้องไม่ขึ้นต้นด้วยตัวเลขและต้องไม่มีช่องว่าง",
  THIS_IS_A_VALID_USERNAME: "ชื่อผู้ใช้นี้สามารถใช้งานได้",
  NO_CLINIC_NAME: "ไม่ทราบชื่อคลินิก",
  IN_THIS_CLINIC_UR: "ในคลินิกนี้ คุณคือ",
  MEMBER: "สมาชิกคลินิก",
  IF_UR_MEMBER: "หากคุณเป็นสมาชิกคลินิก",
  IF_UR_OWNER: "หากคุณเป็นเจ้าของคลินิก (Business Owner)",
  WE_WILL_CREATE_THE_CLINIC_FOR_U:
    "เยี่ยมเลย! เราจะสร้างคลินิกนี้ให้คุณ",
  OR_IF_NO_ANY_CLINIC_FROM_ABOVE:
    "ไม่พบคลินิกที่คุณกำลังมองหาใช่ไหม?",
  THIS_BECUZ_THE_CLINIC_OWNER_MIGHT_NOT_CREATED_THE_CLINIC_IN_OUR_SYSTEM_YET:
    "อาจเป็นเพราะเจ้าของคลินิกยังไม่ได้สร้างคลินิกนี้ในระบบของเรา",
  PLS_CONTACT_THE_CLINIC_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "กรุณาติดต่อเจ้าของคลินิกเพื่อสร้างคลินิกและเชิญคุณเข้าร่วม",
  CONFIRM_PACKAGE: "ยืนยันแพ็กเกจ",
  READ_AND_AGREE_TO_TERMS: "อ่านและยอมรับข้อกำหนด",
  SELECTED_PACKAGE: "แพ็กเกจที่เลือก",
  SIGN_IN_MINI: "เข้าสู่ระบบ (เวอร์ชันไลต์)",
  BYE: "ออกจากระบบบัญชีแล้ว",
  U_DONT_HAVE_OWNED_CLINIC_PLS_GO_DESKTOP_VERSION_TO_CREATE_YOUR_OWN_CLINIC:
    "คุณยังไม่มีคลินิกที่เป็นเจ้าของ กรุณาไปที่เวอร์ชันเดสก์ท็อปเพื่อสร้างคลินิกของคุณเอง",
  CLINIC_OWNER: "เจ้าของคลินิก (Business Owner)",
  OWNER_DESCRIPTION:
    "หากคุณเป็นเจ้าของคลินิกและต้องการสร้างคลินิกบน Healthnex เพื่อเริ่มต้นใช้งาน กรุณาเลือกตัวเลือกนี้",
  MEMBER_DESCRIPTION:
    "หากคุณไม่ใช่เจ้าของคลินิก และต้องการเข้าร่วมคลินิกที่มีอยู่ หรือเพียงต้องการเผยแพร่เว็บไซต์ส่วนตัวผ่าน Healthnex กรุณาเลือกตัวเลือกนี้",
  PLEASE_INPUT_YOUR_CLINIC_ADDRESS: "กรุณากรอกที่อยู่คลินิกของคุณ",
  SELECT_ROLE: "เลือกบทบาทของคุณ",
  U_ARE: "หากคุณเป็น",
  SYSTEM_RECOMMEND_THE_BELOW_PACKAGE_WILL_BE_SUITABLE_FOR_YOU:
    "Healthnex ได้แนะนำแผนการสมัครสมาชิกที่เหมาะกับความต้องการของคุณมากที่สุด",
  GET_X_MONTHS_FREE_NOW: "รับสิทธิ์ใช้งานฟรี {{X}} เดือนทันที!",
  FREE_SUBSCRIPTION_OFFER_JOIN_NOW:
    "เพลิดเพลินกับการเข้าถึงแพ็กเกจฟีเจอร์การสมัครสมาชิกแบบเต็มรูปแบบโดยไม่มีค่าใช้จ่ายในช่วงเวลาจำกัด",
  U_CAN_ALSO_JOIN_THE_EXISTING_CLINIC_AND_WORK_WITH_THEM_COOPERATIVE_IN_HEALTHNEX:
    "นอกจากนี้ คุณยังสามารถเลือกเข้าร่วมคลินิกที่มีอยู่และทำงานร่วมกันภายใน Healthnex ได้อีกด้วย",
  ORIGINAL_PRICE: "ราคาเดิม",
  X_MONTHS_FREE_ACCESS: "ใช้งานฟรี {{X}} เดือน",
  S_CLINIC: " คลินิก",
  AGENT_INVITATION_TO_JOIN: "คำเชิญเข้าร่วมจากตัวแทน",
  INVALID_AGENT_REF_KEY:
    "รหัสอ้างอิงตัวแทนไม่ถูกต้อง กรุณาติดต่อตัวแทนของคุณเพื่อขอความช่วยเหลือเพิ่มเติม",
  VERIFYING_AGENT_REF_KEY: "กำลังตรวจสอบรหัสอ้างอิงตัวแทน",
  PRESS_LEFT_AND_RIGHT_KEY_TO_SWITCH_CLINIC:
    "กด ← ปุ่มซ้าย และ ปุ่มขวา → เพื่อสลับคลินิก",
  PRESS_ENTER_KEY_TO_START_WORKING: "กด ⤶ ปุ่ม ENTER เพื่อเริ่มทำงาน",
  WELCOME_TO_HEATHNEXT_TO_START_PLS_TELL_ME_WHICH_ROLE_YOU_WANT_TO_PLACE:
    "ยินดีต้อนรับสู่ Healthnex 👋\nก่อนเริ่มต้น กรุณาบอกเราว่าคุณคือใคร",
  UPLOAD_UR_PROFILE_PICTURE_HERE:
    "อัปโหลดรูปภาพของคุณ เพื่อให้ผู้อื่นจดจำคุณได้ง่ายขึ้น!",
  INCORRECT_PREV_PASSWORD: "รหัสผ่านเดิมไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง",
  PLEASE_LOGIN_USING_DESKTOP_VERSION_ENJOY_FULL_SERVICES:
    "ลงทะเบียนสำเร็จ กรุณาเข้าสู่ระบบเวอร์ชันเดสก์ท็อปของ Healthnex เพื่อใช้งานบริการแบบเต็มรูปแบบ หรือคุณสามารถใช้งานต่อด้วยเวอร์ชันไลต์บนมือถือเพื่อใช้ฟังก์ชันพื้นฐานได้",
  INDIVIDUAL_BUSINESS: "ผู้ประกอบวิชาชีพอิสระ",
  INDIVIDUAL_BUSINESS_DESCRIPTION:
    "หากคุณประกอบวิชาชีพในรูปแบบส่วนบุคคล คุณสามารถสร้างคลินิกของคุณเองได้ และยังสามารถเชิญพนักงานคนอื่นเข้าร่วมในภายหลังได้",
  PLEASE_INPUT_YOUR_BUSINESS_OR_HOME_ADDRESS:
    "กรุณากรอกที่อยู่ที่ทำการของคุณ (ถ้ามี) หรือที่อยู่ที่พักอาศัยปัจจุบัน",
};

const navigation = {
  PRACTITIONER: "แพทย์",
  PRACTITIONER_PORTAL: "พอร์ทัลแพทย์",
  HOME: "หน้าแรก",
  ABOUT_US: "เกี่ยวกับเรา",
  PARTNERS: "พันธมิตร",
  MEMBER_SERVICE: "บริการสมาชิก",
  CPD_TRAINING: "กิจกรรม CPD",
  TRAINING_AND_COURSES: "การอบรมและหลักสูตร",
  EVENT: "กิจกรรม",
  NEWS: "ข่าวล่าสุด",
  BECOMING_MEMBER: "สมัครเป็นสมาชิก",
  LOGIN_SIGNUP: "เข้าสู่ระบบ/ลงทะเบียน",
  ONLINE_PAYMENT: "ชำระเงินออนไลน์",
  DOWNLOAD_CENTER: "ดาวน์โหลด",
  AGREE_TO_USE_VAI_CLINIC_TEXT:
    "เมื่อเข้าสู่ระบบ ถือว่าคุณยอมรับที่จะใช้งานคลินิกตาม ",
  SIGN_IN: "เข้าสู่ระบบ",
  SIGN_OUT: "ออกจากระบบ",
  USERNAME: "ชื่อผู้ใช้",
  PASSWORD: "รหัสผ่าน",
  FORGET_PASSWORD: "ลืมรหัสผ่าน?",
  AND: " และ ",
  PLEASE_ENTER_YOUR_USERNAME: "กรุณากรอกชื่อผู้ใช้",
  PLEASE_ENTER_YOUR_PASSWORD: "กรุณากรอกรหัสผ่าน",
  CLINIC: "คลินิก",
  PRACTITIONER_PROFILE: "เว็บไซต์แพทย์",
  CONTACT_US: "ติดต่อเรา",
  GO_BACK: "ย้อนกลับ",
  ADD_PATIENT: "เพิ่มผู้ป่วย",
  SELECT_CLINIC_TO_WORK: "เลือกคลินิกที่จะทำงาน",
  SELECT_CLINIC: "เลือกคลินิก",
  PRESCRIPTION_MEDICAL_HISTORY: "ใบสั่งยาและบันทึกการรักษา",
  LANDING_PAGE_UPDATED: "ตั้งค่าหน้าปัจจุบันเป็นหน้าเริ่มต้นแล้ว",
  CHANGE_THIS_PAGE_AS_THE_ENTRY_PAGE:
    "เมื่อตั้งค่าหน้านี้เป็นหน้าเริ่มต้น หน้านี้จะแสดงเป็นหน้าแรกทุกครั้งที่คุณเข้าใช้งานระบบ",
  ENTRY_PAGE: "หน้าเริ่มต้น",
  URL_LINK: "ลิงก์ URL",
  URL_COPIED_TO_CLIPBOARD: "คัดลอก URL ไปยังคลิปบอร์ดแล้ว",
  EMAIL_COPIED_TO_CLIPBOARD: "คัดลอกอีเมลไปยังคลิปบอร์ดแล้ว",
  FAILED_TO_COPY_TO_CLIPBOARD:
    "ไม่สามารถคัดลอกไปยังคลิปบอร์ดได้ กรุณาคัดลอกด้วยตนเองหรือเปลี่ยนไปใช้ https",
  PROFILE_PAGE_QR_CODE: "QR Code หน้าโปรไฟล์ของ {{X}}",
  E_DAYS: " วัน",
  PENDING_CLINIC_REQUESTS: "พบคำขอเกี่ยวกับคลินิกที่รอดำเนินการ",
  ARE_YOU_SURE_TO_SIGN_OUT: "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบตอนนี้?",
  APPOINTMENT_MINI: "การนัดหมาย",
  PRESCRIPTION_MINI: "ผู้ป่วยและใบสั่งยา",
  SHOW_MORE: "แสดงเพิ่มเติม",
  SHOW_LESS: "แสดงน้อยลง",
  BACK_TO_PATIENT_INFO: "กลับไปยังข้อมูลผู้ป่วย",
  ADD_POINT: "เพิ่มจุดฝังเข็ม",
  X_HAS_BEEN_ADDED: "เพิ่ม {{X}} แล้ว",
  ALL_HERBS_IN_X_HAS_ADDED: "เพิ่มสมุนไพรทั้งหมดใน {{X}} แล้ว",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED: "อัปเดตสิทธิ์การทำงานในคลินิกแล้ว",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED_DESCRIPTION:
    "สิทธิ์การเข้าถึงของคุณในคลินิกปัจจุบันได้รับการอัปเดตแล้ว",
  UR_CLINIC_ROLE_PERMISSION_CHANGED: "สิทธิ์ของคุณในคลินิกนี้มีการเปลี่ยนแปลง",
  UR_CLINIC_ROLE_PERMISSION_CHANGED_DESCRIPTION:
    "บทบาท/สิทธิ์ของคุณในคลินิกปัจจุบันมีการเปลี่ยนแปลง โปรดดูรายละเอียดด้านล่าง",
  PERMISSION_DIFF_VS_BEFORE_HINT: "แสดงความแตกต่างของสิทธิ์ของคุณเทียบกับก่อนการเปลี่ยนแปลง",
  PERMISSION_CHANGE_AUTO_REFRESH_HINT: "ระบบจะรีเฟรชหน้านี้โดยอัตโนมัติใน 3 วินาที",
  GOT_IT: "เข้าใจแล้ว",
  CONFIGURE_U_WORKTIME:
    "ตั้งค่าเวลาทำงานของคุณ Healthnex จะสร้างช่วงเวลานัดหมายโดยอัตโนมัติตามเวลาทำงานที่คุณกำหนด",
  MANAGE_UR_APPOINTMENTS:
    "คุณสามารถจัดการการนัดหมายภายในระบบได้ ผู้ป่วยภายนอกก็สามารถจองนัดหมายผ่านเว็บไซต์ Healthnex หรือหน้าโปรไฟล์ส่วนตัวของคุณได้ (หากเปิดใช้งานฟีเจอร์นี้)",
  PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION:
    "คุณสามารถจัดการข้อมูลผู้ป่วยและบันทึกการรักษาของคลินิก และออกใบสั่งยาให้ผู้ป่วยของคุณได้",
  AI_FUNCTION:
    "คุณสามารถใช้ประโยชน์จากผู้ช่วย AI เช่น การแปลข้อมูลและการสรุปกระบวนการตรวจรักษาของคุณ",
  U_CAN_EASILY_CUSTOMISED_PUBLISH_YOUR_PERSONAL_WEBSITE_TO_THE_PUBLIC:
    "คุณสามารถปรับแต่งเว็บไซต์ส่วนตัวได้อย่างหลากหลายและเผยแพร่สู่สาธารณะ เพื่อเพิ่มการมองเห็นและเข้าถึงผู้คนได้กว้างขึ้น  ",
  UR_CLINIC_HAS_REMOVED_PACKAGE_FROM_U:
    "คลินิกของคุณได้นำแพ็กเกจของคุณออกแล้ว หากไม่ตรงกับที่คุณคาดหวัง กรุณาติดต่อเจ้าของคลินิก",
  IF_UNEXPECTED_PLS_CONTACT_THE_CLINIC_OWNER:
    "หากเหตุการณ์นี้เกิดขึ้นโดยไม่คาดคิด กรุณาติดต่อเจ้าของคลินิก",
  NEW_VERSION_AVAILABLE: "มีเวอร์ชันใหม่พร้อมใช้งาน",
  NEW_VERSION_DESCRIPTION:
    "มีเวอร์ชันที่ปรับปรุงแล้วของ Healthnex พร้อมใช้งาน กรุณาคลิกปุ่มด้านล่างเพื่อรีเฟรชหน้าและทำการอัปเกรดให้เสร็จสมบูรณ์",
  REFRESH_AND_UPGRADE: "รีเฟรชและอัปเกรด",
  SYSTEM_REDIRECTING: "ระบบกำลังเปลี่ยนเส้นทาง",
  SWITCHING_CLINIC: "กำลังเปลี่ยนคลินิก",
  UPDATING_PROFILE: "กำลังอัปเดตโปรไฟล์",
  UPLOADING_AVATAR: "อัปโหลดรูปโปรไฟล์",
  UPDATING_PASSWORD: "กำลังอัปเดตรหัสผ่าน",
  CURRENT_PASSWORD: "รหัสผ่านปัจจุบัน",
  DASHBOARD: "แดชบอร์ด",
};

const prescription = {
  CLEAR_SEARCH: "ล้าง",
  PRESCRIPTION: "บันทึกการรักษา",
  PATIENT_PRESCRIPTION: "บันทึกการรักษาของผู้ป่วย",
  DOCTOR_PRESCRIPTION: "ใบสั่งยาของแพทย์",
  NO_PRESCRIPTION_FOUND: "ไม่พบใบสั่งยา",
  NO_PREVIOUS_HISTORY: "ไม่มีบันทึกก่อนหน้า",
  PRESCRIPTION_NOT_FOUND: "ไม่พบใบสั่งยา",
  "EDIT_NOW_HISTORY_#X": "กำลังแก้ไขบันทึกการรักษา #{{X}}",
  EDITING_NOW: "กำลังแก้ไข",
  NO_ENGLISH_ENTRY: "ไม่มีข้อมูลภาษาอังกฤษ",
  NO_CHINESE_ENTRY: "ไม่มีข้อมูลภาษาจีน",
  ENGLISH_CONTENT: "เนื้อหาภาษาอังกฤษ",
  CHINESE_CONTENT: "เนื้อหาภาษาจีน",
  CASE_ID: "รหัสเคส",
  DATE: "วันที่",
  CREATED_BY: "สร้างโดย",
  PAYMENT_STATUS: "สถานะการชำระเงิน",
  ACTION: "การดำเนินการ",
  NOT_PAID: "ยังไม่ชำระเงิน",
  PAID: "ชำระเงินแล้ว",
  CARD_ONLINE: "บัตรออนไลน์",
  CARD_OFFLINE: "บัตรออฟไลน์",
  CASH: "เงินสด",
  HICAPS: "HICAPS",
  CONNECTING_TO_HICAPS_TERMINAL: "กำลังเชื่อมต่อกับเครื่อง HICAPS...",
  HICAPS_TERMINAL_CONNECTED: "เชื่อมต่อกับเครื่อง HICAPS แล้ว",
  HICAPS_TERMINAL_CONNECTION_FAILED: "เชื่อมต่อกับเครื่อง HICAPS ไม่สำเร็จ",
  RETRY: "ลองอีกครั้ง",
  RESUBMIT: "ส่งใหม่อีกครั้ง",
  SUBMITTING: "กำลังส่ง...",
  HICAPS_TERMINAL_SERVER_NOT_CONFIGURED: "คลินิกนี้ยังไม่ได้ตั้งค่าที่อยู่เซิร์ฟเวอร์ของเครื่อง HICAPS กรุณาติดต่อผู้ดูแลระบบ",
  HICAPS_CHARGE_NOT_SUBMITTED_TITLE: "เรียกเก็บเงินแล้วแต่ยังไม่ได้บันทึก",
  HICAPS_CHARGE_NOT_SUBMITTED_DESCRIPTION: "เครื่อง HICAPS เรียกเก็บเงินจำนวนนี้ไปแล้ว แต่การบันทึกลงระบบล้มเหลว กดส่งใหม่อีกครั้งเพื่อบันทึกให้เสร็จสมบูรณ์ — จะไม่มีการเรียกเก็บเงินซ้ำ",
  CONFIRM_REFUND_TITLE: "ยืนยันการคืนเงินผ่าน HICAPS หรือไม่?",
  CONFIRM_REFUND_DESCRIPTION: "การดำเนินการนี้จะรีเซ็ตบันทึกกลับไปเป็นสถานะยังไม่ชำระเงิน รายการต่อไปนี้จะถูกคืนเงิน:",
  CONFIRM_REFUND_ITEM_REBATE: "การเคลมกองทุนสุขภาพจะถูกยกเลิก",
  CONFIRM_REFUND_ITEM_BALANCE: "ยอดชำระคงเหลือจะถูกคืนเงิน",
  CONFIRM_REFUND: "ยืนยันการคืนเงิน",
  CONFIRM_REFUND_SCOPE_FULL: "คืนเงินทั้งหมด",
  CONFIRM_REFUND_SCOPE_FULL_DESCRIPTION: "ยกเลิกการเคลมกองทุนสุขภาพและคืนยอดชำระคงเหลือ",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY: "คืนเฉพาะยอดคงเหลือ",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY_DESCRIPTION: "คืนเฉพาะยอดชำระคงเหลือเท่านั้น — การเคลมกองทุนสุขภาพจะยังคงเดิม",
  REFUND_CLAIM_CANCEL_SUCCESS_PROCESSING_BALANCE: "ยกเลิกเคลมสำเร็จแล้ว กำลังดำเนินการคืนเงินยอดคงเหลือ...",
  HICAPS_PRICE_LOCK_WARNING: "เมื่อเลือก Hicaps แล้ว จะไม่สามารถแก้ไขราคาของบันทึกนี้ได้อีก",
  SELECT_PROVIDER: "เลือกผู้ให้บริการ",
  SEARCH_PROVIDER_NAME: "ค้นหาด้วยชื่อ",
  SELECT_MERCHANT: "เลือกร้านค้า",
  HEALTH_FUND_REBATE: "การคืนเงินกองทุนสุขภาพ",
  BALANCE_PAYMENT: "ชำระเงินคงเหลือ",
  PROCESSING_REBATE_PAYMENT: "กำลังดำเนินการคืนเงินกองทุนสุขภาพ",
  PROCESSING_BALANCE_PAYMENT: "กำลังดำเนินการชำระเงินคงเหลือ",
  PROVIDER_USED_FOR_BOTH_STEPS: "ผู้ให้บริการนี้จะถูกใช้ทั้งสำหรับการคืนเงินและการชำระเงินคงเหลือ",
  WAITING_FOR_PAYMENT: "กำลังรอการชำระเงิน",
  PLEASE_TAP_CARD_ON_TERMINAL: "กรุณาให้ผู้ป่วยแตะ เสียบ หรือรูดบัตรที่เครื่อง HICAPS ตอนนี้",
  FINALIZING_PAYMENT: "กำลังยืนยันผลการชำระเงิน",
  SAVING_INSURANCE_RECORD: "กำลังบันทึกข้อมูลการคืนเงิน",
  HICAPS_ZERO_AMOUNT_HINT: "ไม่สามารถเลือก HICAPS ได้เมื่อจำนวนเงินเป็น $0",
  HICAPS_PAYMENT_LOCKED_TITLE: "ชำระเงินผ่าน HICAPS แล้ว",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION: "บันทึกนี้ชำระเงินผ่านเครื่อง HICAPS แล้ว จึงไม่สามารถแก้ไขราคาได้อีก หากต้องการแก้ไข กรุณาขอคืนเงินก่อน เมื่อคืนเงินสำเร็จ บันทึกนี้จะกลับไปเป็นสถานะยังไม่ชำระเงิน",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION_SHORT: "ชำระผ่าน HICAPS แล้ว — ขอคืนเงินเพื่อแก้ไขราคาอีกครั้ง",
  COMPLETE: "เสร็จสิ้น",
  REFUND: "ขอคืนเงิน",
  UNPAID: "ยังไม่ชำระเงิน",
  MARK_AS_PAID: "ทำเครื่องหมายว่าชำระแล้ว",
  MARK_REBATE_AS_PAID: "ทำเครื่องหมายเงินคืนว่าชำระแล้ว",
  MARK_REBATE_AS_PAID_WARNING: "การดำเนินการนี้จะอัปเดตสถานะการชำระเงิน HICAPS ของเงินคืนนี้เป็นชำระแล้ว ใช้เฉพาะเมื่อการชำระเงินผ่าน HICAPS เสร็จสมบูรณ์บนเครื่องจริงแล้ว แต่ระบบไม่ได้แสดงว่าชำระแล้วเท่านั้น",
  HICAPS_PAY_IN_FULL: "ชำระเต็มจำนวนผ่าน HICAPS",
  HICAPS_PAY_PARTIAL: "แบ่งชำระด้วยวิธีอื่น",
  HICAPS_AMOUNT_TO_PAY: "จำนวนที่ชำระผ่าน HICAPS",
  HICAPS_PARTIAL_AMOUNT_MUST_BE_LESS_THAN_BALANCE: "ต้องมากกว่า $0 และน้อยกว่ายอดคงเหลือทั้งหมด",
  REMAINING_AMOUNT_X: "ยอดที่เหลือ ${{X}} จะถูกเรียกเก็บแยกต่างหาก",
  CONNECT_HICAPS_TERMINAL: "เชื่อมต่อเครื่อง HICAPS",
  REFUND_STEP_REBATE: "กำลังยกเลิกคำขอเบิกเงินคืน",
  REFUND_STEP_BALANCE: "กำลังคืนเงินยอดคงเหลือ",
  REFUND_STEP_ROLLBACK: "กำลังอัปเดตสถานะการชำระเงินของบันทึก",
  REFUND_STEP_REBATE_ROLLBACK: "กำลังอัปเดตสถานะการชำระเงินของเคลม",
  REFUND_STEP_REBATE_ROLLBACK_SHORT: "สถานะเคลม",
  REFUND_STEP_REBATE_SHORT: "ยกเลิกเคลม",
  REFUND_STEP_BALANCE_SHORT: "คืนเงินยอดคงเหลือ",
  REFUND_STEP_ROLLBACK_SHORT: "อัปเดตสถานะ",
  REFUND_SUCCESSFUL: "คืนเงินสำเร็จ",
  REFUND_FAILED: "คืนเงินไม่สำเร็จ กรุณาลองใหม่",
  PROCESSING_WITH_HICAPS_TERMINAL: "กำลังดำเนินการผ่านเครื่อง HICAPS...",
  HICAPS_TRANSACTION_SUCCESSFUL: "ทำรายการ HICAPS สำเร็จ",
  HICAPS_TRANSACTION_FAILED: "ทำรายการ HICAPS ไม่สำเร็จ กรุณาลองอีกครั้ง",
  HICAPS_REBATE_COMPLETED: "ดำเนินการคืนเงินผ่าน HICAPS เรียบร้อยแล้ว",
  FILTER_BY_DATE: "กรองตามวันที่",
  SELECT_DEFAULT_DATE_RANGE: "เลือกช่วงวันที่เริ่มต้น",
  SELECT_CUSTOM_DATE_RANGE: "เลือกช่วงวันที่กำหนดเอง",
  LAST_ONE_YEAR: "1 ปีที่ผ่านมา",
  LAST_ONE_MONTH: "1 เดือนที่ผ่านมา",
  LAST_THREE_MONTHS: "3 เดือนที่ผ่านมา",
  ROWS_PER_PAGE: "จำนวนแถวต่อหน้า",
  MORE_INFORMATION: "ข้อมูลเพิ่มเติม",
  AGE: "อายุ",
  PRESCRIPTION_FORM: "แบบฟอร์มใบสั่งยา",
  CREATE_CASE: "สร้างเคส",
  CREATE_CASE_FAILED: "ไม่สามารถสร้างเคสได้ กรุณาลองใหม่อีกครั้ง",
  SELECT_OPTIONS: "เลือกตัวเลือก",
  CLICK_TO_RECORD: "คลิกเพื่อบันทึกเสียง",
  PRESS_TO_RECORD: "กดเพื่อบันทึกเสียง",
  TRANSLATE_TO_X: "แปลเป็น {{X}}",
  COMPLAINTS_SYMPTOMS: "อาการที่มาพบแพทย์",
  PAST_DISEASE: "ประวัติการเจ็บป่วย",
  FAMILY_DISEASE_HISTORY: "ประวัติการเจ็บป่วยในครอบครัว",
  ALLERGY: "การแพ้",
  ALLERGEN: "สารก่อภูมิแพ้",
  CURRENT_MEDICINE_TAKEN: "ยาที่ใช้อยู่ปัจจุบัน",
  SIGNS_DIAGNOSIS: "อาการแสดงและการวินิจฉัย",
  ATTACHMENT: "ไฟล์แนบ",
  REMARKS: "หมายเหตุ",
  CLICK_DRAG_TO_UPLOAD: "คลิกหรือลากเพื่ออัปโหลด",
  NO_ATTACHMENT_FOUND: "ยังไม่มีไฟล์แนบ",
  TREATMENT_PLAN: "แผนการรักษา",
  PATIENT_ADVICES: "คำแนะนำสำหรับผู้ป่วย",
  PROCEED_TO_PAYMENT: "ดำเนินการชำระเงิน",
  PROCEED_TO_TREATMENT: "ดำเนินการรักษา",
  MEDICINE: "ยา",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "สั่งยาให้ผู้ป่วย",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT:
    "ให้การรักษาด้วยการฝังเข็มแก่ผู้ป่วย",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "ให้การรักษาด้วยการนวดแก่ผู้ป่วย",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT:
    "ให้การรักษาด้วยการนวดบำบัดแก่ผู้ป่วย",
  SELECT: "เลือก",
  MODALITY: "ประเภทการรักษา",
  MEDICINE_TREATMENT_NAME: "ชื่อการรักษาด้วยยา",
  PREVIOUS_STEP: "ขั้นตอนก่อนหน้า",
  PATIENT_HERB_HISTORY: "ประวัติการใช้สมุนไพรของผู้ป่วย",
  APPLY: "นำไปใช้",
  HERB: "สมุนไพร",
  RAW: "ยาต้ม (ก.)",
  GRAN: "ยาสกัด (ก.)",
  TOTAL: "รวม",
  FORMULA: "ตำรับยา",
  CLASSICAL: "ตำรับสมุนไพร",
  SINGLE_HERB: "สมุนไพรเดี่ยว",
  TYPE: "ประเภท",
  SELECT_HERBS: "เลือกสมุนไพร",
  SEARCH_CLASSICAL_FORMULA: "ค้นหาตำรับสมุนไพร",
  PLEASE_SEARCH_BY_NAME: "กรุณาค้นหาด้วยชื่อ",
  CANCEL_SEARCH: "ยกเลิกการค้นหา",
  ADD_ALL_HERBS_IN_FORMULA: "เพิ่มสมุนไพรทั้งหมดในตำรับ",
  X_HERBS_INCLUDED: "มีสมุนไพร {{X}} ชนิด",
  FILL_IN_THE_DOSAGE: "กรอกขนาดยา",
  HERBS_ADDED: "เพิ่มสมุนไพรแล้ว",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA:
    "กรุณาเลือกสมุนไพรจากประวัติหรือตำรับยา",
  GRAMS_DAILY: "ยาสกัด",
  DAILY_TOTAL: "ยอดรวมรายวัน",
  DAYS: "วัน",
  TOTAL_GRANS: "ยาสกัดทั้งหมด",
  TOTAL_RAW: "ยาต้มทั้งหมด",
  DAILY_GRANS: "ยาสกัดต่อวัน",
  DAILY_RAW: "ยาต้มต่อวัน",
  DOSAGE_INSTRUCTION: "คำแนะนำการรักษา",
  DOSAGE: "ขนาดยา",
  NO_OF_REPEATS: "ความถี่ในการใช้ยา (วัน)",
  DOSAGE_DAYS: "จำนวนวัน",
  TO_BE_DISPENSED_AFTER: "จ่ายยาหลังจาก",
  WEEK: "สัปดาห์",
  RAW_HERBS: "ยาต้ม",
  HERBS_EXTRACT: "ยาสกัดสมุนไพร",
  HERBAL_MEDICATION: "ยาสมุนไพรจีน",
  EXTERNAL: "ใช้ภายนอก",
  HERB_BOIL_GUIDE: "คู่มือการต้มยา",
  SECOND_BOIL_REQUIRED: "ต้องต้มครั้งที่สอง",
  FIRST_BOILS: "การต้มครั้งแรก",
  NO_CUP_WATER: "จำนวนถ้วยน้ำ",
  BOIL_TIME: "เวลาต้ม",
  NO_CUPS_REMAINS: "จำนวนถ้วยที่เหลือ",
  MIN_BOIL_TIME: "เวลาต้มขั้นต่ำ (นาที)",
  PLEASE_ENTER_NUMBER: "กรุณากรอกตัวเลข",
  SELECT_POINT: "เลือกจุดฝังเข็ม",
  X_HISTORY: "ประวัติ {{X}}",
  POINT: "จุดฝังเข็ม",
  X_GROUP: "กลุ่ม {{X}}",
  POINT_GROUPS: "กลุ่มจุดฝังเข็ม",
  ORDER: "ลำดับ",
  SINGLE_POINT: "จุดเดี่ยว",
  REVIEW_THE_POINTS: "ตรวจสอบจุดฝังเข็ม",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP:
    "กรุณาเลือกจุดฝังเข็มจากประวัติหรือกลุ่ม",
  DROP_HERE: "วางที่นี่",
  X_INSTRUCTION: "คำแนะนำ {{X}}",
  DURATION: "ระยะเวลา",
  PLS_ENTER_THE_DURATION: "กรุณากรอกระยะเวลา",
  PRECAUTION: "ข้อควรระวัง / หมายเหตุ / คำแนะนำทางการแพทย์",
  FILL_IN_PRECAUTION: "กรอกข้อควรระวัง / หมายเหตุ / คำแนะนำ",
  MAS_TECHNIQUE: "เทคนิค",
  PLS_ENTER_THE_PRECAUTION: "กรุณากรอกข้อควรระวัง / หมายเหตุ / คำแนะนำทางการแพทย์",
  POINTS_ADDED: "เพิ่มจุดฝังเข็มแล้ว",
  VIEW_COPIED_POINTS: "ดูจุดที่เพิ่มจากประวัติครั้งก่อน",
  VIEW_COPIED_HERBS: "ดูสมุนไพรที่เพิ่มจากประวัติครั้งก่อน",
  HERB_RAW_SHORT: "ตัวยา",
  HERB_GRAN_SHORT: "เกรน",
  PAYMENT: "การชำระเงิน",
  FILL_IN_THE_PAYMENT_DETAILS: "กรอกรายละเอียดการชำระเงิน",
  SUBTOTAL: "ยอดรวมย่อย",
  OTHER_FEE: "ค่าธรรมเนียมอื่น ๆ",
  DIAGNOSIS_FEE: "ค่ารักษา",
  DISCOUNT_FEE: "ส่วนลด",
  FEE: "ค่าธรรมเนียม",
  TOTAL_AMOUNTS: "ยอดรวมทั้งหมด",
  CASH_OR_CARD_OFFLINE_AMOUNT: "จำนวนเงินสด / บัตรออฟไลน์",
  INITIAL_VISIT: "การมาพบครั้งแรก",
  FOLLOW_UP: "การติดตามผล",
  ADD_FEE: "เพิ่มค่าธรรมเนียม",
  FEE_LABEL: "ชื่อค่าธรรมเนียม",
  PLEASE_ENTER_LABEL: "กรุณากรอกชื่อ",
  FEE_AMOUNT: "จำนวนค่าธรรมเนียม",
  PLEASE_ENTER_AMOUNT: "กรุณากรอกจำนวนเงิน",
  FEE_LABEL_ALREADY_EXISTS: "มีค่าธรรมเนียมชื่อนี้อยู่แล้ว",
  FEE_AMOUNT_MUST_BE_POSITIVE: "จำนวนเงินต้องไม่ติดลบ",
  MEDICAL_REBATE: "เงินคืนจากประกัน",
  MEDICAL_FUNDS_OF_PATIENT: "ใช้กองทุนสุขภาพของผู้ป่วย",
  REBATE_AMOUNT: "จำนวนเงินคืนจากประกัน",
  ANY_DISCOUNT: "ส่วนลด (ถ้ามี)",
  PENDING_PAYMENT_AMOUNT: "จำนวนเงินที่ค้างชำระ",
  PAYMENT_METHOD: "วิธีการชำระเงิน",
  DISCOUNT_AMOUNT: "จำนวนส่วนลด",
  FINISH_PAYMENT: "เสร็จสิ้นการชำระเงิน",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "กรุณากรอกรายละเอียดบัตรด้านล่างเพื่อทำการชำระเงินให้เสร็จสมบูรณ์",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "การชำระเงินล้มเหลว กรุณาลองใหม่อีกครั้ง",
  X_TRIES_LEFT: "เหลืออีก {{X}} ครั้ง",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "ยอดรวมต้องไม่ติดลบ",
  PAY_NOW: "ชำระเงินตอนนี้",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED:
    "ดำเนินการชำระเงินของคุณสำเร็จแล้ว",
  SYSTEM_REDICTING: "ระบบกำลังเปลี่ยนเส้นทาง...",
  SURCHARGE_WILL_BE_INCLUDED: "รวมค่าธรรมเนียมเพิ่มเติม",
  PROCESSING_PAYMENT: "กำลังดำเนินการชำระเงิน",
  LAST_MODIFIED_AT: "เข้าถึงล่าสุดเมื่อ",
  PAY: "ชำระเงิน",
  NEXT: "ถัดไป",
  PRINT_RECEIPT: "ดาวน์โหลดใบเสร็จ",
  SEND_RECEIPT_TO_PATIENT: "ส่งใบเสร็จให้ผู้ป่วย",
  SEND_TO_PATIENT_VIA_EMAIL_WITH_RECEIPT_ATTACHED:
    "ส่งใบเรียกเก็บเงินไปยังอีเมลของผู้ป่วยทางอีเมล",
  PATIENT_EMAIL: "ที่อยู่อีเมลของผู้ป่วย",
  RECIPIENT_EMAIL: "อีเมลผู้รับ",
  EMAIL_SENT_TO_X: "ส่งอีเมลไปยัง: {{X}}",
  SEND: "ส่ง",
  SENDING_EMAIL: "กำลังส่งอีเมล",
  PRINT_MEDICAL_RECORD: "ดาวน์โหลดเวชระเบียน",
  GENERATING: "กำลังสร้าง",
  NO_MEDICAL_HISTORY_FOUND: "ยังไม่ได้กรอกบันทึกการรักษา",
  NO_TREATMENTS_INCLUDED: "ไม่มีการรักษารวมอยู่",
  TREATMENT: "การรักษา",
  TREATMENTS: "การรักษา",
  VIEW_X_INSTRUCTION: "ดูคำแนะนำ {{X}}",
  X_SURCHARGE_AMOUNT: "จำนวนค่าธรรมเนียมเพิ่มเติม {{X}}",
  DISCOUNT: "ส่วนลด",
  COLLAPSE_ALL: "ยุบทั้งหมด",
  EXPAND_ALL: "ขยายทั้งหมด",
  VIEW_DOSAGE_INSTRUCTION: "ดูคำแนะนำการใช้ยา",
  FINISH: "สรุป",
  X_OPTIONS: "{{X}} ตัวเลือก",
  FULL_CONTENT_MODE: "โหมดง่าย",
  HAS_BEEN_ADDED: " ถูกเพิ่มแล้ว",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "เพิ่มสมุนไพรทั้งหมดในตำรับแล้ว",
  CLASSICAL_FORMULA: "ตำรับสมุนไพร",
  PLS_ENTER_NUMBER: "กรุณากรอกตัวเลข",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "ค้นหาตำรับยาด้วยชื่อ",
  SEARCH_CLASSICAL_FORMULA_HERB_BY_NAME:
    "ค้นหาตำรับสมุนไพรและสมุนไพรด้วยชื่อ",
  SEARCH_HERB_BY_NAME: "ค้นหาสมุนไพรด้วยชื่อ",
  REMOVE_TREATMENT: "ลบการรักษา",
  ARE_YOU_SURE_TO_REMOVE: "คุณแน่ใจหรือไม่ว่าต้องการลบ",
  SECOND_BOILS: "การต้มครั้งที่สอง",
  MIN_BOILING: "นาทีในการต้ม",
  X_POINTS_INCLUDED: "มีจุดฝังเข็ม {{X}} จุด",
  ADD_ALL_POINTS_IN_FORMULA: "เพิ่มจุดทั้งหมดในกลุ่ม",
  SEARCH_POINT_GROUPS_BY_NAME: "ค้นหากลุ่มจุดฝังเข็มด้วยชื่อ",
  SEARCH_POINT_GROUPS_POINT_BY_NAME: "ค้นหากลุ่มจุดฝังเข็มและจุดด้วยชื่อ",
  SEARCH_POINT_BY_NAME: "ค้นหาจุดฝังเข็มด้วยชื่อ",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "เพิ่มจุดทั้งหมดในกลุ่มแล้ว",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO:
    "การรักษานี้ไม่มีราคาหรือราคาเป็นศูนย์",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE:
    "ช่องทางการชำระเงินหมดอายุแล้ว กรุณาโหลดหน้าใหม่",
  ENTER_FEE_AMOUNT: "กรอกจำนวนค่าธรรมเนียม",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION:
    "ไม่มีการรักษารวมอยู่ในใบสั่งยานี้",
  PLEASE_SELECT_TREATMENT_TO_PROCEED:
    "กรุณาเลือกประเภทการรักษาเพื่อดำเนินการต่อ",
  ADD_TREATMENT: "เพิ่มการรักษา",
  MORE: "เพิ่มเติม",
  HAS_REMOVED: " ถูกลบแล้ว",
  ATTACHMENT_UPLOADED: "อัปโหลดไฟล์แนบแล้ว",
  REMOVE_ATTACHMENT: "ลบไฟล์แนบ",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้?",
  ATTACHMENT_REMOVED: "ลบไฟล์แนบแล้ว",
  LAST_SIX_MONTHS: "6 เดือนที่ผ่านมา",
  INPUT_TOTAL_COST_HERE: "กรอกค่ารักษาที่นี่",
  EDIT_PATIENT_INFO: "แก้ไขข้อมูลผู้ป่วย",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "คุณแน่ใจหรือไม่ว่าต้องการล้างเนื้อหาทั้งหมดที่กรอกไว้ด้านล่าง?",
  CLEAR_CONFIRM: "ยืนยันการล้าง",
  DUPLICATE_MEDICAL_HISTORY: "คัดลอกบันทึก",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "คุณกำลังจะคัดลอกบันทึกการรักษาที่เลือก",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "คุณจะได้รับบันทึกการรักษาใหม่ที่มีข้อมูลกรอกไว้ล่วงหน้าเหมือนกับบันทึกที่คุณเลือก",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD:
    "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกการรักษานี้",
  PATIENT_HISTORY_COPIED: "คัดลอกประวัติผู้ป่วยแล้ว",
  DELETE_SUCCESS: "ลบสำเร็จ",
  ADD_ASSISTANT_EXAMINATION: "เพิ่มการตรวจเสริม",
  ADD_NOW: "เพิ่มตอนนี้",
  RESULT_PREVIEW: "ดูตัวอย่าง",
  EXPAND_RECORD_PREVIEW: "ขยายตัวอย่างบันทึก",
  COLLAPSE_RECORD_PREVIEW: "ยุบตัวอย่างบันทึก",
  AUXILIARY_TEST: "การตรวจเสริม",
  TEST_NAME: "ชื่อการตรวจ",
  TEST_DATE: "วันที่ตรวจ",
  ATTACHMENTS: "ไฟล์แนบ",
  SELECT_PHOTO_PDF: "เลือกรูปภาพ/PDF",
  TAKE_PHOTO_OR_SELECT_FILE: "ถ่ายรูป / เลือกไฟล์",
  EXAMINATION: "ผลการตรวจร่างกาย",
  EXAMINATION_DESCRIPTION: "คำอธิบาย",
  INSPECTION: "การมอง (การตรวจด้วยการดูแบบแพทย์แผนจีน)",
  TONGUE_PHOTO: "ภาพลิ้น",
  FACIAL_PHOTO: "ภาพใบหน้า",
  INQUIRY: "การถาม (การซักประวัติแบบแพทย์แผนจีน)",
  INQUIRY_RECORD: "บันทึกการซักประวัติ",
  PULSE: "การจับชีพจร",
  LISTEN_SMELL: "การฟังและการดมกลิ่น",
  BODY_TEMP: "อุณหภูมิร่างกาย",
  BLOOD_PRESSURE: "ความดันโลหิต",
  PULSE_RATE: "อัตราการเต้นของชีพจร",
  BREATH_RATE: "อัตราการหายใจ",
  PERSONAL_OTHER: "พฤติกรรมส่วนตัวและอื่น ๆ",
  ANY_ALLERGY: "มีอาการแพ้หรือไม่",
  IS_PREGNANT: "ตั้งครรภ์หรือไม่?",
  ALLERGY_DRUGS: "การแพ้ยา",
  ALLERGY_TRIGGERS: "สิ่งกระตุ้นการแพ้",
  STD: "ประวัติโรคติดต่อทางเพศสัมพันธ์",
  PROMISCUITY: "การมีคู่นอนหลายคน",
  SMOKING: "การสูบบุหรี่",
  ALCOHOL_ABUSE: "การดื่มสุรามากเกินไป",
  ADD_HISTORY: "เพิ่มประวัติการเจ็บป่วย",
  NO_DISEASES: "ไม่มีประวัติการเจ็บป่วย",
  FAMILY_DISEASES: "ประวัติการเจ็บป่วยในครอบครัว",
  SYMPTOMS: "อาการ",
  NO_SYMPTOMS_ADDED: "ยังไม่ได้เพิ่มอาการ",
  MAIN_SYMPTOM: "อาการหลัก",
  SYMPTOM_DESCRIPTION: "คำอธิบายอาการ",
  ONSITE_TIME: "เวลาที่เริ่มมีอาการ",
  TIME_UNIT: "หน่วยเวลา",
  RECURRENCE_TIME: "เวลาที่อาการกลับมาเป็นซ้ำ",
  EXACERBATION_TIME: "เวลาที่อาการกำเริบ",
  FREQUENCY_OF_OCCURRENCE: "ความถี่ในการเกิดอาการ",
  FREQUENCY: "ความถี่",
  ADD_MAIN_SYMPTOMS: "เพิ่มอาการหลัก",
  PREDISPOSITION: "ปัจจัยโน้มนำ",
  ASSOCIATED_SYMPTOMS: "อาการร่วม",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "คุณแน่ใจหรือไม่ว่าต้องการลบอาการนี้?",
  ADD_PAST_DISEASE: "เพิ่มประวัติการเจ็บป่วย",
  OTHERS: "อื่น ๆ",
  PROCEED_TO_DIAGNOSIS: "ดำเนินการวินิจฉัย",
  UPDATE_SUCCESS: "บันทึกสำเร็จ",
  PREVIOUS_TREATMENT: "คำอธิบายอาการ",
  ASSISTANT_EXAMINATION: "การตรวจเสริม",
  CLICK_TO_ADD: "คลิกเพื่อค้นหาและเพิ่ม",
  CLICK_TO_SELECT: "คลิกเพื่อค้นหาและเลือก",
  PREVIOUS_HISTORY: "บันทึกการรักษาก่อนหน้า",
  PAST_DISEASE_DESCRIPTION: "คำอธิบาย",
  ADD_EVALUATION: "เพิ่มการประเมิน",
  TCM_ICD_CODE: "รหัส ICD แพทย์แผนจีน",
  DETERMINATION_TCM: "ชื่อการวินิจฉัยแพทย์แผนจีน",
  SYNDROME: "ชื่อกลุ่มอาการแพทย์แผนจีน",
  EVALUATION: "การวินิจฉัย",
  DISCIPLINE_TREATMENT_OPTIONS: "หลักการและวิธีการรักษา",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกนี้?",
  BPM: "ต่อนาที",
  SYSTOLIC: "ความดันตัวบน",
  DIASTOLIC: "ความดันตัวล่าง",
  ADD_NEW_INSURANCE: "เพิ่มกองทุนสุขภาพ",
  PLZ_INPUT_INSURANCE_NO: "กรุณากรอกหมายเลขสมาชิก",
  PLZ_INPUT_COMPANY_NAME: "กรุณากรอกชื่อบริษัทประกัน",
  RESULT: "ผลลัพธ์",
  VIEW_HISTORY: "ดูประวัติก่อนหน้า",
  COLLAPSE_HISTORY: "ยุบประวัติ",
  COLLAPSE_INSTRUCTION: "ยุบคำแนะนำ",
  SHOW_DOSAGE_INSTRUCTION: "แก้ไขคำแนะนำการใช้ยา",
  IT_LOOKS_LIKE_PATIENT_HAS_NOT_BEEN_CONSENTED_WITH_AGREEMENT_WITH_US:
    "ดูเหมือนว่าผู้ป่วยยังไม่ได้ให้ความยินยอมตามข้อตกลงกับเรา",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM:
    "กรุณาให้ผู้ป่วยสแกน QR Code ด้านล่างเพื่อกรอกแบบฟอร์มความยินยอมก่อนเริ่มกระบวนการสั่งยา",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM_SHORT:
    "ผู้ป่วยสามารถสแกน QR Code ด้านล่างเพื่อกรอกแบบฟอร์มความยินยอมได้",
  SIGN_CONSENT_FORM: "ลงนามแบบฟอร์มความยินยอมของผู้ป่วย",
  SIGNATURE_DATE: "วันที่ลงนาม",
  PATIENT_FIRST_VISIT_ON: "ผู้ป่วยมาตรวจครั้งแรกเมื่อ",
  APPLY_DATE: "นำไปใช้",
  THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT:
    "ผู้ป่วยรายนี้ยังไม่ได้ลงนามแบบฟอร์มความยินยอม แต่คุณยังสามารถดำเนินการบันทึกการรักษาต่อได้",
  PLEASE_CLICK_BUTTON_BELOW_AND_ASK_PATIENT_TO_SIGN_THE_CONSENT_FORM:
    "กรุณาคลิกปุ่มด้านล่างและขอให้ผู้ป่วยลงนามแบบฟอร์มความยินยอม",
  CLICK_HERE_TO_SIGN_CONSENT: "คลิกที่นี่เพื่อลงนามแบบฟอร์มความยินยอม",
  SIGN_NOW: "ลงนามตอนนี้",
  DOWNLOAD_EMPTY_CONSENT_FORM: "พิมพ์แบบฟอร์มความยินยอมเปล่า",
  CONSENT_FORM_UPLOADED: "อัปโหลดแบบฟอร์มความยินยอมของผู้ป่วยแล้ว",
  VIEW_CONSENT_FORM: "ดูความยินยอมของผู้ป่วย",
  UPLOAD_CONSENT_FORM: "อัปโหลดความยินยอมของผู้ป่วย",
  REUPLOAD_CONSENT_FORM: "อัปโหลดความยินยอมใหม่",
  UPLOADING: "กำลังอัปโหลด",
  UPLOAD: "อัปโหลด",
  IMPORTANT: "ยังไม่ได้สังกัดคลินิกใด",
  X_TREATMENT_NAME: "ชื่อการรักษา {{X}}",
  RECENT_PRESCRIPTIONS: "ใบสั่งยาล่าสุด",
  EDITED_IN: "แก้ไขใน: ",
  PHOTOS_AND_VIDEOS: "รูปภาพและวิดีโอ",
  GENERATING_CONSENT_FORM: "กำลังสร้างแบบฟอร์มความยินยอม",
  CANCELLED: "ยกเลิกแล้ว",
  MORE_INFO_PLS_CHECK_MEDICAL_HISTORY_USING_DESKTOP:
    "รายละเอียดราคาบางส่วนถูกแก้ไขในเวอร์ชันที่เวอร์ชันไลต์ไม่รองรับ กรุณาใช้เวอร์ชันเดสก์ท็อปเพื่อดูรายละเอียดทั้งหมด",
  UPDATING_PRICE: "กำลังอัปเดตราคา... กรุณาลองใหม่อีกครั้ง",
  EDIT_PRESCRIPTION: "แก้ไขใบสั่งยา",
  DIAGNOSIS_DATE: "วันที่วินิจฉัย",
  EDIT_DIAGNOSIS_DATE: "แก้ไขวันที่วินิจฉัย",
  CHANGE_DIAGNOSIS_DATE_TO: "เปลี่ยนวันที่วินิจฉัยเป็น",
  PAID_AT: "ชำระเงินเมื่อ",
  PRESCRIPTION_DATE_UPDATED: "อัปเดตวันที่วินิจฉัยแล้ว",
  PAIN_LEVEL: "ระดับความเจ็บปวด",
  PAIN_TYPE: "ประเภทความเจ็บปวด",
  CLICK_TO_TOGGLE_IMG: "คลิกเพื่อสลับภาพ",
  CLICK_TO_TOGGLE_X: "คลิกเพื่อสลับภาพเป็น {{X}}",
  IMG_FRONT: "ด้านหน้า",
  IMG_BACK: "ด้านหลัง",
  DEFAULT_SCALE: "รีเซ็ตขนาด",
  LOADING_IMG: "กำลังโหลดภาพ",
  THIS_IMAGE_HAS_DETECTED_TO_BE_OLD_CANVAS_NEW_CANVAS_WILL_BE_APPLY_IN_NEXT_UPDATE:
    "ภาพปัจจุบันถูกระบุว่าเป็นเวอร์ชันเก่า ระบบจะเปลี่ยนไปใช้ภาพล่าสุดโดยอัตโนมัติในการอัปเดตครั้งถัดไป โปรดทราบว่าตำแหน่งจุดฝังเข็มแตกต่างกันในแต่ละเวอร์ชัน และจำเป็นต้องทำเครื่องหมายใหม่หลังการอัปเดต",
  NO_IMAGE_FOUND: "ไม่พบภาพ",
  SELECTABLE_POINTS: "จุดฝังเข็ม",
  NO_OF_PACKS: "จำนวนห่อยาสมุนไพร",
  PER_DAY: "วัน",
  "DOSAGE.PER_DAY": "ต่อวัน",
  "DOSAGE.SHOW_DAILY": "แสดงขนาดยาต่อวัน",
  PACKS: "ห่อ",
  HEALTH_CONDITION_RECORD: "บันทึกภาวะสุขภาพ",
  AS_MYSELF: "ในนามตนเอง",
  ON_BEHALF_OF: "ในนามของ",
  ON_BEHALF_OF_X: "ในนามของ: {{X}}",
  ON_BEHALF_OF_OTHERS: "ในนามของผู้อื่น",
  UPLOAD_PAYMENT_DOC: "อัปโหลดเอกสารการชำระเงิน",
  PAYMENT_FILES: "ไฟล์การชำระเงิน",
  SELECTED_HISTORY: "บันทึกประวัติที่เลือก",
  PATIENT_NOT_FOUND: "ไม่พบผู้ป่วยในคลินิกนี้",
  NEW_PATIENT_RECORD: "ใบสั่งยาสำหรับผู้ป่วยใหม่",
  VIEW_EDIT: "ดู / แก้ไข",
  FIND: "ค้นหา",
  SEARCH_BY_PATIENT_NAME_MOBILE: "ค้นหาด้วยชื่อผู้ป่วย/โทรศัพท์",
  NO_BOOKINGS_FOUND: "ไม่พบการนัดหมายที่เกี่ยวข้อง",
  FILL_IN_TREATMENT_NOTE_PLAN: "กรอกบันทึกการรักษา / แผนการรักษา",
  TREATMENT_NOTE_PLAN: "บันทึกการรักษา / แผนการรักษา",
  DOWNLOAD_SELECTED_MEDICAL_RECORDS: "ดาวน์โหลดเวชระเบียนที่เลือก",
  DOWNLOAD_ALL_CURRENT_MEDICAL_RECORDS: "ดาวน์โหลดเวชระเบียนทั้งหมด",
  DOWNLOAD_ALL_CONSENT_FORMS: "ดาวน์โหลดแบบฟอร์มยินยอมทั้งหมดของผู้ป่วย",
  ARE_YOU_SURE_TO_DOWNLOAD_SELECTED_MEDICAL_RECORDS: "คุณแน่ใจหรือไม่ว่าต้องการดาวน์โหลดเวชระเบียนที่เลือก?",
  ARE_YOU_SURE_TO_DOWNLOAD_ALL_MEDICAL_RECORDS: "คุณแน่ใจหรือไม่ว่าต้องการดาวน์โหลดเวชระเบียนทั้งหมด?",
  UNPAID_MEDICAL_RECORDS_WILL_NOT_BE_DOWNLOADED: "เวชระเบียนที่ยังชำระเงินไม่เสร็จจะไม่ถูกรวมอยู่ในการดาวน์โหลด",
  DATE_RANGE: "ช่วงวันที่",
  NUMBER_OF_RECORDS: "จำนวนเวชระเบียน",
  ENTER_PRESCRIPTION_NAME: "กรอกชื่อใบสั่งยา",
  QUICK_SELECT: "เลือกอย่างรวดเร็ว",
  SELECT_FROM_BODY_PART: "เลือกจากแผนภาพร่างกาย",
  ADD_EDIT_METHOD_FROM_BODY_PART: "แก้ไขเทคนิคตามส่วนของร่างกาย",
  EDIT_METHOD: "แก้ไขเทคนิค",
  NO_BODY_PART_HAS_BEEN_SELECTED: "ยังไม่มีการเลือกส่วนของร่างกายในขั้นตอนก่อนหน้า",
  GO_AND_EDIT_BODY_PART: "ไปที่แผนภาพร่างกายเพื่อเลือก",
  CLICK_POINT_ON_IMAGE_TO_SELECT_METHOD: "แตะวงกลมเพื่อเพิ่มเทคนิคให้กับส่วนนั้นของร่างกาย",
  BACK_TO_TREATMENT: "กลับไปยังการรักษา",
  CLICK_POINT_ON_IMAGE_FROM_LEFT_TO_SELECT_METHOD: "คลิกบริเวณร่างกายในรูปภาพด้านซ้ายเพื่อเลือกเทคนิค",
};

const search = {
  SEARCH: "ค้นหา",
  SEARCH_PLACEHOLDER: "ค้นหา",
  SEARCH_RESULT: "ผลการค้นหา",
  NO_SEARCH_RESULT: "ไม่มีผลการค้นหา",
  SEARCHING: "กำลังค้นหา",
  SEARCH_PATIENT: "ค้นหาผู้ป่วยด้วยชื่อ/อีเมล/โทรศัพท์",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "ค้นหาผู้ป่วยด้านล่างด้วยชื่อผู้ป่วย หรือเพิ่มผู้ป่วยใหม่โดยใช้ปุ่มทางด้านซ้าย",
  SEARCH_PATIENT_BY_NAME: "ค้นหาผู้ป่วยด้วยชื่อ/อีเมล/เบอร์โทรศัพท์/หมายเลขประกัน",
  NO_PATIENT_FOUND: "ไม่พบผู้ป่วย",
  SEARCHING_PATIENT: "กำลังค้นหาผู้ป่วย",
};

const info = {
  DOB: "วันเกิด",
  DATE_OF_BIRTH: "วันเกิด",
  SELECT_PATIENT: "เลือกผู้ป่วย",
  X_PRESCRIPTION_INFO: "ใบสั่งยาของ {{X}}",
  VIEW_DETAILS: "ดูรายละเอียด",
  "MEDICAL_HISTORY_#X": "บันทึกการรักษา #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "แก้ไขล่าสุดโดย {{X}} เมื่อ {{Y}}",
  NEW_MEDICAL_HISTORY: "บันทึกการรักษาใหม่",
  NOT_SAVED_YET: "ยังไม่ได้บันทึก",
  SAVE_HISTORY: "บันทึกประวัติ",
  PATIENT_INFO: "ข้อมูลผู้ป่วย",
  PATIENT_ID: "รหัสผู้ป่วย",
  GENDER: "เพศ",
  MALE: "ชาย",
  FEMALE: "หญิง",
  MEDICAL_HISTORY: "บันทึกการรักษา",
  APPOINTMENT: "การนัดหมาย",
  NO_HISTORY_FOUND: "ไม่พบประวัติ",
  DESCRIPTION: "คำอธิบายส่วนตัว",
  COMPLAINTS_SYMPTOMS: "อาการที่มาพบแพทย์",
  DIAGNOSIS: "การวินิจฉัย",
  TREATMENT: "การรักษา",
  ENGLISH_CONTENT_GOES_HERE: "กรอกเนื้อหาภาษาอังกฤษที่นี่",
  CN_CONTENT_GOES_HERE: "กรอกเนื้อหาภาษาจีนที่นี่",
  EDITING: "กำลังแก้ไข",
  SIGNS_DIAGNOSIS: "อาการแสดงและการวินิจฉัย",
  TREATMENT_STRATEGIES: "กลยุทธ์การรักษา",
  ACUPUNCTURE_POINTS_DURATION_METHODS:
    "จุดฝังเข็ม ระยะเวลา และวิธีการ",
  ALLERGY: "การแพ้",
  THERAPEUTICAL_MASSAGE: "การนวดบำบัด",
  GUA_SHA: "การขูดผิว (กัวซา)",
  OTHER: "อื่น ๆ",
  REMARKS: "หมายเหตุ",
  TRANSLATE_FROM_X: "แปลจาก {{X}}",
  TRANSLATE_TO_X: "แปลเป็น {{X}}",
  TRANSLATE: "แปล",
  CHINESE: "ภาษาจีน",
  ENGLISH: "ภาษาอังกฤษ",
  THAI: "ภาษาไทย",
  VIETNAMESE: "ภาษาเวียดนาม",
  X_CONTENT_GOES_HERE: "กรอกเนื้อหา{{X}}ที่นี่",
  NAME_X: "ชื่อ ({{X}})",
  TRANSLATION_CONFIRM: "ยืนยันการแปล",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "เนื้อหาที่แปลจะถูกนำไปใช้และเขียนทับเนื้อหาเดิมของคุณ",
  TRANSLATE_FROM_X_TO_Y: "แปลจาก {{X}} เป็น {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "คุณแน่ใจหรือไม่ว่าต้องการแปล",
  INFO_FILLED: "บันทึกข้อมูลแล้ว",
  NO_DATA_FOUND: "ไม่พบข้อมูล",
  FULL_CONTENT_X: "บันทึกการรักษาฉบับเต็ม: {{X}}",
  "UPDATE_HISTORY_#X": "อัปเดตบันทึกการรักษา #{{X}}",
  EDIT_DESCRIPTION: "แก้ไขคำอธิบายส่วนตัว",
  EDIT_PATIENT: "แก้ไขผู้ป่วย",
  BASIC_INFO: "ข้อมูลพื้นฐาน",
  FIRST_NAME: "ชื่อจริง",
  LAST_NAME: "นามสกุล",
  CONTACT_DETAIL: "รายละเอียดการติดต่อ",
  RESIDENTIAL_ADDRESS: "ที่อยู่ที่พักอาศัย",
  EMERGENCY_CONTACT_DETAIL: "รายละเอียดผู้ติดต่อฉุกเฉิน",
  RELATIONSHIP: "ความสัมพันธ์",
  PATIENT_DISCLOSE: "การเปิดเผยข้อมูลผู้ป่วย",
  GUARDIAN_NAME: "ชื่อผู้ปกครอง",
  GUARDIAN: "ผู้ปกครอง",
  GUARDIAN_CONTACT_NUMBER: "หมายเลขติดต่อผู้ปกครอง",
  GUARDIAN_MOBILE: "มือถือผู้ปกครอง",
  REFERRED_BY: "แนะนำโดย",
  NO_INSURANCE: "ไม่มีกองทุนสุขภาพ",
  EMERGENCY_CONTACT_PERSON: "บุคคลผู้ติดต่อฉุกเฉิน",
  EMERGENCY_CONTACT_NUMBER: "หมายเลขติดต่อฉุกเฉิน",
  INSURANCE_INFO: "ข้อมูลกองทุนสุขภาพ",
  MORE_DETAILS: "รายละเอียดเพิ่มเติม",
  INSURANCE_X: "กองทุนสุขภาพ {{X}}",
  COMPANY_NAME: "ชื่อบริษัท",
  INSURANCE_NO: "หมายเลขสมาชิก",
  EXPIRY_DATE: "วันหมดอายุ",
  ADD_INSURANCE: "เพิ่มกองทุนสุขภาพ",
  CANCEL: "ยกเลิก",
  CONFIRM: "ยืนยัน",
  SELECT_TEMPLATE: "เลือกเทมเพลตเว็บไซต์",
  ADD_TEMPLATE: "เพิ่มเทมเพลต",
  EDIT_TEMPLATE: "โหมดแก้ไข",
  PUBLISH_WEBSITE: "เผยแพร่เว็บไซต์",
  VIEW_PUBLISHED_WEB: "ดูตัวอย่างเว็บไซต์ที่เผยแพร่",
  TEMPLATE: "เทมเพลต",
  INSURANCE: "กองทุนสุขภาพ",
  EXPIRED_IN: "หมดอายุใน",
  EXIT_EDIT: "ออกจากโหมดแก้ไข",
  X_VERSION: "เวอร์ชัน {{X}}",
  MAKE_APPOINTMENT: "นัดหมาย",
  AI_TRANSLATE: "แปลด้วย AI",
  EDIT_TITLE: "แก้ไขหัวข้อ",
  EDIT_NAME: "แก้ไขชื่อ",
  EDIT_INTRODUCTION: "แก้ไขคำอธิบายโดยย่อ",
  ADD_SKILL: "เพิ่มทักษะเด่น",
  SKILL: "ทักษะ",
  AI_ENQUIRY: "สอบถาม AI",
  EDIT_AVATAR: "แก้ไขรูปโปรไฟล์",
  ADD_AVATAR: "เพิ่มรูปโปรไฟล์",
  EDIT_CLINIC: "แก้ไขคลินิก",
  MY_STRENGTHS: "จุดเด่นของฉัน",
  STANDARD_TREATMENT: "จุดเด่นของการรักษา",
  ACADEMIC: "วิชาการ",
  PATIENT_REVIEW: "รีวิวจากผู้ป่วย",
  CLINIC_INFO: "ข้อมูลคลินิก",
  EDIT_STRENGTHS: "แก้ไขจุดเด่น",
  EDIT_TREATMENT: "แก้ไขการรักษา",
  EDIT_PROFILE_TREATMENT: "แก้ไขโปรไฟล์การรักษา",
  DR_X_ARTICLE: "บทความของ {{X}}",
  COURSES: "หลักสูตร",
  ARTICLES: "บทความ",
  EDIT_COURSE: "แก้ไขหลักสูตร",
  UPLOAD_REVIEW_BG: "อัปโหลดภาพพื้นหลังรีวิว",
  EDIT_REVIEW: "แก้ไขรีวิวผู้ป่วย",
  PATIENT: "ผู้ป่วย",
  TITLE: "ตำแหน่งวิชาชีพ",
  SAVE_SUCCESS: "บันทึกสำเร็จ",
  CLINIC_NAME: "ชื่อคลินิก",
  PIN_TO_DISPLAY: "ปักหมุดเพื่อแสดง",
  DELETE: "ลบ",
  SUBURB: "เขต/ตำบล",
  POSTCODE: "รหัสไปรษณีย์",
  STATE: "รัฐ",
  ADD: "เพิ่ม",
  MOVE_DOWN: "เลื่อนลง",
  MOVE_UP: "เลื่อนขึ้น",
  SPECIALITY: "ความเชี่ยวชาญ",
  PUBLISHED: "เผยแพร่แล้ว",
  HIDDEN: "ซ่อนอยู่",
  READ: "อ่าน",
  ADD_ARTICLE: "เพิ่มบทความ",
  SAVE: "บันทึก",
  PUBLISH: "เผยแพร่",
  RE_UPLOAD_BG: "อัปโหลดภาพพื้นหลังใหม่",
  PATIENT_NAME: "ชื่อผู้ป่วย",
  PATIENT_DESCRIPTION: "คำอธิบายผู้ป่วย",
  REVIEW: "รีวิว",
  REUPLOAD_PROFILE_IMAGE: "อัปโหลดรูปโปรไฟล์ใหม่",
  COURSE: "หลักสูตร",
  COURSE_TITLE: "ชื่อหลักสูตร",
  START_DATE: "วันที่เริ่ม",
  END_DATE: "วันที่สิ้นสุด",
  START_TIME: "เวลาเริ่ม",
  DURATION: "ระยะเวลา",
  COURSE_TYPE: "ประเภทหลักสูตร",
  OFFLINE_COURSE: "หลักสูตรออฟไลน์",
  ONLINE_COURSE: "หลักสูตรออนไลน์",
  MEETING_URL: "ลิงก์หลักสูตร",
  LOCATION: "สถานที่",
  STRENGTH: "จุดเด่น",
  EXIT_PREVIEW: "ออกจากตัวอย่าง",
  MY_PROFILE: "โปรไฟล์ของฉัน",
  PURE_HARMONY: "เทมเพลตเรียบง่ายและเป็นมืออาชีพ",
  HERB_ESSENCE: "เทมเพลตสดใหม่และมีระดับ",
  IM_WORKED_AT: " ฉันทำงานที่",
  START_WORKING: "เริ่มทำงาน",
  TOOLBAR: "แถบเครื่องมือ",
  COLLAPSE_TOOLBAR: "ยุบแถบเครื่องมือ",
  EDIT_URL: "แก้ไข URL",
  SLUG: "Slug",
  EDIT_SLUG: "แก้ไข URL หน้าโปรไฟล์",
  PUBLISH_CONFIRM: "ยืนยันการเผยแพร่",
  UNPUBLISH_CONFIRM: "ยืนยันการยกเลิกการเผยแพร่",
  ARE_YOU_SURE_TO_X_WEBSITE: "คุณแน่ใจหรือไม่ว่าต้องการ {{X}} เว็บไซต์?",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "เว็บไซต์จะถูกเผยแพร่และมองเห็นได้โดยสาธารณะผ่านลิงก์ด้านล่าง",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "เว็บไซต์จะถูกยกเลิกการเผยแพร่และซ่อนจากสาธารณะ",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "คุณยังสามารถเผยแพร่เว็บไซต์ในภายหลังได้หากต้องการ",
  PUBLISH_S: "เผยแพร่",
  UNPUBLISH_S: "ยกเลิกการเผยแพร่",
  UNPUBLISH_WEBSITE: "ยกเลิกการเผยแพร่เว็บไซต์",
  UNPUBLISHED: "ยังไม่ได้เผยแพร่",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "เลือกเทมเพลตหน้าเว็บใหม่เพื่อเผยแพร่",
  CLOSE_EDITOR: "ปิดตัวแก้ไข",
  CLOSED: "ปิดแล้ว",
  REMOVE_SUCCESS: "ลบสำเร็จ",
  VIEW_ALL_X_CLINICS: "ดูคลินิกทั้งหมด {{X}} แห่ง",
  CONTINUE: "ดำเนินการต่อ",
  ONLY_WORKING_WEEKDAY: "ทำงานเฉพาะวันธรรมดา",
  WORKING_TIME: "เวลาทำงาน",
  WORKING_IN_WHOLE_WEEK: "ทำงานทั้งสัปดาห์",
  MONDAY: "จ.",
  TUESDAY: "อ.",
  WEDNESDAY: "พ.",
  THURSDAY: "พฤ.",
  FRIDAY: "ศ.",
  SATURDAY: "ส.",
  SUNDAY: "อา.",
  WORKING_TODAY: "ตั้งเป็นวันทำงาน",
  END_TIME: "เวลาสิ้นสุด",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "ใช้เวลาทำงานนี้กับทุกวัน",
  ONLY_WORK_IN_WEEKDAYS: "ทำงานเฉพาะวันธรรมดา",
  WORK_IN_WHOLE_WEEK: "ทำงานทั้งสัปดาห์",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS:
    "ใช้เวลาทำงานปัจจุบันกับทุกวันแล้ว",
  DR_X_COURSE: "หลักสูตรของ {{X}}",
  DR_X_VIDEO: "วิดีโอของ {{X}}",
  DELETE_ARTICLE: "ลบบทความ",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "คุณแน่ใจหรือไม่ว่าต้องการลบบทความนี้?",
  THIS_ACTION_CANNOT_BE_UNDONE: "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  SAVE_ARTICLE: "บันทึกบทความ",
  SAVE_ARTICLE_AND_PUBLISH: "บันทึกและเผยแพร่บทความ",
  PUBISH_ARTICLE: "เผยแพร่บทความ",
  UNPUBLISH_ARTICLE: "ยกเลิกการเผยแพร่บทความ",
  PUBLISH_ARTICLE: "เผยแพร่บทความ",
  ARE_YOU_SURE_TO_X_ARTICLE: "คุณแน่ใจหรือไม่ว่าต้องการ {{X}} บทความนี้?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "ผู้เยี่ยมชมจะไม่สามารถดูบทความนี้ได้",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "ผู้เยี่ยมชมจะสามารถดูบทความนี้ได้",
  UNPUBLISH: "ยกเลิกการเผยแพร่",
  REMOVE_BG_IMAGE: "ลบภาพพื้นหลัง",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE:
    "คุณแน่ใจหรือไม่ว่าต้องการลบภาพพื้นหลัง?",
  BG_UPLOAD: "อัปโหลดภาพพื้นหลัง",
  DEFAULT_BG_WILL_BE_APPLIED: "จะใช้ภาพพื้นหลังเริ่มต้น",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT:
    "คุณกำลังจะแปลเนื้อหาเว็บไซต์ของคุณ",
  WARNING: "คำเตือน",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "หากคุณได้กรอกข้อความใด ๆ ในภาษาที่คุณเลือกไว้ ข้อความนั้นจะถูกเขียนทับ",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "ฉันเข้าใจการดำเนินการนี้และยินยอมให้แปลโดยใช้ AI",
  ALL_7_DAYS: "ทั้ง 7 วัน",
  ARTICLE_TITLE: "ชื่อบทความ",
  NO_WORKING_DAYS: "ไม่มีวันทำงาน",
  WEBSITE_PUBLISHED: "เผยแพร่เว็บไซต์แล้ว",
  WEBSITE_UNPUBLISHED: "ยกเลิกการเผยแพร่เว็บไซต์แล้ว",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "อัปเดตและเผยแพร่เทมเพลตแล้ว",
  TRANSLATING_X_PLS_BE_PATIENT: "กำลังแปล {{X}} กรุณารอสักครู่...",
  SAVING_TRANSLATION: "กำลังบันทึกการแปล กรุณารอสักครู่...",
  TOGGLE_LANGUAGE: "สลับภาษา",
  TRANSLATE_UR_WEBSITE_USING_AI: "แปลเว็บไซต์ของคุณโดยใช้ AI...",
  ARTICLE: "บทความ",
  VIEW_PATIENT_HISTORY: "ดูประวัติผู้ป่วย",
  PRESCRIPTION_INFO: "ข้อมูลบันทึกการรักษา",
  TRANSLATE_FROM: "แปลจาก",
  TRANSLATE_TO: "แปลเป็น",
  SWAP: "สลับ",
  NO_WORKING_TIME_AVAILABLE: "ไม่มีเวลาทำงานที่ว่าง",
  MY_COLLEAGUES: "เพื่อนร่วมงานของฉัน",
  DAILY_SHARING: "การแบ่งปันประจำวัน",
  EDIT_MY_COLLEAGUES: "แก้ไขเพื่อนร่วมงานของฉัน",
  ADD_NEW_SHARING: "เพิ่มการแบ่งปันประจำวันใหม่",
  EDIT_DAILY_SHARING: "แก้ไขการแบ่งปันประจำวัน",
  ADD_IMAGE: "เพิ่มรูปภาพ",
  COLLEAGUE_DESCRIPTION: "คำอธิบายเพื่อนร่วมงาน",
  REUPLOAD: "อัปโหลดใหม่",
  COLLEAGUE: "เพื่อนร่วมงาน",
  PAY_THE_BALANCE: "ชำระยอดคงเหลือ",
  PAYMENT_SUCCESSFUL: "ชำระเงินสำเร็จ",
  DELETE_DAILY_SHARING: "ลบการแบ่งปันประจำวัน",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING:
    "คุณแน่ใจหรือไม่ว่าต้องการลบการแบ่งปันประจำวันนี้?",
  EDIT_VIDEO: "แก้ไขวิดีโอ",
  ADD_VIDEO: "เพิ่มวิดีโอ",
  VIDEO: "การแบ่งปันจากผู้เชี่ยวชาญ",
  COVER_IMAGE: "ภาพหน้าปก",
  VIDEO_TITLE: "ชื่อวิดีโอ",
  VIDEO_DESC: "คำอธิบายวิดีโอ",
  WATCH: "รับชม",
  DELETE_VIDEO: "ลบวิดีโอ",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO:
    "คุณแน่ใจหรือไม่ว่าต้องการลบวิดีโอนี้?",
  USED_BY_PHONE: "กำลังใช้งานผ่านโทรศัพท์",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "ตัดการเชื่อมต่อโทรศัพท์เพื่อพิมพ์",
  DISCONNECT: "ตัดการเชื่อมต่อ",
  CONTENT: "เนื้อหา",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "เปลี่ยนคลินิกปัจจุบันเป็น {{X}} แล้ว",
  ONLY_IMAGE_FILES_ALLOWED: "คุณสามารถอัปโหลดได้เฉพาะไฟล์รูปภาพที่นี่",
  HISTORY_SAVED: "บันทึกการรักษาแล้ว",
  TRANSLATION_COMPLETED: "การแปลเสร็จสมบูรณ์",
  "UPDATE_HISTORY_#X": "อัปเดตประวัติ #{{X}}",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "ชื่อบทความต้องไม่ว่างเปล่า",
  ARTICLE_UPDATED: "อัปเดตบทความแล้ว",
  ARTICLE_CREATED: "สร้างบทความแล้ว",
  ARTICLE_PUBLISHED: "เผยแพร่บทความแล้ว",
  ARTICLE_UNPUBLISHED: "ยกเลิกการเผยแพร่บทความแล้ว",
  ARTICLE_DELETED: "ลบบทความแล้ว",
  PREVIEW_TEMPLATE: "โหมดดูตัวอย่าง",
  U_R_IN_PREVIEW_MODE: "คุณอยู่ในโหมดดูตัวอย่าง",
  U_R_IN_EDIT_MODE: "คุณอยู่ในโหมดแก้ไข",
  PROFILE_IMAGE_UPLOADED: "อัปโหลดรูปโปรไฟล์แล้ว",
  SAVE_SUCCESS: "บันทึกสำเร็จ",
  INCORRECT_USERNAME_OR_PASSWORD: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
  CLINIC_X_SELECTED: "เลือกคลินิก {{X}} เพื่อทำงานแล้ว",
  AUTHENTICATION_EXPIRED:
    "การยืนยันตัวตนหมดอายุ! กรุณาลองเข้าสู่ระบบใหม่อีกครั้ง",
  MAKE_AN_APPOINTMENT: "นัดหมาย",
  APPOINTMENT_TIME: "เวลานัดหมาย",
  PHONE: "โทรศัพท์",
  EMAIL: "อีเมล",
  FIRST_NAME_IS_REQUIRED: "จำเป็นต้องกรอกชื่อจริง",
  LAST_NAME_IS_REQUIRED: "จำเป็นต้องกรอกนามสกุล",
  PHONE_IS_REQUIRED: "จำเป็นต้องกรอกหมายเลขโทรศัพท์",
  INVALID_PHONE_NUMBER: "หมายเลขโทรศัพท์ไม่ถูกต้อง",
  INVALID_PHONE_FORMAT_SMS_WARNING: "หมายเลขปัจจุบันอาจส่งผลต่อการรับ SMS กรุณาใช้รูปแบบ 04XXXXXXXX เพื่อให้แน่ใจว่าจะได้รับ SMS อย่างถูกต้อง",
  PLEASE_FIX_ERRORS: "กรุณาแก้ไขข้อผิดพลาด",
  BOOKING_CREATED: "สร้างการจองแล้ว",
  FIRSTNAMEEN_IS_REQUIRED: "จำเป็นต้องกรอกชื่อจริง (ภาษาอังกฤษ)",
  LASTNAMEEN_IS_REQUIRED: "จำเป็นต้องกรอกนามสกุล (ภาษาอังกฤษ)",
  INVALID_EMAIL: "อีเมลไม่ถูกต้อง",
  EMAIL_IS_REQUIRED: "จำเป็นต้องกรอกอีเมล",
  ADDRESS_IS_REQUIRED: "จำเป็นต้องกรอกที่อยู่",
  LESS_DETAILS: "แสดงรายละเอียดน้อยลง",
  REMOVE: "ลบ",
  COMPANY_NAME_IS_REQUIRED: "จำเป็นต้องกรอกชื่อบริษัท",
  INSURANCE_NUMBER_IS_REQUIRED: "จำเป็นต้องกรอกหมายเลขประกัน",
  CONFIGURATION: "การตั้งค่าการใช้งาน",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE:
    "เลือกส่วนที่คุณต้องการตั้งค่า",
  BUSINESS: "ธุรกิจ",
  CONFIGURE_BUSINESS_TIME: "ตั้งค่าเวลาทำการ / ประเภทบริการ",
  LANGUAGE: "ภาษา",
  CURRENT_LANGUAGE_X: "ภาษาปัจจุบัน: {{X}}",
  PATIENT_CREATED: "สร้างผู้ป่วยแล้ว",
  PATIENT_EDITED: "อัปเดตข้อมูลผู้ป่วยแล้ว",
  CHECK_IN_SUCCESS: "เช็คอินสำเร็จ",
  WHETHER_TO_DISPLAY_THIS_SECTION: "จะแสดงส่วนนี้หรือไม่",
};

const appointment = {
  APPOINTMENT_INFO: "ข้อมูลการนัดหมาย",
  APPOINTMENT_STATUS: "สถานะการนัดหมาย",
  CHECKED_IN: "เช็คอินแล้ว",
  CHECK_IN: "เช็คอิน",
  PROCEED_TO_MEDICAL_HISTORY: "ดำเนินการไปยังบันทึกการรักษา",
  APPOINTMENT_CLINIC: "คลินิกที่นัดหมาย",
  NAME: "ชื่อ",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 คุณกำลังมองหาผู้ป่วยด้านล่างนี้หรือไม่?",
  NO_RELAVANT_PATIENT_IN_CLINIC:
    "👀 ดูเหมือนว่าไม่พบผู้ป่วยที่เกี่ยวข้องในคลินิกนี้",
  PLS_ADD_PATIENT_FIRST: "คุณต้องการเพิ่มผู้ป่วยรายนี้เข้าคลินิกของคุณหรือไม่?",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "เลือกผู้ป่วยจากคลินิกเพื่อดำเนินการสร้างบันทึกการรักษา",
  CREATE_MEDICAL_HISTORY: "สร้างบันทึกการรักษา",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "ไม่มีผู้ป่วยข้างต้นที่ตรงกันใช่ไหม?",
  PENDING_CHECK_IN: "ยืนยันการจองแล้ว",
  PENDING_CHECK_IN_WAITING: "กำลังรอในคลินิก",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "คุณแน่ใจหรือไม่ว่าต้องการเช็คอินการนัดหมายนี้สำหรับ {{X}}?",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "หลังจากเช็คอินแล้ว คุณสามารถดำเนินการสร้างบันทึกการรักษาสำหรับผู้ป่วยรายนี้ได้",
  LOADING_APPOINTMENT: "กำลังโหลดการนัดหมาย",
  TODAY: "วันนี้",
  REMEDIAL_MASSAGE: "การนวดบำบัด",
  MASSAGE: "การนวด",
  ACUPUNCTURE: "การฝังเข็ม",
  CHINESE_MEDICINE: "แพทย์แผนจีน",
  APPROXIMATE_DURATION: "ระยะเวลาโดยประมาณ",
  DURATION_MINUTES: "{{m}} นาที",
  DURATION_HOURS: "{{h}} ชม.",
  DURATION_HOURS_MINUTES: "{{h}} ชม. {{m}} นาที",
  VIEW_IN_SCHEDULE: "ดูในตารางนัด",
  APPROX: "ประมาณ",
  BUSINESS_TIME: "เวลาทำการ",
  WORKING_SERVICES: "บริการที่ให้",
  WORKING_DAYS: "วันทำงาน",
  WORKING_TIME_PERIOD: "ช่วงเวลาทำงาน",
  RESET: "รีเซ็ตการเปลี่ยนแปลง",
  BLOCK_TIME_SLOTS: "บล็อกช่วงเวลา",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "ใช้เวลาที่บล็อกกับทุกวัน",
  LOADING_TIME_SLOTS: "กำลังโหลดช่วงเวลา",
  NO_AVAILABLE_TIME: "ไม่มีเวลาว่าง",
  RESET_CLINIC: "รีเซ็ตการเปลี่ยนแปลงเวลาทำงาน",
  SAVE_CHANGES: "บันทึกการเปลี่ยนแปลง",
  CLINIC_NOT_FOUND: "ไม่พบคลินิก",
  SAVE_CLINIC_SUCCESS: "บันทึกเวลาทำการแล้ว",
  PLEASE_SELECT_WORKING_SERVICES: "กรุณาเลือกบริการที่ให้",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "เวลาเริ่มต้องไม่อยู่หลังเวลาสิ้นสุด",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "เวลาสิ้นสุดต้องไม่อยู่ก่อนเวลาเริ่ม",
  SELECTED_WEEKDAY: "วันที่เลือก",
  MINUTES: "นาที",
  CLEAR_ALL: "ล้างทั้งหมด",
  SELECT_ALL: "เลือกทั้งหมด",
  COPY_PRODUCTS_TO_OTHER_CLINIC: "คัดลอกผลิตภัณฑ์ไปยังคลินิกอื่น",
  COPY_PRODUCTS_FROM_OTHER_CLINIC: "คัดลอกผลิตภัณฑ์จากคลินิกอื่น",
  ASSIGN_PRACTITIONERS_TO_IMPORTED: "กำหนดแพทย์ให้กับผลิตภัณฑ์ที่นำเข้า",
  SELECT_SOURCE_CLINIC: "เลือกคลินิกต้นทาง",
  X_PRODUCTS_IMPORTED_FROM_Y: "นำเข้าผลิตภัณฑ์ {{X}} รายการจาก {{Y}} แล้ว",
  COPY_TO_THIS_CLINIC: "คัดลอกมายังคลินิกนี้",
  SELECT_PRODUCTS_TO_COPY: "เลือกผลิตภัณฑ์ที่จะคัดลอก",
  SELECT_TARGET_CLINIC: "เลือกคลินิกปลายทาง",
  SELECTED_X_OF_Y: "เลือกแล้ว {{X}} จาก {{Y}}",
  PRODUCTS_COPIED_SUCCESS: "คัดลอกผลิตภัณฑ์ไปยังคลินิกปลายทางแล้ว",
  X_PRODUCTS_COPIED_TO_Y:
    "คัดลอกผลิตภัณฑ์ที่เลือก {{X}} รายการไปยัง {{Y}} แล้ว",
  GO_TO_CLINIC_PRODUCTS: "ไปยังหน้าผลิตภัณฑ์ของคลินิก",
  HIDE_PREVIEW: "ซ่อนตัวอย่าง",
  X_PRODUCTS_IN_THIS_CLINIC: "ผลิตภัณฑ์ {{X}} รายการในคลินิกนี้",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "คลิกเพื่อบล็อกช่วงเวลาที่คุณไม่ต้องการให้ใช้สำหรับการนัดหมาย",
  SELECT_WORKING_DAY: "เลือกวันทำงาน",
  DECREASE_DURATION: "ลดระยะเวลา",
  INCREASE_DURATION: "เพิ่มระยะเวลา",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS:
    "ใช้เวลาที่บล็อกปัจจุบันกับทุกวันแล้ว",
  SAVE_AS_NOT_WORKING: "บันทึกเป็นวันไม่ทำงาน",
  SAVE_AS_WORKING: "บันทึกเป็นวันทำงาน",
  CONFIRM_CLEAR_BLOCK_TIMES: "คุณแน่ใจหรือไม่ว่าต้องการล้างเวลาที่บล็อกทั้งหมด?",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "การเปลี่ยนระยะเวลาจะล้างเวลาที่บล็อกทั้งหมด",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "การเปลี่ยนเวลาทำงานจะล้างเวลาที่บล็อกของวันนี้",
  BLOCK_TIMES_CLEARED: "ล้างเวลาที่บล็อกแล้ว",
  SAVING: "กำลังบันทึก",
  BLOCK_THIS_TIMESLOT: "บล็อกช่วงเวลานี้",
  ACTIVE_THIS_TIMESLOT: "เปิดใช้ช่วงเวลานี้",
  UNSAVED_CHANGES: "การเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
  SCHEDULE_CONFLICT: "ตารางเวลาทับซ้อน",
  ALREADY_WORKING_IN_OTHER_CLINICS_ON_THESE_DAYS: "คุณมีตารางงานในคลินิกอื่นอยู่แล้วในวันต่อไปนี้:",
  CONFIRM_TO_REPLACE_AND_SAVE: "ยืนยันเพื่อแทนที่วันเหล่านี้ในคลินิกอื่น แล้วจึงบันทึกการเปลี่ยนแปลงที่นี่",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณแน่ใจหรือไม่ว่าต้องการสลับคลินิกและละทิ้งการเปลี่ยนแปลงเหล่านั้น?",
  DISCARD_AND_SWITCH: "ละทิ้งและสลับ",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "คุณยังไม่ได้ตั้งค่าเวลาทำงานในคลินิกนี้",
  CONFIGURE_WORKING_TIME: "เวลาทำงานและบริการของฉัน",
  MY_WORKING_CLINICS: "คลินิกที่ฉันทำงาน",
  ALL: "ทั้งหมด",
  FILTER: "ตัวกรอง",
  STATUS: "สถานะ",
  REJECT: "ปฏิเสธ",
  DATE_OF_BIRTH_IS_REQUIRED: "จำเป็นต้องกรอกวันเกิด",
  INVALID_DATE: "วันที่ไม่ถูกต้อง",
  DATE_CANNOT_BE_IN_FUTURE: "วันที่ต้องไม่เป็นวันในอนาคต",
  PATIENT_UPDATED_WARNING: "การแจ้งเตือนข้อมูลผู้ป่วย",
  SYSTEM_HAS_DETECTED_THE_FOLLOWING_CHANGES_TO_THIS_PATIENT:
    "ระบบตรวจพบว่าข้อมูลผู้ป่วยปัจจุบันไม่ตรงกับข้อมูลที่ระบุในการจองนี้",
  DO_U_WANT_TO_UPDATE_THIS_PATIENT_INFO:
    "คุณต้องการอัปเดตข้อมูลผู้ป่วยหรือไม่?",
  CURRENT_INFO: "ข้อมูลปัจจุบัน",
  UPDATED_INFO: "ข้อมูลที่อัปเดต",
  QUICK_UPDATE: "อัปเดตด่วน",
  DATE_SCHEDULE: "ตารางตามวันที่",
  NO_APPOINTMENT_FOUND: "ไม่พบการนัดหมาย",
  INCOMING_BOOKINGS_ONLY: "เฉพาะการนัดหมายที่กำลังจะมาถึง",
  SELECT_HOUR: "เลือกชั่วโมง",
  SELECT_MINUTE: "เลือกนาที",
  SELECT_APPOINTMENT_TIME: "เลือกเวลานัดหมาย",
  X_APPOINTMENTS_SCHEDULED_FOR_THIS_DATE:
    "มีการนัดหมาย {{X}} รายการในวันนี้",
  X_APPOINTMENTS_SECHEDULED_FOR_TODAY:
    "มีการนัดหมาย {{X}} รายการสำหรับวันนี้",
  THIS_SAVED_PATIENT_INCLUDES_INVALID_PHONE_NUMBER_THIS_MIGHT_BE_A_PROBLEM_RECEIVING_SMS_LATER:
    "ตรวจพบหมายเลขโทรศัพท์ที่ไม่ถูกต้องสำหรับผู้ป่วยรายนี้ ซึ่งอาจส่งผลต่อการส่ง SMS แจ้งเตือนในอนาคต",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_PATIENT_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "เคล็ดลับ: เมื่อใกล้ถึงเวลานัดหมาย ระบบจะส่ง SMS แจ้งเตือนไปยังผู้ป่วย",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "เคล็ดลับ: เมื่อใกล้ถึงเวลานัดหมาย ระบบจะส่ง SMS แจ้งเตือนไปยังคุณ",
  BOOKED_PRACTITIONER: "แพทย์ที่จอง",
  U_CAN_MANAGE_UR_CLINIC_PRODUCT_HERE: "จัดการผลิตภัณฑ์ของคลินิกของคุณที่นี่",
  THESE_PRODUCTS_WILL_BE_USED_IN_PATIENTS_BOOKING_FROM_PUBLIC:
    "ผลิตภัณฑ์เหล่านี้จะพร้อมให้ผู้ป่วยเลือกเมื่อจองนัดหมายผ่านระบบจองสาธารณะ",
  THIS_NOTE_WILL_BE_SAVED_TO_NEW_PATIENT_PROFILE: "หมายเหตุนี้จะถูกบันทึกไว้ในข้อมูลผู้ป่วยใหม่",
};

const clinicManagement = {
  CLINIC_SETTINGS: "การตั้งค่าคลินิก",
  CLINIC_MANAGEMENT: "การจัดการคลินิกและสมาชิก",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "ค้นหาคลินิกในแถบค้นหาเพื่อเข้าร่วม หรือสร้างคลินิกใหม่",
  NO_CLOSED_CLINICS: "ไม่มีคลินิกที่ปิด",
  NO_PENDING_CLINICS: "ไม่มีคลินิกที่รอดำเนินการ",
  SEARCH_CLINIC: "ค้นหาคลินิก",
  ADD_CLINIC: "สร้างคลินิกใหม่",
  CLINIC_INFO: "ข้อมูลคลินิก",
  OWNER: "เจ้าของ",
  INVITE_PRACTITIONERS: "เชิญแพทย์",
  INVITED: "เชิญแล้ว",
  NO_PRACTITIONER_FOUND: "ไม่พบแพทย์",
  SUBMIT_CLINIC_INFO: "ส่งข้อมูลคลินิก",
  UPDATE_CLINIC_INFO: "อัปเดตข้อมูลคลินิก",
  RESUBMIT_CLINIC_INFO: "ส่งข้อมูลคลินิกอีกครั้ง",
  ADDRESS: "ที่อยู่",
  OPEN: "เปิดทำการ",
  PENDING: "รอดำเนินการ",
  MY_CLINIC: "คลินิกของฉัน",
  EDIT_CLINIC_INFO: "แก้ไขคลินิก",
  ACTIVE: "ใช้งานอยู่",
  INACTIVE: "ไม่ได้ใช้งาน",
  ASSOCIATED_PRACTITIONERS: "แพทย์ที่เกี่ยวข้อง",
  NO_PHONE_NUMBER: "ไม่มีหมายเลขโทรศัพท์",
  PRACTITIONER_INFO: "ข้อมูลแพทย์",
  SERVICES: "บริการ",
  WORK_TIME: "เวลาทำงาน",
  WORKING_DAY: "วันทำงาน",
  NOT_AVAILABLE: "ไม่ว่าง",
  MINS: " นาที",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "แพทย์ {{X}} คนกำลังใช้งานอยู่",
  X_PRACTITIONERS_FOUND: "พบแพทย์ทั้งหมด {{X}} คน",
  NO_ACTIVE_PRACTITIONERS: "ไม่พบแพทย์",
  NO_INACTIVE_PRACTITIONERS: "ไม่มีแพทย์ที่ไม่ได้ใช้งาน",
  INVITE: "เชิญ",
  WORKING_IN_CLINIC: "ทำงานในคลินิก",
  QUIT_PRACTITIONER: "แพทย์ลาออก",
  QUIT_FROM_CLINIC: "ลาออกจากคลินิก",
  QUIT_CLINIC_CONFIRM: "ยืนยันการลาออกจากคลินิก",
  QUIT_CLINIC_REQUEST_SENT: "ส่งคำขอลาออกจากคลินิกแล้ว",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "คุณแน่ใจหรือไม่ว่าต้องการลาออกจากคลินิกนี้",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "หลังจากได้รับอนุมัติ ผู้ป่วยจะไม่สามารถจองคุณสำหรับคลินิกนี้ได้อีกต่อไป",
  PENDING_APPROVE_TO_QUIT: "รออนุมัติการลาออก",
  PENDING_APPROVE_TO_JOIN: "รออนุมัติการเข้าร่วม",
  JOIN_CLINIC: "เข้าร่วมคลินิก",
  X_NEW_MEMBER_REQUESTS: "มีคำขอใหม่ที่รอดำเนินการ {{X}} รายการ",
  JOIN_CLINIC_CONFIRM: "ยืนยันการเข้าร่วมคลินิก",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "คุณแน่ใจหรือไม่ว่าต้องการเข้าร่วมคลินิกนี้",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "ส่งคำขอเข้าร่วมของคุณแล้ว",
  NEW_PRACITTIONERS: "แพทย์ใหม่",
  ACCEPT_CONFRIM: "ยืนยันการยอมรับ",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST:
    "คุณแน่ใจหรือไม่ว่าต้องการยอมรับคำขอของแพทย์รายนี้",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST:
    "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธคำขอของแพทย์รายนี้",
  VIEW_INFO: "ดูข้อมูล",
  NO_SERVICES_AVAILABLE: "ไม่มีบริการให้บริการ",
  SEARCH_PRACTITIONER_BY_NAME: "ค้นหาแพทย์ของคลินิกด้วยชื่อ",
  X_PENDING_APPROVAL: "มีคำขอ {{X}} รายการที่รออนุมัติ",
  APPROVE: "อนุมัติ",
  DECLINE: "ปฏิเสธ",
  ACCEPT: "ยอมรับ",
  CLEAR: "ล้าง",
  ACCEPT_CONFIRM: "ยืนยันการยอมรับ",
  REJECT_CONFIRM: "ยืนยันการปฏิเสธ",
  CLOSE_CLINIC: "ปิดคลินิก",
  CONFIRM_TO_CLOSE_CLINIC: "ยืนยันการปิดคลินิก",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "คลินิกนี้จะถูกปิดและแพทย์ที่เกี่ยวข้องทั้งหมดจะถูกนำออก",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "ฉันเข้าใจผลที่ตามมาจากการปิดคลินิกนี้",
  ME: "ฉัน",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "คุณแน่ใจหรือไม่ว่าต้องการนำแพทย์รายนี้ออกจากคลินิกนี้",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "แพทย์รายนี้จะไม่สามารถทำงานในคลินิกนี้ได้อีกต่อไป",
  INVITE_CONFIRM: "ยืนยันการเชิญ",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC:
    "คุณแน่ใจหรือไม่ว่าต้องการเชิญ {{X}} เข้าคลินิกของคุณ",
  CONTINUE: "ดำเนินการต่อ",
  PENDING_ACCEPT: "รอแพทย์ยอมรับ",
  NO_CLINIC_SELECTED: "ยังไม่ได้เลือกคลินิก",
  NO_WORKING_CLINIC_FOUND: "ไม่พบคลินิกที่ทำงาน",
  NEW_CLINIC_INVITATION: "คำเชิญเข้าร่วมคลินิก",
  ADD_JOIN_CLINIC: "เพิ่ม / เข้าร่วมคลินิกใหม่",
  OR_U_CAN: "หรือคุณสามารถ",
  CONSULTATION_FEES: "ค่าบริการคลินิก",
  THIS_CONSULTATION_FEES_WILL_BE_DISPLAYED_IN_YOUR_PERSONAL_PAGE:
    "ค่าบริการคลินิกที่กรอกครบ (ค่าบริการ > $0.00) จะแสดงในหน้าส่วนตัวของคุณ",
  ENTER_FEE_LABEL: "กรอกชื่อค่าธรรมเนียม",
  ADD_OTHER_CONSULTATION_FEE: "เพิ่มค่าบริการคลินิกอื่น ๆ",
  ALL_PACKAGES: "แพ็กเกจทั้งหมด",
  PACKAGE_FILTER: "กรองผู้ใช้คลินิกตามแพ็กเกจ",
  EXTEND_PACKAGE: "ขยายแพ็กเกจ",
  OOPS_THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "🤔 จำนวนผู้ใช้ที่ซื้อสำหรับแพ็กเกจนี้เต็มจำนวนสูงสุดแล้ว",
  USER_PACK_PURCHASED: "จำนวนผู้ใช้ที่จัดสรร / ซื้อแล้ว",
  THIS_PACKAGE_HAS_ALREADY_BEEN_ASSIGNED_TO_THIS_CLINIC_USER:
    "ผู้ใช้คลินิกรายนี้ได้รับการจัดสรรแพ็กเกจนี้แล้ว",
  THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "จำนวนผู้ใช้ที่ซื้อสำหรับแพ็กเกจนี้เต็มจำนวนสูงสุดแล้ว",
  EXPIRED_TODAY: "ใกล้หมดอายุ",
  SOON_TO_EXPIRED: "ใกล้หมดอายุ",
  EXTEND_NOW: "ขยายตอนนี้",
  REMOVE_PACKAGE_FROM_USER: "นำแพ็กเกจออกจากผู้ใช้รายนี้",
  NO_PERMISSION_TO_ACCESS_CLINIC_FUNCTION:
    "ในกรณีนี้ ผู้ใช้จะไม่สามารถเข้าถึงฟังก์ชันของคลินิกได้อีกต่อไป",
  NO_PERMISSION_ACCESS_FEATURE_OR_DATA:
    "คุณไม่มีสิทธิ์เข้าถึงข้อมูลหรือฟีเจอร์นี้ในขณะนี้ หากมีข้อสงสัยเกี่ยวกับสิทธิ์การใช้งาน กรุณาติดต่อผู้ดูแลคลินิกของคุณ",
  CURRENT_CLINIC_INVALID_MAY_HAVE_LEFT:
    "คลินิกนี้ไม่ถูกต้องแล้ว คุณอาจออกจากคลินิกนี้ไปแล้ว",
  CLINIC_WORK_PERMISSIONS_UPDATED:
    "ตรวจพบว่าสิทธิ์การทำงานของคุณสำหรับคลินิกนี้ได้รับการอัปเดตแล้ว",
  VALID_PACKAGE: "แพ็กเกจที่ใช้งานได้",
  REPURCHASE_PACKAGE: "ซื้อแพ็กเกจอีกครั้ง",
  CLOSED_CLINIC: "คลินิกปิดแล้ว",
  THIS_CLINIC_HAS_BEEN_CLOSED: "คลินิกนี้ถูกปิดแล้ว",
  CLINIC_RELATED_TO_ME: "คลินิกที่เกี่ยวข้องกับฉัน",
  CANCEL_INVITATION_SUCCESS: "ยกเลิกคำเชิญสำเร็จ",
  AVG_DURATION: "ระยะเวลาตรวจเฉลี่ย",
  VIEW_CLINIC: "ดูคลินิก",
  NEW: "ใหม่",
  CLINIC_NO_PACKAGE_SUBSCRIBED: "คลินิกยังไม่มีการสมัครสมาชิกที่ใช้งานอยู่",
  PURCHASE_PACKAGE_AND_ASSIGN_TO_CLINIC_MEMBERS_TO_START_WORKING_AT_HEALTHNEX:
    "เมื่อคุณซื้อแผนและจัดสรรให้กับพนักงานคลินิกของคุณ คุณจะปลดล็อกประสบการณ์การใช้บริการ Healthnex แบบเต็มรูปแบบได้ทันที!",
  PURCHASE_PACKAGE_TO_START_WORKING_AT_HEALTHNEX:
    "เมื่อคุณซื้อแผน คุณจะปลดล็อกประสบการณ์การใช้บริการ Healthnex แบบเต็มรูปแบบได้ทันที!",
  PURCHASE_PACKAGE_FOR_UR_CLINIC: "เลือกแผนที่เหมาะกับคลินิกของคุณ",
  NO_SURE_WHAT_DO: "ไม่แน่ใจว่าจะเริ่มต้นตรงไหน?",
  START_SYSTEM_GUIDE: "เริ่มการแนะนำการใช้งาน",
  NO_PACKAGE_ALLOCATED: "คุณยังไม่ได้รับการจัดสรรแผนในคลินิกนี้",
  PLEASE_CONTACT_YOUR_CLINIC_OWNER_TO_ASSIGN_THE_PACKAGE_TO_ACCESS_MORE_FEATURES_IN_HEALTHNEX:
    "กรุณาติดต่อเจ้าของคลินิกเพื่อจัดสรรแผนให้คุณ เพื่อให้คุณสามารถเข้าถึงฟีเจอร์ของ Healthnex ได้อย่างครบถ้วน",
  SUBSCRIPTION: "การสมัครสมาชิกแพ็กเกจ",
  SELECT_A_SUITABLE_PACKAGE_FOR_YOUR_CLINIC_MEMBERS_TO_START_WORKING:
    "เลือกแผนที่เหมาะสมสำหรับพนักงานคลินิกของคุณเพื่อเริ่มทำงาน",
  ASSIGN_TO_CLINIC: "จัดสรรให้คลินิก",
  SELECT_THE_CLINIC_THAT_U_WITH_TO_APPLY_THIS_PACKAGE_FOR:
    "กรุณาเลือกคลินิกที่คุณต้องการใช้แผนนี้",
  ADJUST_NUMBER_USER_PACK_U_WISH_TO_PURCHASE:
    "กรุณาปรับจำนวนชุดผู้ใช้ที่คุณต้องการซื้อ (หากแพ็กเกจนี้เป็นชุดรวม คุณจะไม่สามารถกำหนดจำนวนผู้ใช้เองได้)",
  USER_PACK_CAN_BE_ASSIGNED_TO_CLINIC_USER_TO_ALLOW_EXPERIENCE_THE_PACKAGE_FEATURE:
    "ชุดผู้ใช้สามารถจัดสรรให้กับพนักงานคลินิกได้ เพื่อให้พวกเขาเข้าถึงและใช้งานฟีเจอร์ของแผนได้",
  EG_PURCHASED_3_USER_PACKS_CAN_BE_APPLY_TO_3_USERS_IN_CLINIC_INCLUDE_OWNER:
    "ตัวอย่างเช่น หากคุณซื้อแผนสำหรับผู้ใช้ 3 ราย คุณสามารถจัดสรรให้พนักงานคลินิก 3 คน รวมถึงเจ้าของคลินิกได้",
  ASSIGN_USER_PACK_TO_CLINIC_USER: "จัดสรรชุดผู้ใช้ให้สมาชิกคลินิก",
  CLINIC_MEMBERS_WHO_DONT_HAVE_PACKAGE_WILL_BE_DISPLAYED_HERE_U_CAN_QUICK_ASSIGNED_PURCHASED_USER_PACK_TO_THEM:
    "พนักงานคลินิกที่ยังไม่ได้รับการจัดสรรแผนจะแสดงที่นี่ คุณสามารถจัดสรรชุดผู้ใช้ที่ซื้อไว้ให้พวกเขาได้อย่างรวดเร็ว",
  CARD_DETAIL: "รายละเอียดบัตร",
  FILLING_UR_CARD_DETAIL_TO_PAY:
    "กรอกรายละเอียดบัตรของคุณเพื่อทำการชำระเงิน",
  PAY_NOW: "ชำระเงินตอนนี้",
  DONT_SHOW_AGAIN: "ไม่ต้องแสดงอีก",
  ORDER_NO: "คำสั่งซื้อ",
  SELECTED_CLINIC: "คลินิกที่เลือก",
  CLINIC_LOGO: "โลโก้คลินิก",
  EDIT_LOGO: "แก้ไขโลโก้",
  ADD_LOGO: "เพิ่มโลโก้",
  REUPLOAD_LOGO: "อัปโหลดโลโก้ใหม่",
  UPLOAD_LOGO: "อัปโหลดโลโก้",
  CLINIC_LOGO_UPLOADED: "อัปโหลดโลโก้คลินิกแล้ว",
  NO_CLINICS_FOUND_IN_X: "🤔 ไม่พบคลินิกที่เกี่ยวข้องใน {{X}}",
  U_CAN_CREATE_YOUR_OWN_CLINIC_OR_JOIN_AN_EXISTING_CLINIC_TO_WORK_LATER:
    "🎉 ไม่ต้องกังวล—คุณสามารถสร้างคลินิกของคุณเองตอนนี้ หรือเข้าร่วมคลินิกในภายหลังก็ได้ ตามที่สะดวกที่สุดสำหรับคุณ!",
  JOINED: "เข้าร่วมแล้ว",
  U_ARE_THE_OWNER_OF_BELOW_CLINICS: "คุณจะกลายเป็นเจ้าของคลินิกต่อไปนี้",
  WE_WILL_CREATE_THE_CLINIC_FOR_YOU_ANY_NO_NAME_CLINIC_WILL_BE_RENAME_TO_YOUR_NAME:
    "เราจะสร้างคลินิกเหล่านี้ให้คุณ โปรดทราบว่าคลินิกที่ไม่มีชื่อจะถูกตั้งชื่อตามชื่อของคุณ เช่น คลินิกของ John",
  U_ARE_THE_MEMBER_OF_BELOW_CLINICS: "คุณเป็นสมาชิกของคลินิกด้านล่างนี้",
  U_WILL_BE_THE_MEMBER_OF_THE_BELOW_CLINICS:
    "คุณจะเข้าร่วมคลินิกที่มีอยู่ต่อไปนี้ใน Healthnex ในฐานะสมาชิก",
  THESE_CLINICS_HAS_NOT_BEEN_CREATED_BY_THEIR_OWNER_IN_SYSTEM_PLEASE_CONTACT_THEIR_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "คลินิกเหล่านี้ยังไม่ได้ถูกสร้างขึ้นในระบบ Healthnex โดยเจ้าของ กรุณาติดต่อเจ้าของคลินิกเพื่อสร้างคลินิกและเชิญคุณเข้าร่วม",
  CLINIC_BELOWS_ARE_NOT_IN_THE_SYSTEM:
    "คุณเป็นสมาชิกของคลินิกต่อไปนี้ แต่คลินิกเหล่านี้ยังไม่ได้ถูกสร้างขึ้นในระบบ Healthnex",
  CREATING_ACCOUNT:
    "กรุณารอสักครู่ เรากำลังสร้างบัญชี Healthnex ของคุณ",
  PLEASE_DONT_CLOSE_THIS_PAGE: "กรุณาอย่าปิดหน้านี้",
  WELCOME_TO_HEALTHNEX: "ยินดีต้อนรับสู่ Healthnex!",
  VERIFYING_EXTERNAL_ACCOUNT: "กำลังตรวจสอบข้อมูลบัญชีภายนอก",
  PACKAGE_IS_SOOON_TO_EXPIRED: "แพ็กเกจต่อไปนี้กำลังจะหมดอายุ",
  IF_NOT_RENEW_SERVICE_WILL_BE_STOPPED:
    "หากคุณไม่ต่ออายุภายในเวลาที่กำหนด บริการปัจจุบันของคุณจะถูกระงับ",
  RENEW_UR_PACKAGE_BEFORE_LOSE_ACCESS_TO_UR_SERVICE:
    "เพื่อหลีกเลี่ยงการหยุดชะงักในการดำเนินงานประจำวันของคุณ กรุณาต่ออายุแผนของคุณโดยเร็วที่สุดเพื่อให้บริการต่อเนื่อง",
  RENEW_NOW: "ต่ออายุตอนนี้",
  MY_PACKAGE: "แพ็กเกจของฉัน",
  THIS_FEATURE_REQUIRED_A_PACKAGE_SUBSCRIPTION:
    "ฟีเจอร์นี้ต้องมีการสมัครสมาชิกแพ็กเกจ",
  CURRENT_PACKAGE: "แพ็กเกจปัจจุบัน",
  NO_ADDRESS: "ไม่มีที่อยู่",
  CURRENT_CLINIC_NOT_FOUND: "ไม่พบคลินิกปัจจุบัน",
  CURRENT_PACKAGE_OFFER: "ข้อเสนอแพ็กเกจปัจจุบัน",
  FOR_USERS_PACK_AVAILABLE: " ชุดผู้ใช้",
  U_CAN_ENTER_MODIFY_UR_INSURANCE_NUMBER_HERE:
    "คุณสามารถกรอกหรือแก้ไขหมายเลขประกันของคุณได้ที่นี่",
  INCLUDED_INSURANCES: "ประกันที่รวมอยู่",
  NO_MODALITY_INSURANCE: "ยังไม่ได้เพิ่มประกัน",
  ADD_MODALITY_INSURANCE_NO: "เพิ่มประกัน",
  INSURANCE_PROVIDER: "ผู้ให้บริการประกัน",
  INSURANCE_NUMBER: "หมายเลขประกัน",
  SWITCH_TO_ENABLED: "เปิดใช้งาน",
  SWITCH_TO_NOT_ENABLED: "ไม่เปิดใช้งานสิ่งนี้",
  INSURANCE_NOT_ENABLED: "ยังไม่ได้เปิดใช้งานประกัน",
  MODALITY_NOT_ENABLED: "ยังไม่ได้เปิดใช้งานบริการ",
  X_INSURANCES_CHANGE_UNSAVED_ARE_YOU_SURE_TO_CLOSE:
    "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึกในประกัน {{X}} รายการ คุณแน่ใจหรือไม่ว่าต้องการปิดหน้าต่างนี้?",
  CLINIC_MAXIMUM_BED_NUM: "จำนวนเตียงสูงสุดของคลินิก",
  CURRENT_MAXIMUM_BED_NUM_CONFIGURED_BY_CLINIC:
    "จำนวนเตียงสูงสุดที่คลินิกตั้งค่าไว้ในปัจจุบัน",
  CONFIGURE_BED_NUM: "ตั้งค่าจำนวนเตียงของคลินิก",
  BED: "เตียง",
  PRACTITIONER_CAPACITY: "จำนวนผู้ป่วยสูงสุดที่รับพร้อมกันต่อบริการ",
  PATIENT_AT_SAME_TIME: "ผู้ป่วยในเวลาเดียวกัน",
  THIS_VALUE_CANNOT_EXCEED_THE_CLINIC_MAXIMUM_CAPACITY:
    "ค่านี้ต้องไม่เกินจำนวนเตียงสูงสุดของคลินิก",
  X_BED_NUM: "{{X}} เตียง",
  U_CAN_CHANGE_THE_CLINIC_BED_NUM_HERE:
    "คุณสามารถเปลี่ยนจำนวนเตียงของคลินิกได้ที่นี่",
  NOT_WORKING_DAY_IN_THIS_CLINIC: "วันที่ไม่ทำงาน",
  REST_DAY: "วันหยุด",
  WORK_IN: "ทำงานใน",
  SELECT_ADDON: "เลือกบริการเสริม",
  YOU_SUBSCRIBED_ALL_ADDONS_TO_THIS_PACKAGE:
    "คุณได้สมัครบริการเสริมทั้งหมดในแพ็กเกจแล้ว",
  EFFECTIVE_DATE: "เวลาที่มีผล",
  NOT_YET_EFFECTIVE: "ยังไม่มีผล",
  CANCEL_SUBSCRIPTION: "ยกเลิกการสมัครสมาชิก",
  CANCEL_SUBSCRIPTION_CONFIRM: "ยกเลิกการสมัครสมาชิกนี้?",
  CANCEL_SUBSCRIPTION_DESC:
    "เมื่อยกเลิกแล้ว แพ็กเกจนี้จะไม่สามารถต่ออายุได้อีก คุณสามารถใช้งานได้ตามปกติจนกว่าการสมัครสมาชิกจะหมดอายุ หลังจากนั้นแพ็กเกจจะถูกปิดการใช้งาน",
  SUBSCRIPTION_CANCELLED: "ยกเลิกการสมัครสมาชิกแล้ว",
  E_DAYS_LEFT: " วันที่เหลือ",
  E_DAYS_AGO: " วันที่ผ่านมา",
  FILTER_PRACTITIONER_BY: "กรองแพทย์ตาม",
  ASSIGN_PRACTITIONER: "กำหนดแพทย์",
  CLINIC_PRACTITIONERS_NOT_VISIBLE_BELOW:
    "แพทย์ที่ไม่พร้อมให้บริการสำหรับบริการนี้",
  BELOW_PRACTITIONERS_NOT_PROVIDING_SERVICE: "แพทย์ต่อไปนี้ไม่ได้ให้บริการนี้:",
  ENABLE_SERVICE: "เปิดใช้งานบริการ",
  ADDON: "บริการเสริม",
  PACKAGE: "แพ็กเกจ",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "การจัดการทรัพยากรของคลินิก",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA:
    "จัดการข้อมูลสมุนไพรและตำรับยาที่ใช้ได้เฉพาะในคลินิกปัจจุบันของคุณเท่านั้น",
  CURRENT_CLINIC: "คลินิกปัจจุบัน",
  CONFIGURE_CLINIC_HERBS: "ตั้งค่าสมุนไพรของคลินิก",
  CONFIGURE_CLINIC_FORMULA: "ตั้งค่าตำรับยาของคลินิก",
  CLINIC_HERB: "สมุนไพรของคลินิก",
  CLINIC_FORMULA: "ตำรับยาของคลินิก",
  SEARCH_HERB_NAME: "ค้นหาชื่อสมุนไพร",
  SEARCH_FORMULA_NAME: "ค้นหาชื่อตำรับยา",
  ADD_HERB: "เพิ่มสมุนไพร",
  ADD_FORMULA: "เพิ่มตำรับยา",
  HERB_NAME: "ชื่อสมุนไพร",
  HERB_NAME_IN_X: "ชื่อสมุนไพร ({{X}})",
  PINYIN: "พินอิน",
  IS_TOXIC: "มีพิษ",
  IS_PREMIUM: "เป็นเกรดพรีเมียม",
  USED_BY_CREATER_ONLY: "ใช้โดยผู้สร้างเท่านั้น",
  TOXIC: "มีพิษ",
  PREMIUM: "พรีเมียม",
  YES: "ใช่",
  NO: "ไม่",
  HERB_NAME_CN: "ชื่อสมุนไพร (ภาษาจีน)",
  FORMULA_NAME_CN: "ชื่อตำรับยา (ภาษาจีน)",
  HERB_NAME_EN: "ชื่อสมุนไพร (ภาษาอังกฤษ)",
  FORMULA_NAME_EN: "ชื่อตำรับยา (ภาษาอังกฤษ)",
  HERB_NAME_X: "ชื่อสมุนไพร ({{X}})",
  FORMULA_NAME_X: "ชื่อตำรับยา ({{X}})",
  HERB_INFO: "ข้อมูลสมุนไพร",
  FORMULA_INFO: "ข้อมูลตำรับยา",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "ตำรับยานี้สามารถใช้/แก้ไขได้โดยผู้สร้าง (ตัวคุณเอง) เท่านั้น",
  SEARCH_HERB_NAME_HERE: "ค้นหาชื่อสมุนไพรที่นี่",
  SEARCH_HERB_BY_HERB_NAME: "ค้นหาสมุนไพรด้วยชื่อสมุนไพร",
  HERB_IN_THIS_FORMULA: "สมุนไพรในตำรับนี้",
  NO_HERB_ADDED: "ยังไม่ได้เพิ่มสมุนไพร",
  FORMULA_NAME: "ชื่อตำรับยา",
  FORMULA_NAME_IN_X: "ชื่อตำรับยา ({{X}})",
  NUM_HERBS: "จำนวนสมุนไพร",
  ADDED: "เพิ่มแล้ว",
  FORMULA_CREATED: "สร้างตำรับยาแล้ว",
  FORMULA_UPDATED: "อัปเดตตำรับยาแล้ว",
  POINT_GROUP_CREATED: "สร้างกลุ่มจุดฝังเข็มแล้ว",
  HERB_CREATED: "สร้างสมุนไพรแล้ว",
  HERB_UPDATED: "อัปเดตสมุนไพรแล้ว",
  UNDO: "เลิกทำ",
  REDO: "ทำซ้ำ",
  PLZ_INPUT_FORMULA_NAME_CN: "กรุณากรอกชื่อตำรับยาเป็นภาษาจีน",
  PLZ_INPUT_FORMULA_NAME_EN: "กรุณากรอกชื่อตำรับยาเป็นภาษาอังกฤษ",
  PLZ_INPUT_FORMULA_NAME_X: "กรุณากรอกชื่อตำรับยาเป็น{{X}}",
  PLZ_INPUT_PINYIN: "กรุณากรอกพินอิน",
  PLZ_INPUT_HERB_NAME_CN: "กรุณากรอกชื่อสมุนไพรเป็นภาษาจีน",
  PLZ_INPUT_HERB_NAME_EN: "กรุณากรอกชื่อสมุนไพรเป็นภาษาอังกฤษ",
  PLZ_INPUT_HERB_NAME_X: "กรุณากรอกชื่อสมุนไพรเป็น{{X}}",
};

const packagePages = {
  INCLUDES: "รวมถึง",
  INCLUDES_ALL_LOWER_AND: "รวมฟีเจอร์ระดับต่ำกว่าทั้งหมด และ",
  PP_PER_YEAR: "ต่อผู้ใช้ / ปี",
  PP_PER_MONTH: "ต่อผู้ใช้ / เดือน",
  PACKAGES: "แพ็กเกจ",
  EXPIRE_IN_X_DAYS: "หมดอายุใน {{X}} วัน",
  FOR_NEXT_X_DAYS: "สำหรับ {{X}} วันถัดไป",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE: "เลือกคลินิกสำหรับใช้แพ็กเกจ",
  NUMBER_OF_USER: "จำนวนผู้ใช้",
  SELECTED_PACKAGE: "แพ็กเกจที่เลือก",
  CURRENT_USER: "ผู้ใช้ปัจจุบัน",
  NEW_PACKAGE: "สมัครแพ็กเกจใหม่",
  NO_CLINIC_MEMBERS: "ไม่มีสมาชิกคลินิกที่ยังไม่มีแพ็กเกจ",
  ASSIGN_PACKAGE_TO_USER: "จัดสรรให้สมาชิกคลินิก",
  PER_EXIST_USER: "ต่อผู้ใช้ที่มีอยู่",
  PER_NEW_USER: "ต่อผู้ใช้ใหม่",
  NO_PACKAGES_FOUND: "ไม่พบแพ็กเกจ",
  EXTEND: "ขยาย",
  UPGRADE: "อัปเกรด",
  RENEW: "ต่ออายุ",
  PP: "ต่อผู้ใช้",
  SELECT_A_PACKAGE: "เลือกแพ็กเกจ",
  CHANGE: "เปลี่ยน",
  REASSIGN: "จัดสรรใหม่",
  ASSIGN: "จัดสรร",
  PURCHASE_PACKAGES: "ซื้อแพ็กเกจ",
  NO_PACKAGE: "ไม่มีแพ็กเกจ",
  EXPIRE_DATE: "วันหมดอายุ",
  MAX_USERS: "ผู้ใช้สูงสุด",
  TIME: "เวลา",
  PRICE: "ราคา",
  PAYMENT_HISTORY: "ประวัติการชำระเงิน",
  CHECK_YOUR_PAYMENT_HISTORY: "ตรวจสอบประวัติการชำระเงินของคุณ",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "แพ็กเกจนี้มีไว้สำหรับใช้งานส่วนบุคคล และจะถูกนำไปใช้กับบัญชีของคุณโดยตรงเมื่อเปิดใช้งาน",
  PURCHASE: "ซื้อ",
  SELECT_AVAILABLE_CLINIC_PACKAGE_FOR_YOUR_CLINIC:
    "เลือกแพ็กเกจที่คุณต้องการสำหรับคลินิกของคุณ",
  EXTEND_SELECTED_PACKAGE: "ขยายแพ็กเกจที่เลือก",
  UPGRADE_SELECTED_PACKAGE: "อัปเกรดแพ็กเกจที่เลือก",
  APPLY_THE_PACKAGE_TO_YOUR_CLINIC:
    "ใช้ / ปรับแต่งแพ็กเกจให้กับคลินิกของคุณ",
  MAKE_PAYMENT: "ชำระเงิน",
  MY_CLINICS: "คลินิกของฉัน",
  NOTE: "หมายเหตุ",
  ANY_CLINICS_MANAGED_BY_U_WILL_BE_AVAILABLE_BELOW:
    "คลินิกใด ๆ ที่คุณจัดการจะแสดงด้านล่าง",
  CURRENT_PURCHASED_USERS: "ผู้ใช้ที่ซื้อในปัจจุบัน",
  USERS: " ผู้ใช้",
  FOR_USERS_PACK: " ชุดผู้ใช้",
  EXTEND_TO: "ขยายเป็น",
  EXTEND_USERS_NUMBER_CANNOT_BE_EQUAL_OR_LESS_THAN_CURRENT_USER_NUMBER:
    "จำนวนผู้ใช้ที่ขยายต้องไม่น้อยกว่าหรือเท่ากับจำนวนผู้ใช้ปัจจุบัน",
  PLZ_CHECK_THE_NUMBER_OF_USERS: "กรุณาตรวจสอบจำนวนผู้ใช้",
  SYSTEM_WILL_DIRECT_U_BACK_PLS_WAIT: "ระบบกำลังเปลี่ยนเส้นทาง กรุณารอสักครู่...",
  PURCHASE_FOR: "ซื้อสำหรับ",
  IF_U_GOT_PROMOTION_CODE: "หากคุณมีรหัสโปรโมชัน",
  CLICK_HERE: "คลิกที่นี่",
  IF_U_GOT_PROMOTION_CODE_INPUT_IT_HERE:
    "หากคุณมีรหัสโปรโมชัน กรุณากรอกที่นี่",
  CURRENT_USERS_ASSIGNED_TO_THIS_PACKAGE:
    "ผู้ใช้ปัจจุบันที่ถูกจัดสรรให้แพ็กเกจนี้",
  PURCHASED_FOR: "ซื้อสำหรับ ",
  RENEW_SELECTED_PACKAGE: "ต่ออายุแพ็กเกจที่คุณเลือก",
  EXTEND_PACKAGE_FOR_YOUR_CLINIC: "ขยายแพ็กเกจสำหรับคลินิกของคุณ",
  UPGRADE_PACKAGE_FOR_YOUR_CLINIC: "อัปเกรดแพ็กเกจสำหรับคลินิกของคุณ",
  RENEW_PACKAGE_FOR_YOUR_CLINIC: "ต่ออายุแพ็กเกจสำหรับคลินิกของคุณ",
  EXTENDED_USER_PACK: "ชุดผู้ใช้ (หลังขยาย)",
  CURRENT_USER_PACK: "ชุดผู้ใช้ (ปัจจุบัน)",
  PAYMENT_UNAVAILABLE: "ไม่สามารถชำระเงินได้",
  PLS_OPEN_PAGE_OVER_HTTPS: "กรุณาเปิดหน้านี้ผ่าน HTTPS เพื่อชำระเงินอย่างปลอดภัย",
  CREATE_UR_CLINIC_NOW: "สร้างคลินิกของคุณ",
  NO_PACKAGE_SUBSCRIBED: "ไม่มีแพ็กเกจที่สมัครสมาชิก",
  BELONGS_TO: "เป็นของ",
  TO_ACCESS_FULL_HEALTHNEX_SERVICES_PLEASE_SELECT_A_PACKAGE_FOR_UR_CLINIC:
    "เลือกแพ็กเกจฟีเจอร์สำหรับคลินิกของคุณเพื่อปลดล็อกการเข้าถึง Healthnex แบบเต็มรูปแบบ",
  RENEW_UR_CLINIC_PACKAGE: "ต่ออายุแพ็กเกจคลินิกของคุณ",
  PACKAGE_ASSIGNED_BY_CLINIC_OWNER: "แพ็กเกจที่จัดสรรโดยเจ้าของคลินิกของคุณ",
  RENEW_UR_PERSONAL_PACKAGE: "ต่ออายุแพ็กเกจส่วนตัวของคุณ",
  FOR_PERSONAL: "สำหรับส่วนบุคคล",
  FOR_CLINIC: "สำหรับคลินิก",
  PURCHASE_FOR_MYSELF: "ซื้อสำหรับตัวฉันเอง",
  PURCHASE_FOR_CLINIC: "ซื้อสำหรับคลินิก",
  HEALTHNEX_IS_GOING_TO_CREATE_U_OWNED_CLINIC_PLS_PROVIDE_THE_ADDRESS:
    "Healthnex กำลังจะสร้างคลินิกของคุณ กรุณาระบุที่อยู่คลินิกเพื่อดำเนินการต่อ",
  CLINIC_ADDRESS: "ที่อยู่คลินิก",
  SORRY: "ขออภัย",
  FIND_UR_SUITABLE_PACKAGES: "ค้นหาแพ็กเกจที่เหมาะกับคุณ",
  ARE_U_LOOKING_TO_BUY_A_PERSONAL_PACKAGE_CLINIC_PACKAGE:
    "คุณกำลังมองหาที่จะซื้อแพ็กเกจส่วนบุคคลหรือแพ็กเกจคลินิก?",
  I_WANNA_BUY: "ฉันต้องการซื้อ",
  PERSONAL_WEBSITE_FOR_MYSELF: "เว็บไซต์ส่วนตัวสำหรับตัวฉันเอง",
  CLINIC_PACKAGE_FOR_MY_CLINIC: "บริการคลินิกสำหรับคลินิกของฉัน",
  HOW_MANY_USERS_PACK_U_WISH_TO_INCLUDE_IN_YOUR_PACKAGE:
    "คุณต้องการรวมผู้ใช้กี่รายในแพ็กเกจของคุณ?",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_INCLUDES_PERSONAL_WEBSITE:
    "สมาชิกคลินิกที่สามารถเข้าถึงการนัดหมายและใบสั่งยาโดยใช้ AI และรวมถึงเว็บไซต์ส่วนตัวด้วย",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_WITHOUT_INCLUDES_PERSONAL_WEBSITE:
    "สมาชิกคลินิกที่สามารถเข้าถึงการนัดหมายและใบสั่งยาโดยใช้ AI แต่ไม่รวมเว็บไซต์ส่วนตัว",
  WITHOUT_PERSONAL_WEBSITE: "ไม่รวมเว็บไซต์ส่วนตัว",
  INCLUDES_PERSONAL_WEBSITE: "รวมเว็บไซต์ส่วนตัว",
  ALL_CLINIC_PACKAGES: "แพ็กเกจคลินิกทั้งหมด",
  WHAT_FEATURES_U_WISH_TO_INCLUDE:
    "คุณต้องการรวมฟีเจอร์ใดบ้างในแพ็กเกจคลินิกของคุณ?",
  INCLUDES_X_USERS: "รวมผู้ใช้ {{X}} ราย",
  CUSTOM_USER_PACKS: "ชุดผู้ใช้แบบกำหนดเอง",
  THIS_PACKAGE_REQUIRES_TO_PURCHASE_AT_LEAST_X_USER_PACKS:
    "แพ็กเกจนี้ต้องซื้อชุดผู้ใช้อย่างน้อย {{X}} ชุด",
  SHORT_APPOINTMENT: "นัดหมาย",
  SHORT_PRESCRIPTION: "ใบสั่งยา",
  SHORT_PACKAGE: " แพ็ก",
  WEB: "เว็บ",
  X_YEARS: "{{X}} ปี",
  ADDONS_SERVICE_INCLUDED: "บริการเสริมที่เลือกได้",
  ADDON_SERVICE_SELECTED: "บริการเสริมที่เลือก",
  PER_MESSAGE: "ต่อข้อความ",
  ADD_ON_BILL_BASED_ON_UR_USAGE_CHARGE_WILL_BE_APPLIED_EVERY_X:
    "บริการเสริมนี้คิดค่าบริการตามการใช้งานของคุณ คุณสามารถใช้บริการได้ในแต่ละรอบบิล ({{X}}) และจะมีการเรียกเก็บค่าบริการเมื่อเริ่มรอบถัดไปตามการใช้งานในรอบก่อนหน้า",
  CONTINUE_USE_BILL_CHARGED_EVERY_X:
    "คุณจะถูกเรียกเก็บเงินเมื่อเริ่มต้นแต่ละรอบ ({{X}}) ตามการใช้งานในรอบก่อนหน้า",
  WEEKLY: "รายสัปดาห์",
  FORTNIGHTLY: "ทุกสองสัปดาห์",
  MONTHLY: "รายเดือน",
  QUARTERLY: "รายไตรมาส",
  BI_ANNUALLY: "ทุกครึ่งปี",
  ANNUALLY: "รายปี",
  ADDON_DETAIL: "รายละเอียดบริการเสริม",
  NEXT_BILLING_DATE: "เวลาเรียกเก็บเงินถัดไป",
  BILLING_CYCLE: "รอบการเรียกเก็บเงิน",
  ADDON_PRICE: "ราคาบริการเสริม",
  X_ADDONS_SERVICE_INCLUDED: "บริการเสริมที่เลือกได้ {{X}} รายการ",
  SELECT_BILLING_METHOD: "เลือกวิธีการเรียกเก็บเงิน",
  BILLING_METHOD: "วิธีการเรียกเก็บเงิน",
  TEMPORARILY_FREE: "ฟรีในขณะนี้",
  FIRST_YEAR_FREE: "ปีแรกฟรี",
  ON_PROMOTION: "อยู่ในช่วงโปรโมชัน",
  PROMOTION_END_DATE: "โปรโมชันสิ้นสุด",
  REGULAR_PRICE_RESUMES_ON_X: "ราคาปกติจะกลับมาในวันที่ {{X}}",
  SET_AS_DEFAULT: "ตั้งเป็นค่าเริ่มต้น",
  RECENTLY_USED: "ใช้ล่าสุด",
  USE_DIFFERENT_CARD: "ใช้บัตรอื่น",
  PAY_WITH_SAVED_CARD: "ใช้บัตรที่บันทึกไว้",
  CARD_HOLDER_NAME: "ชื่อผู้ถือบัตร",
  ENABLE_AUTO_RECHARGE: "เปิดใช้งานการต่ออายุอัตโนมัติ",
  CANCEL_AUTO_RECHARGE: "ยกเลิกการต่ออายุอัตโนมัติ",
  AUTO_RECHARGE_WHEN_SUBCRPTION_EXPIRED:
    "ต่ออายุโดยอัตโนมัติด้วยบัตรนี้เมื่อการสมัครสมาชิกของคุณหมดอายุ",
  SAVE_BELOW_CARD_DETAILS: "บันทึกบัตรนี้",
  STORE_CREDIT_CARD_SECURELY:
    "ข้อมูลบัตรของคุณจะถูกจัดเก็บอย่างปลอดภัยเพื่อการชำระเงินที่รวดเร็วขึ้นในครั้งถัดไป",
  ADDON_REQUIRES_SAVED_CARD:
    "คุณได้เลือกบริการเสริมที่ต้องมีการเรียกเก็บเงินแบบประจำ กรุณาบันทึกข้อมูลบัตรของคุณเพื่อให้เราสามารถเรียกเก็บเงินในแต่ละรอบบิลโดยอัตโนมัติ",
  DETECT_U_HAVE_A_SAVED_CARD_THIS_CARD_DETAIL_WILL_BE_SAVE_AND_REPLACE_THAT_CARD_DETAIL:
    "เราพบบัตรที่บันทึกไว้ บัตรนี้จะแทนที่บัตรเดิมหลังการชำระเงิน",
  ARE_YOU_SURE_TO_CANCEL_AUTO_RECHARGE:
    "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการต่ออายุอัตโนมัติ?",
  U_CAN_ENABLE_AUTO_RECHARGE_LATER:
    "คุณสามารถเปิดใช้งานการต่ออายุอัตโนมัติได้ในภายหลัง",
  AUTO_RECHARGE_HAS_BEEN_ENABLED: "เปิดใช้งานการต่ออายุอัตโนมัติแล้ว",
  AUTO_RECHARGE_HAS_BEEN_CANCELLED: "ยกเลิกการต่ออายุอัตโนมัติแล้ว",
  AUTO_RECHARGE: "การต่ออายุอัตโนมัติ",
  HAS_ENABLED: "เปิดใช้งานแล้ว",
  NOT_ENABLED: "ยังไม่ได้เปิดใช้งาน",
};

const cmasaImport = {
  IMPORT_CLINICS: "นำเข้าคลินิก",
  CLINICS_FOUND_IN_X: "พบคลินิกใน {{X}}",
  NO_CLINIC_FOUND: "ไม่พบคลินิก",
  CLINICS_IMPORTED_FROM_X: "คลินิกที่นำเข้าจาก {{X}}",
  NO_CLINIC_IMPORTED: "ไม่มีคลินิกที่นำเข้า",
  DELETE: "ลบ",
  CONFIRM: "ยืนยัน",
  ARE_YOU_SURE_TO_DELETE_X: "คุณแน่ใจหรือไม่ว่าต้องการลบ {{X}}?",
  THIS_ACTION_CANNOT_BE_UNDONE: "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  IMPORT_CLINIC: "นำเข้าคลินิก",
  UPDATE_CLINIC: "อัปเดตคลินิก",
  UPLOAD_AVATAR: "อัปโหลดรูปโปรไฟล์",
  REUPLOAD_PROFILE_IMAGE: "อัปโหลดรูปโปรไฟล์ใหม่",
  CLICK_TO_UPLOAD: "คลิกเพื่ออัปโหลด",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมด",
  PLEASE_ENTER_VALID_EMAIL: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
  PLEASE_ENTER_SAME_PASSWORD: "กรุณากรอกรหัสผ่านให้ตรงกัน",
  SIGN_UP_SUCCESS: "ลงทะเบียนสำเร็จ",
  CLINIC_EXISTS: "คลินิกนี้มีอยู่แล้ว",
  NEXT_STEP: "ขั้นตอนถัดไป",
  SAME_WITH_ORG_PASSWORD: "เหมือนกับรหัสผ่านเดิม",
  PROFILE_IMG: "รูปโปรไฟล์",
  I_CHANGED_MY_MIND: "ฉันเปลี่ยนใจ",
  ADDING: "รอการสร้าง",
  JOINING: "รอการเข้าร่วม",
  OR: "หรือ",
  SKIP: "ข้าม",
  GUIDED_SAVE_AND_SKIP_OPTIONAL: "บันทึกและข้ามส่วนที่ไม่บังคับ",
  JOIN: "เข้าร่วม",
  SAVE_CONFIRM: "ยืนยันการบันทึก",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO:
    "คุณแน่ใจหรือไม่ว่าต้องการส่งข้อมูลคลินิกและยินยอมให้สร้างคลินิก?",
  FOUND_RELEVANT_CLINICS:
    "เราพบคลินิกบางแห่งในระบบ Healthnex ที่อาจเกี่ยวข้องกับคลินิกนี้",
  JOIN_OR_SKIP_CLINIC_GUIDE:
    "คุณสามารถคลิก เข้าร่วม เพื่อขอเข้าร่วมหนึ่งในนั้นได้ หากคุณไม่แน่ใจหรือไม่พบคลินิกที่ถูกต้อง คุณสามารถคลิก ข้าม และเลือกจัดการเรื่องนี้ในภายหลังได้",
  NEED_TO_ADD_CLINIC: "คุณต้องการเพิ่มคลินิกนี้ลงในระบบ Healthnex ของเราหรือไม่?",
  ADD_CLINIC_DESCRIPTION:
    "คลิก เพิ่ม เพื่อดำเนินการต่อ คุณจะกลายเป็นเจ้าของคลินิก โดยสามารถเชิญหรือนำสมาชิกออกได้ คุณยังสามารถโอนสิทธิ์ความเป็นเจ้าของให้สมาชิกคลินิกคนอื่นได้ในภายหลัง หากคุณไม่แน่ใจหรือยังไม่ต้องการเพิ่มในตอนนี้ ให้คลิก ข้าม และกลับมาดำเนินการในภายหลัง",
  CLINIC_RESULT_TITLE: "ผลลัพธ์สำหรับคลินิกนี้",
  CLINIC_SKIPPED_MSG:
    "คลินิกนี้ถูกข้ามแล้ว คุณจะไม่เข้าร่วมคลินิกที่มีอยู่และจะไม่เพิ่มเป็นคลินิกใหม่",
  CLINIC_NOT_LISTED: "คลินิกที่ฉันต้องการเข้าร่วมไม่ได้อยู่ในรายการข้างต้น",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE:
    "ฉันไม่ต้องการใช้ข้อมูลคลินิกข้างต้น",
  PREVIOUS_CLINIC: "คลินิกก่อนหน้า",
  NEXT_CLINIC: "คลินิกถัดไป",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนใจ? การกระทำนี้จะรีเซ็ตการตั้งค่าที่คุณทำไว้สำหรับคลินิกนี้",
};

const camera = {
  FOR_PATIENT: "สำหรับผู้ป่วย {{name}}",
  UPLOAD_PHOTO_LABEL: "อัปโหลด",
  TAKE_PHOTO: "ถ่ายรูป",
  OR_CHOOSE_FROM_ALBUM: "หรือเลือกจากอัลบั้ม",
  CHOOSE_PHOTO: "เลือกรูปภาพ",
  PREVIEW: "ดูตัวอย่าง",
  DISCONNECTED_TITLE: "การเชื่อมต่อขาดหาย / ลิงก์หมดอายุ",
  DISCONNECTED_BODY:
    "ลิงก์อัปโหลดรูปภาพนี้หมดอายุหรือถูกปิดแล้ว กรุณาสร้าง QR Code หรือลิงก์ใหม่",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "คลิกและอัปโหลดด้วยโทรศัพท์ของคุณ",
  CLICK_AND_RECORD_WITH_YOUR_PHONE:
    "คลิกและเชื่อมต่อกับโทรศัพท์ของคุณเพื่อบันทึก",
  CLICK_AND_USE_YOUR_PHONE: "คลิกและใช้โทรศัพท์ของคุณเพื่อบันทึก",
  SCAN_TO_CONNECT: "",
  CAMERA_TOKEN_EXPIRED: "โทเค็นกล้องหมดอายุแล้ว",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "สแกน QR Code เพื่อเชื่อมต่อ เมื่อเชื่อมต่อแล้ว โทรศัพท์ของคุณจะยังคงเชื่อมต่ออยู่ในทุกหน้า",
};

const Library = {
  MEDICAL_PUBLICATIONS: "สิ่งพิมพ์ทางการแพทย์",
  SEARCH_MEDICAL_PUBLICATIONS: "ค้นหาสิ่งพิมพ์ทางการแพทย์",
  SEARCH_PUBLICATION_BY_NAME: "ค้นหาสิ่งพิมพ์ด้วยชื่อ",
  RECENT: "ล่าสุด",
  LIBRARY: "คลังความรู้",
  NO_PUBLICATIONS_FOUND: "ไม่พบสิ่งพิมพ์",
  NO_RECENT_PUBLICATIONS: "ไม่มีสิ่งพิมพ์ล่าสุด",
  NO_PUBLICATIONS_IN_LIBRARY: "ไม่มีสิ่งพิมพ์ในคลังความรู้",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "ค้นหาสิ่งพิมพ์ทางการแพทย์ในแถบค้นหา หรือเยี่ยมชมคลังความรู้ของเรา",
  JUST_NOW: "เมื่อสักครู่",
  RECENT_X_MINUTES: "{{x}} นาทีที่ผ่านมา",
  RECENT_X_HOURS: "{{x}} ชั่วโมงที่ผ่านมา",
  RECENT_X_DAYS: "{{x}} วันที่ผ่านมา",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "เพิ่มหนังสือเล่มนี้ในรายการโปรดของคุณ",
  CHAPTERS: "บท",
  BOOKMARK: "ที่คั่นหนังสือ",
  ADD_BOOKMARK: "เพิ่มที่คั่นหนังสือ",
  FULL_SCREEN: "เต็มหน้าจอ",
  TEXT_SIZE: "ขนาดข้อความ",
  NEXT_PAGE: "หน้าถัดไป",
  PREVIOUS_PAGE: "หน้าก่อนหน้า",
  FONT_SIZE: "ขนาดตัวอักษร",
  SMALL: "เล็ก",
  MEDIUM: "กลาง",
  LARGE: "ใหญ่",
  BOOKS_MANAGEMENT: "การจัดการหนังสือ",
  SAVE_BOOK: "หนังสือที่บันทึก",
  READER: "โปรแกรมอ่าน",
  REGULAR: "ปกติ",
  SEARCH_FOR_PUBLICATIONS: "ค้นหาด้วยชื่อเรื่องหรือผู้แต่ง",
  ERROR_BOOKINGS: "การนัดหมายที่ผิดพลาด",
  TIP: "เคล็ดลับ",
  ERROR_BOOKINGS_USUALLY_BECUZ_THE_WORKING_DURATION_HAS_CHANGED_OVER_TIME_AFTER_THE_APPOINTMENT_HAS_BEEN_CREATED_EARLIER:
    "การนัดหมายที่ไม่ถูกต้องมักเกิดจากการเปลี่ยนแปลงเวลาทำงานก่อนที่จะสร้างการนัดหมาย คุณยังสามารถดำเนินการตรวจรักษาต่อ หรือเลื่อนนัดเวลาใหม่ให้ผู้ป่วยได้",
};

const bookingPage = {
  BOOK_DOCTOR: "จองแพทย์",
  BOOKING_A_DOCTOR: "กำลังจองแพทย์",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "ค้นหาด้วยชื่อแพทย์ ประเภทบริการ หรือรหัสไปรษณีย์ของเขต",
  BY: "โดย ",
  SERVICE_TYPE: "ประเภทบริการ",
  PLEASE_SELECT_SERVICE_TYPE: "กรุณาเลือกประเภทบริการอย่างน้อยหนึ่งรายการ",
  SEARCH_BY_PRACTITIONER_NAME: "ค้นหาด้วยชื่อแพทย์",
  SEARCHING_PRACTITIONERS: "กำลังค้นหาแพทย์",
  NO_SERVICE_LISTED: "ไม่มีบริการที่แสดง",
  BOOK: "จอง",
  WEBSITE: "เว็บไซต์",
  PUBLISH_WEBSITE: "เผยแพร่เว็บไซต์",
  JOIN: "เข้าร่วม",
  AND_X_PRACTITIONERS_MORE: "และแพทย์อีก {{X}} คน...",
  MEDICINE_TREATMENT: "การรักษาด้วยยาจีน",
  ACUPUNCTURE_TREATMENT: "การรักษาด้วยการฝังเข็ม",
  MASSAGE_TREATMENT: "การรักษาด้วยการนวด",
  REMEDIAL_MASSAGE_TREATMENT: "การรักษาด้วยการนวดบำบัด",
  NO_RELEVANT_PRACTITIONERS_FOUND: "ไม่พบแพทย์ที่เกี่ยวข้อง",
  NO_SERVICES_LISTED: "ไม่มีบริการที่แสดง",
  BOOK_THIS_PRACTITIONER: "จองแพทย์รายนี้",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET:
    "แพทย์รายนี้ยังไม่ได้ลงทะเบียน",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "เผยแพร่เว็บไซต์โปรไฟล์แพทย์",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "ดูเว็บไซต์โปรไฟล์แพทย์",
  NO_WORKING_CLINIC: "ไม่มีคลินิกที่ทำงาน",
  AND_X_MORE_CLINIC: "และคลินิกอีก {{X}} แห่ง",
  CHOOSE_CLINIC: "เลือกคลินิก",
  CHOOSE_CLINIC_DESCRIPTION: "กรุณาเลือกคลินิกที่คุณต้องการเข้ารับบริการ",
  CHOOSE_SERVICE: "เลือกบริการ",
  CHOOSE_SERVICE_DESCRIPTION: "เลือกบริการที่คุณต้องการจองนัดหมาย",
  PICK_APPOINTMENT_DATE: "เลือกวันที่นัดหมาย",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "เลือกวันที่/เวลานัดหมายของคุณ",
  MORNING: "ช่วงเช้า",
  AFTERNOON: "ช่วงบ่าย",
  PATIENT_INFO_DESCRIPTION: "กรุณากรอกข้อมูลผู้ป่วย",
  CONFIRM_DESCRIPTION: "กรุณายืนยันรายละเอียดการนัดหมาย",
  SUBMIT_APPOINTMENT: "ส่งการนัดหมาย",
  PREV: "ก่อนหน้า",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY:
    "สร้างการนัดหมายของคุณสำเร็จแล้ว",
  CREATE_BOOKING: "สร้างการจอง",
  TOMORROW: "พรุ่งนี้",
  TODAY: "วันนี้",
  IS_ALREADY_BOOKED: "ถูกจองโดยผู้อื่นแล้ว",
  TIME_ALREADY_BOOKED: "เวลานี้ถูกจองแล้ว",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "การจองนี้ทำให้เกิดการจองเกิน แต่เนื่องจากสร้างโดยคุณ (แพทย์) ระบบจะอนุมัติโดยอัตโนมัติ",
  ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
    "คุณแน่ใจหรือไม่ว่าต้องการจองเวลานี้?",
  BACK_TO_HOME: "ปิดหน้า",
  INVITATION_LINK_EXPIRED: "ลิงก์คำเชิญหมดอายุ",
  INVITATION_LINK_EXPIRED_DESC:
    "ลิงก์คำเชิญนี้ใช้งานไม่ได้แล้ว กรุณาขอให้เจ้าของคลินิกส่งคำเชิญใหม่ให้คุณ",
  EXISTING_PATIENT: "ผู้ป่วยเดิม",
  START_WITH_NEW_PATIENT: "เริ่มต้นด้วยผู้ป่วยใหม่",
  BACK_TO_EXISTING_PATIENT: "กลับไปยังผู้ป่วยเดิม",
  NEW_PATIENT: "ผู้ป่วยใหม่",
  ARE_U_LOOKING_FOR: "👀 คุณกำลังมองหา",
  SELECTED_PATIENT: "ผู้ป่วยที่เลือก",
  ALL_GOOD: "เรียบร้อยดี",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW:
    "กรุณาดูรายละเอียดการนัดหมายด้านล่าง",
  VIEW_DETAIL: "ดูรายละเอียด",
  SELECTED_FROM_OUTSIDE_TIMESLOT: "เลือกจากตารางเวลา",
  BOOK_TIMESLOT: "จองช่วงเวลานี้",
  INVALID_DOB: "วันเกิดไม่ถูกต้อง",
  AGREED_TO_SEND_APPOINTMENT_SMS_TO_PATIENT:
    "ฉันยินยอมให้ส่ง SMS / อีเมลแจ้งเตือนการนัดหมายไปยังผู้ป่วย",
  CONFIGURE_UR_PROVIDED_SERVICES: "ตั้งค่าบริการที่คุณให้",
  NOT_AVAILABLE_FOR_BOOKING: "ไม่พร้อมให้จอง",
  BOOKED_ENABLED_ONLY: "เฉพาะที่เปิดให้จองเท่านั้น",
  PLEASE_SELECT_EXISTING_PATIENT:
    "กรุณาเลือกผู้ป่วยเดิมเพื่อดำเนินการนัดหมาย",
  THIS_FEATURE_REQUIRED_PRESCRIPTION_PACKAGE:
    "ขออภัย ฟีเจอร์บันทึกผู้ป่วยไม่พร้อมใช้งานในแพ็กเกจปัจจุบันของคุณ",
  PLEASE_CONSIDER_UPGRADE_YOUR_PACKAGE_OR_CONTINUE_WITH_NEW_PATIENT:
    "หากคุณต้องการเข้าถึงฟีเจอร์นี้ กรุณาติดต่อเจ้าของคลินิกเพื่ออัปเกรดแพ็กเกจของคุณ หรือดำเนินการจองผู้ป่วยใหม่ต่อไป",
  U_SELECTED_A_PAST_TIMESLOT: "เลือกช่วงเวลาที่ผ่านมาแล้ว",
  U_SELECTED_A_PAST_TIMESLOT_NO_SMS_WILL_BE_SENT:
    "คุณได้เลือกช่วงเวลาที่ผ่านมาแล้ว จะไม่มีการส่ง SMS แจ้งเตือน",
  ANY_RECOMMENDED_PATIENTS_FROM_EXISTING_WILL_BE_SHOWN_HERE:
    "ผู้ป่วยที่แนะนำตามผู้ป่วยที่คุณบันทึกไว้ในระบบแล้วจะแสดงที่นี่",
  PICK_APPOINTMENT_PRACTITIONER: "เลือกแพทย์สำหรับ",
  PICK_APPOINTMENT_PRACTITIONER_END: "",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "เลือกแพทย์",
  RESELECT_APPOINTMENT_DATE: "เลือกวันที่นัดหมายใหม่",
  RESELECT_PRACTITIONER: "เลือกแพทย์ใหม่",
  AVAILABLE_PRACTITIONERS: "แพทย์ที่ว่าง",
  DESELECT_CHINESE_MEDICINE_FIRST: "กรุณายกเลิกการเลือกยาจีนก่อน",
  DESELECT_PRODUCTS_FIRST: "กรุณายกเลิกการเลือกผลิตภัณฑ์ที่เลือกไว้ก่อน",
  NUMBER_OF_PEOPLE: "จำนวนคน",
  PERSON: "คน",
  PEOPLE: "คน",
  ENTER_PATIENT_INFORMATION: "กรอกข้อมูลผู้ป่วย",
  IS_THIS_PERSON_NEW_PATIENT: "นี่เป็นการมาครั้งแรกที่คลินิกนี้หรือไม่?",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "เคล็ดลับ: เมื่อใกล้ถึงเวลานัดหมาย ระบบจะส่ง SMS แจ้งเตือนไปยังคุณ",
  NO_AVAILABLE_PRACTITIONERS: "ไม่พบแพทย์ที่ว่างในวันนี้",
  ORR: "หรือ",
  CONFIRM_APPOINTMENT_DESCRIPTION:
    "กรุณาตรวจสอบรายละเอียดการนัดหมายก่อนยืนยันการจองของคุณ",
  PICK_APPOINTMENT_TIME: "เลือกเวลานัดหมาย",
  PRODUCTS: "ผลิตภัณฑ์บริการ",
  I_AM_A_NEW_PATIENT: "ฉันเป็นผู้ป่วยใหม่",
  SEARCH_EXISTING_PATIENT: "ค้นหาผู้ป่วยเดิม",
  DESELECT_ALL: "ยกเลิกการเลือก",
  SERVICES_ITEM: "รายการบริการ",
  X_BED_NUM: "{{X}} เตียง",
  NEW_TO_THIS_CLINIC: "นี่เป็นการมาครั้งแรกของฉันที่คลินิกนี้",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT:
    "ระบบจะส่งอีเมลยืนยันไปยังผู้ป่วย",
};

const guide = {
  WE_FIRST_GO_TO_CLINIC_MANAGEMENT_PAGE:
    "ก่อนอื่นเราไปที่หน้าการจัดการสมาชิกคลินิก",
  CLICK_ON_THIS: "คลิกที่ปุ่มนี้",
  CREATE_A_NEW_CLINIC_BY_COMPLETE_THE_ESSENTIAL_INFORMATION:
    "กรอกข้อมูลที่จำเป็นของคลินิกของคุณ",
  SUBMIT_YOUR_CLINIC_INFORMATION:
    "ส่งข้อมูลคลินิกของคุณ จากนั้นคลินิกของคุณจะถูกสร้างขึ้น",
  IF_U_RECEIVE_CLINIC_INVITATION: "หากคุณได้รับคำเชิญเข้าร่วมคลินิก",
  ANY_INVITATION_WILL_BE_SHOWN_HERE_U_CAN_ACCEPT_OR_REJECT_THE_INVITATION:
    "คำเชิญเข้าร่วมคลินิกใด ๆ จะแสดงที่นี่ คุณสามารถเลือกยอมรับหรือปฏิเสธคำเชิญได้",
  IF_U_WISH_TO_JOIN_A_CLINIC: "หากคุณต้องการเข้าร่วมคลินิก",
  SEARCH_THE_CLINIC_NAME_U_WISH_TO_JOIN:
    "ค้นหาชื่อคลินิกที่คุณต้องการเข้าร่วม",
  DONE: "เสร็จสิ้น",
  START_GUIDE: "เริ่มคู่มือ",
  USER_GUIDE: "คู่มือวิดีโอ",
  GUIDE: "คู่มือ",
  NEED_HELP: "ต้องการความช่วยเหลือ?",
  CONTACT_SUPPORT: "ติดต่อฝ่ายสนับสนุน",
  VIEW_USER_GUIDE: "ดูคู่มือวิดีโอ",
  CLINIC_MANAGEMENT_GUIDE: "คู่มือการจัดการคลินิก",
  CLINIC_MANAGEMENT_DESCRIPTION:
    "คู่มือนี้จะแนะนำคุณเกี่ยวกับวิธีและสถานที่ในการสร้างและเข้าร่วมคลินิก",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE: "คู่มือใบสั่งยาและบันทึกการรักษา",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE_DESCRIPTION:
    "คู่มือนี้จะแนะนำคุณเกี่ยวกับวิธีและสถานที่ในการสร้างผู้ป่วยและใบสั่งยา",
  APPOINTMENT_GUIDE: "คู่มือการนัดหมาย",
  MANAGE_UR_APPOINTMENTS_GUIDE_DESCRIPTION:
    "คู่มือนี้จะแนะนำคุณเกี่ยวกับวิธีและสถานที่ในการจัดตารางเวลาทำงานและการนัดหมาย",
  MORE_GUIDES_ON_THE_WAY: "มีคู่มือเพิ่มเติมกำลังจะมา",
};

const patientConsent = {
  PATIENT_CONSENT: "ความยินยอมของผู้ป่วย",
  CONSENT_TITLE_1: "การรักษา",
  CONSENT_DESCRIPTION_1: "ฉันเข้าใจว่าการรักษาที่ {{X}} อาจรวมถึง:",
  CONSENT_ITEM_1: "การฝังเข็มด้วยเข็มปลอดเชื้อชนิดใช้ครั้งเดียว ",
  CONSENT_ITEM_2: "การรมยา การครอบแก้ว หรือการขูดผิว (กัวซา) ",
  CONSENT_ITEM_3:
    "ยาสมุนไพรจีน (ยาต้ม ผงยา ยาเม็ด หรือยาสกัด) ",
  CONSENT_ITEM_4:
    "คำแนะนำด้านการใช้ชีวิตและโภชนาการตามหลักการแพทย์แผนจีน ",
  CONSENT_TITLE_2: "ความเสี่ยงและผลข้างเคียง ",
  CONSENT_DESCRIPTION_2:
    "ฉันเข้าใจว่าแม้จะมีการดูแลอย่างเหมาะสมทุกประการ แต่อาจเกิดผลข้างเคียงเล็กน้อยได้ ซึ่งรวมถึง: ",
  CONSENT_ITEM_5: "รอยฟกช้ำ เลือดออก หรืออาการเจ็บเล็กน้อยหลังการฝังเข็ม ",
  CONSENT_ITEM_6: "อาการเวียนศีรษะหรืออ่อนเพลียชั่วคราว ",
  CONSENT_ITEM_7:
    "การเปลี่ยนแปลงของระบบย่อยอาหารเล็กน้อยหรืออาการแพ้จากยาสมุนไพร ",
  CONSENT_ITEM_8: "รอยแดงหรือรอยช้ำชั่วคราวจากการครอบแก้วหรือการขูดผิว (กัวซา) ",
  CONSENT_ITEM_9: "อาการไม่พึงประสงค์ที่รุนแรงพบได้น้อยมาก ",
  CONSENT_TITLE_3: "การเปิดเผยข้อมูลและความปลอดภัย ",
  CONSENT_DESCRIPTION_3: "ฉันได้แจ้งแพทย์ของฉันเกี่ยวกับ: ",
  CONSENT_ITEM_10: "ภาวะทางการแพทย์หรืออาการแพ้ในปัจจุบัน ",
  CONSENT_ITEM_11: "สถานะการตั้งครรภ์ (ถ้ามี) ",
  CONSENT_ITEM_12: "ยาหรืออาหารเสริมที่ฉันใช้อยู่ในปัจจุบัน ",
  CONSENT_DESCRIPTION_4:
    "ฉันเข้าใจว่าการรักษาด้วยแพทย์แผนจีนไม่สามารถทดแทนการดูแลทางการแพทย์ฉุกเฉินได้ ",
  CONSENT_DESCRIPTION_5:
    "ข้อมูลส่วนบุคคลและข้อมูลสุขภาพของฉันจะได้รับการจัดการตามกฎหมายความเป็นส่วนตัวของออสเตรเลีย",
  CONSENT_TITLE_4: "ความยินยอมและการรับทราบ",
  CONSENT_ITEM_13:
    "ฉันได้อ่านและเข้าใจข้อมูลข้างต้นแล้ว ฉันมีโอกาสซักถามและได้รับคำตอบจนเป็นที่พอใจทุกประการ ",
  CONSENT_ITEM_14:
    "ฉันยินยอมโดยสมัครใจที่จะรับการรักษาด้วยแพทย์แผนจีนและ/หรือการฝังเข็มจากแพทย์ที่ {{X}}",
  DRAW_YOUR_SIGNATURE: "วาดลายเซ็นของคุณ",
  SIGNATURE_UPLOADED: "อัปโหลดลายเซ็นแล้ว",
  CONSENT_SIGN_SUCCESS:
    "คุณได้ลงนามแบบฟอร์มความยินยอมในการรักษาเรียบร้อยแล้ว กรุณาดำเนินการตรวจรักษาต่อไป!",
};

const agreements = {
  PRIVACY_POLICY_TITLE: "นโยบายความเป็นส่วนตัวของ HEALTHNEX",
  PRIVACY_POLICY_EFFECTIVE_DATE:
    "วันที่มีผลบังคับใช้: นโยบายความเป็นส่วนตัวนี้มีผลตั้งแต่วันที่ผู้ใช้ลงทะเบียนเป็นครั้งแรกและใช้แพลตฟอร์ม Healthnex",
  PRIVACY_POLICY_SECTION_OVERVIEW_TITLE: "1. ภาพรวม",
  PRIVACY_POLICY_SECTION_OVERVIEW_CONTENT:
    "Healthnex ให้ความสำคัญและมุ่งมั่นที่จะปกป้องความเป็นส่วนตัวของผู้ใช้และผู้ป่วยของพวกเขา นโยบายความเป็นส่วนตัวนี้อธิบายถึงวิธีที่เรารวบรวม ใช้ จัดเก็บ และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลด้านสุขภาพตามกฎหมายความเป็นส่วนตัวปี 1988 (Cth) และหลักการความเป็นส่วนตัวของออสเตรเลีย (APP)",
  PRIVACY_POLICY_SECTION_COLLECT_TITLE: "2. ข้อมูลที่เรารวบรวม",
  PRIVACY_POLICY_COLLECT_USER_INFO:
    "ข้อมูลผู้ใช้: ชื่อ รายละเอียดการติดต่อ ข้อมูลการลงทะเบียนมืออาชีพ ข้อมูลคลินิก และรายละเอียดการเข้าสู่ระบบบัญชี",
  PRIVACY_POLICY_COLLECT_PATIENT_INFO: "ข้อมูลผู้ป่วย: เวชระเบียน ข้อมูลการนัดหมาย ข้อมูลใบสั่งยา และข้อมูลสุขภาพอื่น ๆ",
  PRIVACY_POLICY_COLLECT_TECH_INFO: "ข้อมูลทางเทคนิค: ที่อยู่ IP ข้อมูลอุปกรณ์ และบันทึกของระบบ",
  PRIVACY_POLICY_SECTION_USAGE_TITLE: "3. วัตถุประสงค์ของการรวบรวม",
  PRIVACY_POLICY_USAGE_PLATFORM: "การจัดหาและบำรุงรักษาแพลตฟอร์ม Healthnex;",
  PRIVACY_POLICY_USAGE_ACCOUNT: "การจัดการบัญชีผู้ใช้และการดำเนินงานของคลินิก",
  PRIVACY_POLICY_USAGE_SECURITY: "การสนับสนุนทางเทคนิค ความปลอดภัยของระบบ และการปฏิบัติตามข้อกำหนด;",
  PRIVACY_POLICY_USAGE_LEGAL: "วัตถุประสงค์อื่นตามที่กฎหมายและข้อบังคับที่เกี่ยวข้องกำหนด",
  PRIVACY_POLICY_SECTION_HEALTH_INFO_TITLE: "4. ข้อมูลสุขภาพ",
  PRIVACY_POLICY_HEALTH_INFO_DESCRIPTION:
    "ข้อมูลสุขภาพจัดเป็นข้อมูลที่ละเอียดอ่อน Healthnex ทำหน้าที่เป็นผู้ประมวลผลข้อมูลเท่านั้น และประมวลผลข้อมูลด้านสุขภาพของผู้ป่วยตามคำแนะนำของผู้ใช้ซึ่งทำหน้าที่เป็นผู้ควบคุมข้อมูลเท่านั้น",
  PRIVACY_POLICY_SECTION_DISCLOSURE_TITLE: "5. การเปิดเผยข้อมูล",
  PRIVACY_POLICY_DISCLOSURE_DESCRIPTION:
    "เราไม่เปิดเผยข้อมูลส่วนบุคคลหรือสุขภาพแก่บุคคลที่สาม เว้นแต่กฎหมายกำหนดหรือได้รับอนุญาตจากผู้ใช้ บริการด้านเทคนิคบางอย่าง (เช่น บริการคลาวด์และบริการอีเมล) อาจเกี่ยวข้องกับการประมวลผลของบุคคลที่สามที่ได้รับการควบคุม",
  PRIVACY_POLICY_SECTION_SECURITY_TITLE: "6. ความปลอดภัยของข้อมูล",
  PRIVACY_POLICY_SECURITY_DESCRIPTION:
    "เราใช้มาตรการทางเทคนิคและองค์กรที่เหมาะสมเพื่อปกป้องความปลอดภัยของข้อมูล รวมถึงการควบคุมการเข้าถึง การเข้ารหัส และกลไกการตรวจสอบ",
  PRIVACY_POLICY_SECTION_RETENTION_TITLE: "7. การเก็บรักษาข้อมูล",
  PRIVACY_POLICY_RETENTION_DESCRIPTION: "ข้อมูลจะถูกเก็บรักษาหรือลบตามข้อกำหนดทางกฎหมายและความต้องการทางธุรกิจ",
  PRIVACY_POLICY_SECTION_RIGHTS_TITLE: "8. สิทธิ์ของผู้ใช้",
  PRIVACY_POLICY_RIGHTS_DESCRIPTION:
    "ผู้ใช้มีสิทธิ์ขอเข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคลของตน โดยอยู่ภายใต้ข้อจำกัดทางกฎหมาย",
  PRIVACY_POLICY_SECTION_BREACH_TITLE: "9. การละเมิดข้อมูล",
  PRIVACY_POLICY_BREACH_DESCRIPTION:
    "ในกรณีที่มีการละเมิดข้อมูลที่ต้องแจ้ง เราจะปฏิบัติตามโครงการการละเมิดข้อมูลที่สามารถแจ้งเตือนได้ของออสเตรเลีย (NDB)",
  PRIVACY_POLICY_SECTION_CONTACT_TITLE: "10. ติดต่อเรา",
  PRIVACY_POLICY_CONTACT_DESCRIPTION:
    "สำหรับการสอบถามเกี่ยวกับความเป็นส่วนตัว โปรดติดต่อ Healthnex ผ่านช่องทางการสนับสนุนอย่างเป็นทางการ",
  IF_ANY_SENSITIVE_RELATED_QUESTION_PLS_CONTACT_HEALTHNEX:
    "สำหรับการสอบถามเกี่ยวกับความเป็นส่วนตัว โปรดติดต่อ Healthnex ผ่านช่องทางการสนับสนุนอย่างเป็นทางการ",
  DATA_PROCESSING_ADDENDUM: "ภาคผนวกการประมวลผลข้อมูล",
  DPA_TITLE: "ภาคผนวกการประมวลผลข้อมูล HEALTHNEX",
  DPA_SUB_TITLE: "(ภาคผนวกการประมวลผลข้อมูล DPA)",
  DPA_INTRO: "ภาคผนวกการประมวลผลข้อมูลนี้เป็นส่วนหนึ่งของ Healthnex ข้อกำหนดการใช้งานแพลตฟอร์ม",
  DPA_SECTION_ROLES_TITLE: "1. บทบาท",
  DPA_ROLE_USER: "ผู้ใช้: ผู้ควบคุมข้อมูล",
  DPA_ROLE_HEALTHNEX: "Healthnex: ผู้ประมวลผลข้อมูล",
  DPA_SECTION_SCOPE_TITLE: "2. ขอบเขตการประมวลผล",
  DPA_SCOPE_DESCRIPTION:
    "Healthnex ประมวลผลข้อมูลส่วนบุคคลและข้อมูลสุขภาพเฉพาะในขอบเขตที่จำเป็นเพื่อให้บริการแพลตฟอร์มและปฏิบัติตามคำแนะนำของผู้ใช้อย่างเคร่งครัด",
  DPA_SECTION_DATA_TYPE_TITLE: "3. ประเภทข้อมูล",
  DPA_DATA_TYPE_DESCRIPTION: "ข้อมูลที่ประมวลผลรวมถึงแต่ไม่จำกัดเพียง:",
  DPA_DATA_TYPE_PATIENT_INFO: "ข้อมูลสุขภาพของผู้ป่วย",
  DPA_DATA_TYPE_APPOINTMENT_RECORD: "ข้อมูลการนัดหมายและเวชระเบียน",
  DPA_DATA_TYPE_USER_ACCOUNT: "ข้อมูลบัญชีผู้ใช้",
  DPA_SECTION_SECURITY_TITLE: "4. ความปลอดภัยของข้อมูล",
  DPA_SECURITY_DESCRIPTION:
    "Healthnex จะใช้มาตรการทางเทคนิคและความปลอดภัยขององค์กรที่เหมาะสมเพื่อปกป้องข้อมูลจากการเข้าถึง การเปิดเผย หรือการสูญหายโดยไม่ได้รับอนุญาต",
  DPA_SECTION_SUBPROCESSORS_TITLE: "5. การประมวลผลย่อย",
  DPA_SUBPROCESSORS_DESCRIPTION:
    "Healthnex อาจมีส่วนร่วมกับผู้ให้บริการบุคคลที่สามที่เชื่อถือได้ (เช่น โครงสร้างพื้นฐานคลาวด์หรือ AI ผู้ให้บริการ) ผู้ประมวลผลย่อยทั้งหมดอยู่ภายใต้ภาระหน้าที่ในการรักษาความลับและการปกป้องข้อมูล",
  DPA_SECTION_BREACH_RESPONSE_TITLE: "6. การตอบสนองการละเมิดข้อมูล",
  DPA_BREACH_RESPONSE_DESCRIPTION:
    "ในกรณีที่มีการละเมิดข้อมูล Healthnex จะแจ้งให้ผู้ใช้ทราบภายในระยะเวลาที่เหมาะสม และให้ความร่วมมือเพื่อปฏิบัติตามภาระผูกพันทางกฎหมายที่เกี่ยวข้อง",
  DPA_SECTION_POST_TERMINATION_TITLE: "7. การจัดการข้อมูลหลังจากการยุติการใช้งาน",
  DPA_POST_TERMINATION_DESCRIPTION:
    "เมื่อข้อตกลงสิ้นสุดลง Healthnex จะลบหรือไม่เปิดเผยข้อมูลที่เกี่ยวข้องตามคำแนะนำของผู้ใช้และข้อกำหนดทางกฎหมายที่เกี่ยวข้อง เว้นแต่กฎหมายกำหนดให้ต้องเก็บรักษาไว้",
  DPA_SECTION_PRECEDENCE_TITLE: "8. ลำดับความสำคัญ",
  DPA_PRECEDENCE_DESCRIPTION:
    "ในกรณีที่มีความไม่สอดคล้องกันระหว่างภาคผนวกนี้กับข้อตกลงหลัก ภาคผนวกนี้จะมีผลเหนือกว่าในเรื่องการคุ้มครองข้อมูล",
};

const freeTrialTerms = {
  FREE_TRIAL_TERMS_PAGE_TITLE: "เงื่อนไข",
  FREE_TRIAL_TERMS_TITLE:
    "แพลตฟอร์ม HEALTHNEX เงื่อนไขการใช้งานทดลองใช้ฟรีสาม (3) เดือน\n(รวมถึงข้อกำหนดความเป็นส่วนตัวและการประมวลผลข้อมูล)\n",
  FREE_TRIAL_TERMS_SUBTITLE:
    "ข้อกำหนดเหล่านี้ควบคุมการเข้าถึงและการใช้งานแพลตฟอร์ม Healthnex ของคุณในช่วงระยะเวลาทดลองใช้ฟรีสามเดือน",
  FREE_TRIAL_TERMS_EFFECTIVE_DATE: "วันที่มีผลบังคับใช้: วันที่ผู้ใช้ลงทะเบียนและเข้าถึงแพลตฟอร์ม Healthnex เป็นครั้งแรก",
  FREE_TRIAL_TERMS_PARTIES:
    "ข้อตกลงนี้ (“ข้อตกลง”) ทำขึ้นระหว่าง: Healthnex (“Healthnex”, “เรา”, “พวกเรา” หรือ “แพลตฟอร์ม”); และบุคคลหรือนิติบุคคลใดๆ ที่ลงทะเบียนหรือใช้แพลตฟอร์ม Healthnex รวมถึงแต่ไม่จำกัดเพียงเจ้าของคลินิก ผู้ดำเนินการคลินิก ผู้ประกอบวิชาชีพทางการแพทย์ หรือบุคคลที่ทำหน้าที่หลายความสามารถ (\"ผู้ใช้\", \"คุณ\")",
  FREE_TRIAL_TERMS_PURPOSE_TITLE: "1. วัตถุประสงค์ของข้อตกลง",
  FREE_TRIAL_TERMS_PURPOSE_DESC:
    "ข้อตกลงนี้กำหนดเงื่อนไขที่ Healthnex มอบสิทธิ์ให้ผู้ใช้เข้าถึงแพลตฟอร์มเป็นระยะเวลาทดลองใช้ฟรีสาม (3) เดือน และชี้แจงการเตรียมการหลังจากการสิ้นสุดการทดลองใช้",
  FREE_TRIAL_TERMS_USER_DEF_TITLE: "2. คำจำกัดความของผู้ใช้",
  FREE_TRIAL_TERMS_USER_DEF_DESC:
    "ผู้ใช้สามารถเข้าถึงและใช้แพลตฟอร์ม Healthnex ในความสามารถต่อไปนี้อย่างน้อยหนึ่งความสามารถ รวมถึงแต่ไม่จำกัดเพียง:",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_1: "• เจ้าของคลินิก/ผู้บริหาร",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_2: "• 1) เจ้าของหรือผู้ปฏิบัติงานคลินิก ",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_3: "• 2) ผู้บริหารคลินิก ",
  FREE_TRIAL_TERMS_USER_DEF_MULTI_CAPACITY: "3) ผู้ประกอบวิชาชีพแพทย์หรือผู้ประกอบวิชาชีพด้านสุขภาพ ",
  FREE_TRIAL_TERMS_USER_ACCOUNT_RESP:
    "ในกรณีที่ผู้ใช้ดำเนินการในหลายความสามารถ ภาระผูกพันและความรับผิดชอบทั้งหมดภายใต้ข้อตกลงนี้จะมีผลสะสม\nผู้ใช้ต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่ดำเนินการภายใต้บัญชีของตน รวมถึงการกระทำของผู้ปฏิบัติงานหรือพนักงานที่เกี่ยวข้อง",
  FREE_TRIAL_TERMS_ACCESS_TITLE: "3. ทดลองใช้งานฟรี",
  FREE_TRIAL_TERMS_ACCESS_P1:
    "ในระหว่างช่วงทดลองใช้งาน Healthnex มอบสิทธิ์การใช้งานแบบจำกัด ไม่ผูกขาด ไม่สามารถถ่ายโอนและเพิกถอนได้แก่ผู้ใช้ในการเข้าถึงและใช้แพลตฟอร์ม Healthnex",
  FREE_TRIAL_TERMS_ACCESS_P2: "ช่วงทดลองใช้งานฟรีมีระยะเวลาสาม (3) เดือนติดต่อกันนับจากวันที่มีผล",
  FREE_TRIAL_TERMS_ACCESS_P3: "ทดลองใช้ฟรีโดยไม่มีค่าใช้จ่ายและไม่ได้ต่ออายุอัตโนมัติ",
  FREE_TRIAL_TERMS_FEATURES_TITLE: "4. คุณสมบัติของแพลตฟอร์มระหว่างการทดลองใช้",
  FREE_TRIAL_TERMS_FEATURES_INTRO:
    "ในช่วงระยะเวลาทดลองใช้งาน ผู้ใช้สามารถเข้าถึงคุณลักษณะต่างๆ ซึ่งรวมถึงแต่ไม่จำกัดเพียง:",
  FREE_TRIAL_TERMS_FEATURES_ITEM_1: "1) การสร้างและปรับแต่งหน้าเว็บส่วนตัวหรือของคลินิก;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_2: "2) การนัดหมายและการจัดการตารางเวลา;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_3: "3) ข้อมูลผู้ป่วยและการจัดการเวชระเบียน รวมถึงฟังก์ชันที่เกี่ยวข้องกับใบสั่งยา",
  FREE_TRIAL_TERMS_FEATURES_ITEM_4:
    "4) การใช้ AI-คุณลักษณะช่วยเหลือสำหรับการสนับสนุนด้านการดูแลระบบและเวิร์กโฟลว์ (ไม่ใช่การวินิจฉัย);",
  FREE_TRIAL_TERMS_FEATURES_ITEM_5: "• บริการสนับสนุนที่นำเสนอในช่วงระยะเวลาทดลองใช้งาน",
  FREE_TRIAL_TERMS_FEATURES_NOTE: "Healthnex ขอสงวนสิทธิ์ในการแก้ไข จำกัด หรือยุติคุณสมบัติการทดลองใช้ตามดุลยพินิจของตน",
  FREE_TRIAL_TERMS_EXPIRY_TITLE: "5. การหมดอายุและการต่ออายุการทดลองใช้ (เงื่อนไขสำคัญ)",
  FREE_TRIAL_TERMS_EXPIRY_P1:
    "1) ผู้ใช้รับทราบและตกลงอย่างชัดแจ้งว่าหากเมื่อสิ้นสุดระยะเวลาทดลองใช้ฟรีสาม (3) เดือน ผู้ใช้ไม่ได้ลงนามในการสมัครรับข้อมูลแบบชำระเงินหรือข้อตกลงการบริการกับ Healthnex การเข้าถึงแพลตฟอร์ม Healthnex จะยุติลง",
  FREE_TRIAL_TERMS_EXPIRY_P2: "2) หากผู้ใช้ไม่สมัครสมาชิกให้เสร็จสิ้นเมื่อสิ้นสุดการทดลองใช้:",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_1: "• การเข้าถึงแพลตฟอร์มอาจถูกระงับหรือยุติ; และ",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_2: "• ผู้ใช้อาจไม่สามารถใช้คุณสมบัติแพลตฟอร์มหรือเข้าถึงข้อมูลที่เก็บไว้ได้อีกต่อไป",
  FREE_TRIAL_TERMS_EXPIRY_P3: "Healthnex ไม่มีภาระผูกพันในการขยายระยะเวลาทดลองใช้หรือให้สิทธิ์การเข้าถึงฟรีต่อไป",
  FREE_TRIAL_TERMS_DATA_PRIVACY_TITLE: "6. ข้อมูล ความเป็นส่วนตัว และข้อมูลด้านสุขภาพ",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P1:
    "1) ผู้ใช้รับทราบว่าในการใช้แพลตฟอร์ม Healthnex Healthnex อาจรวบรวม จัดเก็บ ประมวลผล และส่งข้อมูลส่วนบุคคลและข้อมูลด้านสุขภาพตามที่กำหนดไว้ในพระราชบัญญัติความเป็นส่วนตัวปี 1988 (Cth)",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P2:
    "2) ผู้ใช้ทำหน้าที่เป็นผู้ควบคุมข้อมูลในส่วนที่เกี่ยวกับข้อมูลผู้ป่วย และ Healthnex ประมวลผลข้อมูลดังกล่าวตามคำแนะนำของผู้ใช้เท่านั้น",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P3: "3) Healthnex จะจัดการข้อมูลส่วนบุคคลและข้อมูลสุขภาพทั้งหมดตาม:",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_1: "Healthnex นโยบายความเป็นส่วนตัว; ",
  AND_D: "และ",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_2: "Healthnex ภาคผนวกการประมวลผลข้อมูล (DPA)",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P4: "4) นโยบายความเป็นส่วนตัวและ DPA รวมอยู่ในและเป็นส่วนหนึ่งของข้อตกลงนี้โดยการอ้างอิง",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P5:
    "5) ในกรณีที่มีความไม่สอดคล้องกันระหว่างข้อตกลงนี้กับ DPA DPA จะมีผลเหนือกว่าในขอบเขตของภาระผูกพันในการประมวลผลข้อมูลด้านสุขภาพ",
  FREE_TRIAL_TERMS_USER_RESP_TITLE: "7. ความรับผิดชอบและการปฏิบัติตามข้อกำหนดของผู้ใช้",
  FREE_TRIAL_TERMS_USER_RESP_INTRO: "ผู้ใช้รับรองและรับประกันว่า:",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_1:
    "1) ในกรณีที่ผู้ใช้เป็นผู้ประกอบวิชาชีพทางการแพทย์ พวกเขาได้รับการจดทะเบียนอย่างถูกต้องตามกฎหมายและได้รับอนุญาตให้ประกอบวิชาชีพในเขตอำนาจศาลที่เกี่ยวข้อง;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_2:
    "2) ในกรณีที่ผู้ใช้เป็นเจ้าของคลินิกหรือผู้ดำเนินการ พวกเขาตรวจสอบให้แน่ใจว่าผู้ประกอบวิชาชีพทั้งหมดที่ใช้แพลตฟอร์มได้รับการลงทะเบียนและได้รับอนุญาตอย่างเหมาะสม",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_3:
    "3) การใช้แพลตฟอร์ม Healthnex เป็นไปตามกฎหมายที่บังคับใช้ทั้งหมด รวมถึงกฎหมายความเป็นส่วนตัวและบันทึกสุขภาพ",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_4:
    "4) การตัดสินใจทางคลินิก การวินิจฉัย การรักษา และใบสั่งยาทั้งหมดถือเป็นความรับผิดชอบของผู้ประกอบวิชาชีพที่เกี่ยวข้องแต่เพียงผู้เดียว ไม่ใช่ Healthnex",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_TITLE: "8. ข้อสงวนสิทธิ์ระหว่างช่วงทดลองใช้งาน",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P1:
    "1) ตามขอบเขตสูงสุดที่กฎหมายอนุญาต แพลตฟอร์ม Healthnex ได้รับการจัดเตรียมไว้ระหว่างช่วงทดลองใช้งานตามเกณฑ์ \"ตามสภาพ\" และ \"ตามที่มี\"",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P2:
    "2) Healthnex ไม่รับประกันความพร้อมใช้งานอย่างต่อเนื่อง การทำงานที่ปราศจากข้อผิดพลาด หรือความเหมาะสมสำหรับวัตถุประสงค์เฉพาะใดๆ ในระหว่างช่วงทดลองใช้งาน",
  FREE_TRIAL_TERMS_LIABILITY_TITLE: "9. ข้อจำกัดความรับผิด",
  FREE_TRIAL_TERMS_LIABILITY_P1:
    "1) ตามขอบเขตที่กฎหมายอนุญาต Healthnex ไม่รวมถึงความรับผิดทั้งหมดสำหรับการสูญเสียทางอ้อมหรือเป็นผลสืบเนื่องใด ๆ ที่เกิดขึ้นจากหรือเกี่ยวข้องกับการใช้บริการทดลองใช้งานของผู้ใช้",
  FREE_TRIAL_TERMS_LIABILITY_P2:
    "2) ไม่มีส่วนใดในข้อตกลงนี้ที่ยกเว้นสิทธิ์ที่ไม่สามารถยกเว้นได้ภายใต้กฎหมายผู้บริโภคของออสเตรเลีย",
  FREE_TRIAL_TERMS_AMENDMENTS_TITLE: "10. การแก้ไข",
  FREE_TRIAL_TERMS_AMENDMENTS_P1:
    "Healthnex อาจแก้ไขข้อตกลงนี้โดยการแจ้งให้ทราบอย่างสมเหตุสมผลผ่านทางแพลตฟอร์มหรือการสื่อสารทางอิเล็กทรอนิกส์ การใช้งานต่อไปหลังจากการแก้ไขดังกล่าวถือเป็นการยอมรับข้อกำหนดที่อัปเดต",
  FREE_TRIAL_TERMS_GOVERNING_LAW_TITLE: "11. กฎหมายที่ใช้บังคับ",
  FREE_TRIAL_TERMS_GOVERNING_LAW_P1:
    "ข้อตกลงนี้อยู่ภายใต้กฎหมายของนิวเซาธ์เวลส์ (NSW) ออสเตรเลีย และคู่สัญญาทั้งสองฝ่ายจะต้องอยู่ภายใต้เขตอำนาจศาลพิเศษของศาลของรัฐนั้น",
  FREE_TRIAL_TERMS_ACK_TITLE: "12. การรับทราบและการยอมรับ",
  FREE_TRIAL_TERMS_ACK_INTRO: "โดยการคลิก “ฉันยอมรับ” ลงทะเบียนบัญชี หรือใช้แพลตฟอร์ม Healthnex ผู้ใช้ยืนยันว่า:",
  FREE_TRIAL_TERMS_ACK_ITEM_1: "• พวกเขาได้อ่านและทำความเข้าใจข้อตกลงนี้แล้ว",
  FREE_TRIAL_TERMS_ACK_ITEM_2: "• พวกเขาตกลงที่จะผูกพันตามเงื่อนไขทั้งหมด; และ",
  FREE_TRIAL_TERMS_ACK_ITEM_3:
    "• พวกเขารับทราบอย่างชัดเจนว่าการเข้าถึงแพลตฟอร์มจะสิ้นสุดลงหลังจากช่วงทดลองใช้งานสาม (3) เดือน เว้นแต่จะมีการสมัครสมาชิกแบบชำระเงิน",
  FREE_TRIAL_TERMS_ACK_CHECKBOX:
    "ฉันได้อ่านและยอมรับ Healthnex ข้อกำหนดการใช้งาน นโยบายความเป็นส่วนตัว และภาคผนวกการประมวลผลข้อมูล และฉันรับทราบว่าการเข้าถึงของฉันจะสิ้นสุดลงหลังจากการทดลองใช้สามเดือน เว้นแต่ฉันจะสมัครแผนแบบชำระเงิน",
};

const dashboard = {
  SEARCH_PATIENTS: "ค้นหาผู้ป่วย",
  SEARCH_PATIENTS_THAT_U_WANT_TO_VIEW_THE_DETAIL_ABOUT: "ค้นหาและดูรายละเอียดผู้ป่วย",
  VIEW_USER_GUIDE_AND_UNDERSTAND_THE_SYSTEM: "ดูคู่มือผู้ใช้และทำความเข้าใจระบบ",
  VIEW_APPOINTMENTS: "ดูการนัดหมาย",
  VIEW_CREATED_APPOINTMENTS_ON_TIME_SCHEDULE: "ดูการนัดหมายที่กำหนดไว้ทั้งหมดในตารางเวลา",
  CREATE_APPOINTMENT_FOR_THE_SELECTED_PATIENT: "สร้างการนัดหมายสำหรับผู้ป่วยที่เลือก",
  CREATE_MEIDICAL_HISTORY_FOR_THE_SELECTED_PATIENT: "สร้างเวชระเบียนสำหรับผู้ป่วยที่เลือก",
  VIEW_PATIENT_MEDICAL_HISTORY: "ดูเวชระเบียนของผู้ป่วย",
  VIEW_MEDICAL_HISTORY_FOR_THE_SELECTED_PATIENT: "ดูเวชระเบียนสำหรับผู้ป่วยที่เลือก",
  ADD_NEW_PATIENT_TO_THE_SYSTEM: "เพิ่มผู้ป่วยใหม่เข้าสู่ระบบ",
  VIEW_PATIENT: "ดูผู้ป่วย",
  VIEW_PATIENT_INFO: "ดูข้อมูลผู้ป่วย",
  VALIDATE_PATIENT: "ตรวจสอบผู้ป่วยใหม่",
  VALIDATION_REQUIRED: "ต้องมีการตรวจสอบ",
  RECOMMENDED_PATIENTS: "ผู้ป่วยที่แนะนำ",
  MERGE: "ผสาน",
  MERGE_TO_RECOMMENDED_PATIENTS: "รวมเป็นหนึ่งในผู้ป่วยที่มีอยู่ด้านล่าง",
  MERGE_TO_THIS_PATIENT: "รวมผู้ป่วยรายนี้",
  VIEW_MERGED_PATIENT: "ดูผู้ป่วยที่รวมเข้าด้วยกัน",
  CONFIRMED_AS_NEW_PATIENT: "ยืนยันการเป็นผู้ป่วยใหม่",
  PATIENT_CONFIRMED: "ผู้ป่วยได้รับการยืนยันว่าเป็นผู้ป่วยรายใหม่",
  PATIENT_MERGED: "รวมผู้ป่วยเรียบร้อยแล้ว",
  DELETE_PATIENT: "ลบผู้ป่วย",
  DELETE_PATIENT_CONFIRM: "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ป่วยรายนี้? การดำเนินการนี้ไม่สามารถยกเลิกได้",
  DELETE_PATIENT_FAILED: "ไม่สามารถลบผู้ป่วยได้ ผู้ป่วยอาจมีเวชระเบียนที่มีอยู่",
  NUMBER_OF_APPOINTMENTS: "จำนวนการนัดหมาย",
  TOTAL_EARNINGS: "รายได้รวม",
  TOTAL_CHARGED: "รายได้รวม",
  INSURANCE_REBATE_TOTAL: "ยอดรวมส่วนลดประกันภัย",
  TOTAL_DISCOUNT: "ยอดรวมส่วนลด",
  NO_PATIENTS_HAS_CREATED_PRESCRIPTION: "หมายเลข ของคนไข้ที่ต้องสั่งยา",
  NO_PRESCRIPTION_CONDUCTED: "ใบสั่งยาทั้งหมดที่ออก",
  YOUR_CLINIC_MEMBERS: "สมาชิกคลินิกของคุณ",
  MY_STATS: "สถิติของฉัน",
  VIEW_STATS: "ดูสถิติ",
  VIEW_THIS_WEEK: "ดูสัปดาห์นี้",
  VIEW_TODAY: "ดูวันนี้",
  THIS_WEEK: "สัปดาห์นี้\nสถิติของ",
  S_STATS: "",
  GOOD_MORNING: "สวัสดีตอนเช้า",
  GOOD_NOON: "สวัสดีตอนบ่ายครับ",
  GOOD_AFTERNOON: "สวัสดีตอนบ่ายครับ",
  GOOD_EVENING: "สวัสดีตอนเย็น",
  VIEW_CLINIC_STATS: "ดูภาพรวมงานของคลินิก",
  GO_TO: "ไปที่ ",
  PAGE_BACK: " หน้า",
};

const patientList = {
  IMPORT_PATIENT_FROM_EXCEL: "นำเข้าผู้ป่วยจาก Excel",
  IF_U_WANT_TO_IMPORT_PATIENTS_FROM_YOUR_EXCEL:
    "คุณสามารถนำเข้าข้อมูลผู้ป่วยได้อย่างรวดเร็วโดยกรอกเทมเพลต Excel แล้วอัปโหลดไปที่ Healthnex",
  STEP_1_DOWNLOAD_THE_EXCEL_TEMPALTE_FILE_FROM_BELOW_AND_FILL_IN_ALL_THE_REQUIRED_COLUMNS:
    "ขั้นตอนที่ 1: ดาวน์โหลดเทมเพลต Excel ด้านล่างและกรอกข้อมูลในฟิลด์ที่จำเป็นทั้งหมดสำหรับผู้ป่วยแต่ละราย",
  STEP_2_COMPLETE_PATIENT_INFO_EXCEL_TEMPALTE_AND_UPLOAD_BELOW:
    "ขั้นตอนที่ 2: หลังจากกรอกข้อมูลผู้ป่วยเรียบร้อยแล้ว ให้คลิกปุ่มด้านล่างเพื่ออัปโหลดเทมเพลต Excel ไปที่ Healthnex",
  DOWNLOAD_EXCEL_TEMPLATE: "ดาวน์โหลด Excel เทมเพลต",
  UPLOAD_EXCEL: "อัปโหลดไฟล์ Excel (.xlsx)",
  IMPORTED_PATIENTS: "ผู้ป่วยนำเข้า",
  PATIENTS_IMPORTED_SUCCESSFULLY: "นำเข้าผู้ป่วยสำเร็จแล้ว",
  IMPORT_ERRORS_FOUND: "พบข้อผิดพลาดในการนำเข้า",
  NO_ERRORS_FOUND: "ไม่พบข้อผิดพลาด",
  RECORDS_REQUIRED_UR_ACTION_DUE_TO_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM: "บันทึกอาจมีอยู่แล้วในระบบและต้องมีการตรวจสอบด้วยตนเอง",
  IMPORT_STATUS: "สถานะการนำเข้า",
  IMPORT_PAUSED: "การนำเข้าถูกหยุดชั่วคราว",
  X_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM: "{{X}} พบผู้ป่วยที่มีข้อมูลคล้ายกัน",
  OVERWRITE_EXCEL_TO_THIS: "เขียนทับด้วยข้อมูลที่นำเข้า",
  HERE_IS_THE_DIFFERENCE_BETWEEN_TWO_RECORDS: "คุณสามารถตรวจสอบความแตกต่างระหว่างข้อมูลผู้ป่วยที่มีอยู่และข้อมูลที่นำเข้าด้านล่าง",
  CURRENT_IN_SYSTEM: "ข้อมูลผู้ป่วยปัจจุบัน (ระบบ)",
  EXCEL_INFO_TO_UPDATE: "ข้อมูลผู้ป่วยที่นำเข้า (Excel)",
  THERE_ARE_STILL_SOME_IMPORTED_PATIENTS_INFO_NEED_UR_ACTION: "มีบันทึกผู้ป่วยที่ไม่ได้นำเข้าและจำเป็นต้องตรวจสอบโดยเจ้าหน้าที่ของคุณ",
  ARE_U_SURE_TO_COMPLETE_THE_IMPORT_NOW: "คุณแน่ใจหรือไม่ว่าคุณได้นำเข้าเสร็จสมบูรณ์แล้วและต้องการปิดหน้าต่างนี้?",
  DOWNLOADING: "กำลังดาวน์โหลด",
  PATIENTS_IMPORTED_FROM_EXCEL: "ผู้ป่วยนำเข้าจาก Excel",
  RE_UPLOAD_THE_EXCEL: "อัปโหลดใหม่ Excel",
  COMPLETE_IMPORT: "ทำการนำเข้าให้เสร็จสิ้น",
  PREFER_NOT_TO_SAY: "ไม่ต้องการพูด",
  ADDED_PATIENTS: "เพิ่มผู้ป่วย",
  DUPLICATED_PATIENTS: "ผู้ป่วยที่มีอยู่ในระบบ",
  EXCEL_FILE_UPLOAD_FAILED_PLEASE_MAKE_SURE_YOU_ARE_USING_OUR_TEMPLATE_FILE_U_CAN_DOWNLOAD_THE_FILE_HERE:
    "Excel การอัปโหลดล้มเหลว โปรดตรวจสอบให้แน่ใจว่าคุณใช้ไฟล์เทมเพลตที่ให้มา คุณสามารถดาวน์โหลดเทมเพลตได้โดยใช้ปุ่มด้านล่าง",
  EXPORT_MEDICAL_HISTORY: "ส่งออกเวชระเบียน",
  EXPORT_X_MEDICAL_HISTORY: "ส่งออกเวชระเบียนของ {{X}}",
  STEP_1_SELECT_DATE_RANGE_MEDICAL_INSURANCES_TO_FILTER_MEDICAL_HISTORY_THAT_U_LIKE_TO_EXPORT:
    "ขั้นตอนที่ 1: เลือกช่วงวันที่รับคำปรึกษาและกรองตามประกันของผู้ป่วย เพื่อกำหนดบันทึกประวัติการรักษาที่คุณต้องการส่งออก",
  OPTIONAL: "ไม่จำเป็น",
  GUIDED_REQUIRED_MISSING_SUMMARY: "จำเป็น ({{X}}) รายการยังไม่ได้กรอก: ",
  GUIDED_OPTIONAL_MISSING_SUMMARY: "ไม่บังคับ ({{X}}) รายการยังไม่ได้กรอก: ",
  IF_U_WANT_TO_EXPORT_PATIENT_HISTORY_CREATED_FROM_SPECIFIC_CLINIC:
    "หากคุณต้องการส่งออกเวชระเบียนที่สร้างโดยคลินิกเฉพาะ โปรดเลือกคลินิกด้านล่างเพื่อกรองผลลัพธ์",
  STEP_2_EXPORT_RELATED_PATIENT_HISTORY_TO_EXCEL: "ขั้นตอนที่ 2: ส่งออกบันทึกประวัติทางการแพทย์ที่กรองแล้วเป็นไฟล์ Excel",
  TOTAL_MEDICAL_RECORDS_FOUND: "พบบันทึกทางการแพทย์ทั้งหมด",
  MULTI_SELECTION: "อนุญาตให้เลือกได้หลายรายการ",
  EXPORT_TO_EXCEL: "ส่งออกเป็น Excel",
  UPDATED_BY: "อัปเดตโดย",
  UPLOAD_ATTACHMENT: "อัพโหลดไฟล์แนบ",
  MAX_X_ATTACHMENTS_ALLOWED: "คุณสามารถอัปโหลดไฟล์แนบได้สูงสุด {{X}} เท่านั้น",
  DELETING: "กำลังลบ",
  OCCUPATION: "อาชีพ",
  NOTES: "หมายเหตุ",
  ADDRESS_INFO: "ข้อมูลที่อยู่",
  POSTAL_ADDRESS: "ที่อยู่ทางไปรษณีย์",
  SAME_AS_HOME_ADDRESS: "เช่นเดียวกับที่อยู่บ้าน",
  OTHER_INFO: "ข้อมูลอื่นๆ",
  PLEASE_CHECK_THE_INFORMATION_THAT_U_WISH_TO_UPDATE: "โปรดเลือกข้อมูลที่คุณต้องการอัปเดตหรือเก็บไว้",
  NEW_INFO: "ข้อมูลใหม่",
};

const templateEditor = {
  CLINIC_DOC_TEMPLATE: "เทมเพลตเอกสารและ SMS",
  DOCUMENT_TEMPLATES: "เทมเพลตเอกสารและ SMS",
  YOU_CAN_CREATE_EDIT_CLINIC_TEMPLATES_HERE: "สร้างและจัดการใบรับรอง จดหมาย และข้อความ SMS ที่คลินิกของคุณใช้",
  NEW_CLINIC_TEMPLATE: "เทมเพลตคลินิกใหม่",
  TEMPLATE_NAME: "ชื่อเทมเพลต",
  TEMPLATE_CATEGORY: "หมวดหมู่เทมเพลต",
  TEMPLATE_SOURCE: "แหล่งที่มาของเทมเพลต",
  SYSTEM_TEMPLATE: "เทมเพลตระบบ",
  CLINIC_TEMPLATE: "เทมเพลตคลินิก",
  CLINIC_TEMPLATES: "เทมเพลตคลินิก",
  CLINIC_TEMPLATES_HINT: "เทมเพลตที่คลินิกของคุณปรับแต่งเอง",
  SYSTEM_TEMPLATES: "เทมเพลตระบบ",
  SYSTEM_TEMPLATES_HINT: "เทมเพลตเริ่มต้นจาก Healthnex การแก้ไขจะสร้างสำเนาของคลินิก",
  NO_CLINIC_TEMPLATE_YET: "ยังไม่มีเทมเพลตคลินิก แก้ไขเทมเพลตระบบด้านล่างเพื่อสร้างเทมเพลตของคุณเอง",
  USER_DEFINED: "กำหนดเอง",
  SICK_CERT: "ใบรับรองแพทย์",
  REFERRAL: "จดหมายส่งต่อ",
  ALL: "ทั้งหมด",
  SEARCH_TEMPLATES: "ค้นหาเทมเพลต",
  CLEAR_FILTERS: "ล้างตัวกรอง",
  CLEAR_SEARCH: "ล้างการค้นหา",
  NO_TEMPLATE_FOUND: "ไม่พบเทมเพลต",
  TRY_ANOTHER_SEARCH_TERM: "ลองใช้คำค้นหาอื่นหรือล้างตัวกรอง",
  LOADING_TEMPLATES: "กำลังโหลดเทมเพลต...",
  CREATE_SUCCESS: "สร้างเทมเพลตสำเร็จ",
  TEMPLATE_SAVE_SUCCESS: "บันทึกเทมเพลตสำเร็จ",
  TEMPLATE_DELETE_SUCCESS: "ลบเทมเพลตสำเร็จ",
  DELETE_TEMPLATE: "ลบเทมเพลต",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE: "คุณแน่ใจหรือไม่ว่าต้องการลบเทมเพลตนี้",
  TEMPLATE_WILL_BE_RESET_TO_SYSTEM_TEMPLATE: "หากเทมเพลตนี้กำลังใช้งานอยู่ ระบบจะเปลี่ยนไปใช้เทมเพลตระบบแทน",
  NOTE: "หมายเหตุ",
  CREATED_IN: "สร้างใน",
  LAST_EDITED_AT: "แก้ไขล่าสุด",
  EDIT: "แก้ไข",
  DELETE: "ลบ",
  TEMPLATE_ACTIVATED: "เปิดใช้งานเทมเพลตสำเร็จ",
  TEMPLATE_DEACTIVATED: "ปิดใช้งานเทมเพลตสำเร็จ",
  STATUS: "สถานะ",
  IN_USE: "กำลังใช้งาน",
  NOT_USED: "ไม่ได้ใช้งาน",
  UPDATING: "กำลังอัปเดต",
  DUPLICATE: "ทำสำเนา",
  DUPLICATE_TEMPLATE: "ทำสำเนาเทมเพลต",
  SAVE: "บันทึก",
  SAVING: "กำลังบันทึก",
  SAVE_AS_CLINIC_TEMPLATE: "บันทึกเป็นเทมเพลตคลินิก",
  LOADING_TEMPLATE: "กำลังโหลดเทมเพลต",
  CREATING_TEMPLATE: "กำลังสร้างเทมเพลต",
  SAVING_TEMPLATE: "กำลังบันทึกเทมเพลต",

  SMS_CREATE_BOOKING: "SMS - ยืนยันการจอง",
  SMS_RESCHEDULE_BOOKING: "SMS - เลื่อนการจอง",
  EDIT_SMS_TEMPLATE: "แก้ไขเทมเพลต SMS",
  MESSAGE_CONTENT: "เนื้อหาข้อความ",
  VARIABLES: "ตัวแปร",
  INSERT_VARIABLE_HINT: "คลิกหรือลากตัวแปรเพื่อแทรกที่เคอร์เซอร์ หรือพิมพ์ {{ ในข้อความเพื่อค้นหา",
  CHARACTERS: "ตัวอักษร",
  SMS_CHAR_LIMIT_HINT: "จำนวนตัวอักษรนับจากข้อความที่แทนที่ด้วยข้อมูลตัวอย่างของผู้ป่วยและคลินิกแล้ว ข้อมูลจริงอาจทำให้ยาวขึ้นหรือสั้นลงเล็กน้อย",
  SMS_CHAR_LIMIT_EXCEEDED: "ข้อความเกินขีดจำกัด 300 ตัวอักษร กรุณาย่อข้อความก่อนบันทึก",
  SMS_TODAY: "วันนี้",
  SMS_TEXT_MESSAGE: "ข้อความ",
  SMS_PREVIEW_EMPTY: "เริ่มพิมพ์เพื่อดูตัวอย่างข้อความ",
  DRAG_ELEMENTS_AND_DROP_ON_PAGE: "โปรดลากโมดูลเนื้อหาด้านล่างไปวางบนหน้าเพื่อแก้ไข",
  PREVIEW: "ตัวอย่าง",
  SCALE: "มาตราส่วน",
  ZOOM_OUT: "ย่อ",
  ZOOM_IN: "ขยาย",
  RESET_SCALE: "รีเซ็ตมาตราส่วน",
  CONTENT: "เนื้อหา",
  TEXT: "ข้อความ",
  LAYOUT: "เค้าโครง",
  COLUMNS: "คอลัมน์",
  LINE_DIVIDER: "เส้นแบ่ง",
  MEDIA: "สื่อ",
  IMAGE: "รูปภาพ",
  SIGNATURE: "ลายเซ็น",
  PAGE_SIZE: "ขนาดหน้า",
  PAGE_MARGIN: "ระยะขอบหน้า",
  PAGE_SETTINGS: "ตั้งค่าหน้ากระดาษ",
  SELECT_ELEMENT_TO_EDIT_HINT: "คลิกองค์ประกอบบนหน้าเพื่อแก้ไขการตั้งค่าที่นี่",
  TEXT_PARAGRAPH: "ย่อหน้าข้อความ",
  ENTER_CONTENT_HERE: "กรอกเนื้อหาที่นี่",
  FONT_SIZE: "ขนาดตัวอักษร",
  BOLD: "ตัวหนา",
  ITALIC: "ตัวเอียง",
  UNDERLINE: "ขีดเส้นใต้",
  ALIGNMENT: "การจัดแนว",
  TEXT_COLOUR: "สีข้อความ",
  BOTTOM_MARGIN: "ระยะห่างด้านล่าง",
  DYNAMIC_FIELD: "ป้ายกำกับและเนื้อหาที่ตั้งไว้ล่วงหน้า",
  LABEL: "ป้ายกำกับ",
  LABEL_FONT_SIZE: "ขนาดตัวอักษรของป้ายกำกับ",
  VALUE_FONT_SIZE: "ขนาดตัวอักษรของค่า",
  VALUE_COLOUR: "สีของค่า",
  LABEL_COLOUR: "สีของป้ายกำกับ",
  TWO_COLUMNS: "สองคอลัมน์",
  COLUMN_GAP: "ระยะห่างระหว่างคอลัมน์",
  LEFT_WIDTH_RATIO: "ความกว้างคอลัมน์ซ้าย",
  RIGHT_WIDTH_RATIO: "ความกว้างคอลัมน์ขวา",
  HORIZONTAL_LINE: "เส้นแนวนอน",
  LINE_WIDTH: "ความหนาของเส้น",
  COLOUR: "สี",
  SPACING: "ช่องว่าง",
  HEIGHT: "ความสูง",
  MINIMUM_HEIGHT: "ความสูงขั้นต่ำ",
  PRACTITIONER_SIGNATURE: "ลายเซ็นผู้ประกอบวิชาชีพ",
  CLINIC_LOGO: "โลโก้คลินิก",
  CLEAR: "ล้าง",
  LEFT: "ชิดซ้าย",
  CENTER: "กึ่งกลาง",
  RIGHT: "ชิดขวา",
  JUSTIFY: "จัดเต็มแนว",
  MANUAL_INPUT: "กรอกด้วยตนเอง",
  AUTOMATIC_FIELDS: "ฟิลด์ที่ตั้งไว้ล่วงหน้า",
  USER_INPUT_FIELDS: "ฟิลด์ที่ผู้ใช้ต้องกรอก",
  USER_INPUT: "ต้องให้ผู้ใช้กรอก",
  USER_INPUT_FIELD_HINT: "ผู้ใช้ต้องกรอกข้อมูลนี้ก่อนสร้างเอกสาร",
  DRAG_OR_CLICK_VARIABLE_HINT: "ลากหรือคลิกเพื่อแทรก",
  VARIABLE_PALETTE_TITLE: "แทรกตัวแปร",
  VARIABLE_PALETTE_PANEL_HINT: "ลากตัวแปรไปวางในกล่องข้อความ หรือคลิกเพื่อแทรกที่ตำแหน่งเคอร์เซอร์",
  INSERT_PRESET_VARIABLES: "แทรกเนื้อหาที่ตั้งไว้ล่วงหน้า",
  SELECT_PRESET_OPTIONS: "เลือกเนื้อหาที่ตั้งไว้ล่วงหน้า",
  SHOW_PREVIEW: "แสดงตัวอย่าง",
  TOOLBAR_SIZE: "ขนาด",
  TOOLBAR_COLOUR: "สี",
  TOOLBAR_THICKNESS: "ความหนา",
  PRACTITIONER_NAME: "ชื่อผู้ประกอบวิชาชีพ",
  CMBA_NUMBER: "หมายเลข CMBA",
  CLINIC_NAME: "ชื่อคลินิก",
  CLINIC_ADDRESS: "ที่อยู่คลินิก",
  PATIENT_NAME: "ชื่อผู้ป่วย",
  PATIENT_DOB: "วันเดือนปีเกิดของผู้ป่วย",
  BOOKING: "การจอง",
  BOOKING_CODE: "รหัสการจอง",
  BOOKING_START_DATE: "วันที่เริ่มนัดหมาย",
  BOOKING_START_TIME: "เวลาที่เริ่มนัดหมาย",
  BOOKING_PATIENT_NAME: "ชื่อผู้ป่วยของการจอง",
  PRACTITIONER_PHONE: "เบอร์โทรผู้ประกอบวิชาชีพ",
  TODAY_DATE: "วันที่วันนี้",
  START_DATE: "วันที่เริ่มต้น",
  END_DATE: "วันที่สิ้นสุด",
  FREE_TEXT: "ข้อความอิสระ",
  CONSULTED_DATE: "วันที่เข้ารับคำปรึกษา",
  UNFIT_UNTIL_DATE: "ไม่สามารถทำงานได้จนถึงวันที่",

  PERMISSION_ROLES: "บทบาทตามสิทธิ์",
  PERMISSION_ROLES_HINT: "สร้างบทบาทที่กำหนดเองสำหรับคลินิกของคุณ จากชุดสิทธิ์ที่ใช้ร่วมกัน",
  CLINIC_ROLES: "บทบาทของคลินิก",
  CLINIC_ROLES_SECTION_HINT: "บทบาทที่คลินิกของคุณสร้างขึ้น — แก้ไขได้เต็มรูปแบบ",
  NO_CLINIC_ROLE_YET: "ยังไม่มีบทบาทของคลินิก สร้างบทบาทแรกเพื่อเริ่มต้น",
  SYSTEM_ROLES: "บทบาทของระบบ",
  SYSTEM_ROLES_HINT: "บทบาทเริ่มต้นที่ Healthnex จัดเตรียมไว้ — อ่านอย่างเดียว",
  SYSTEM: "ระบบ",
  NEW_CLINIC_ROLE: "สร้างบทบาทคลินิกใหม่",
  EDIT_CLINIC_ROLE: "แก้ไขบทบาทคลินิก",
  SEARCH_ROLES: "ค้นหาบทบาท",
  ROLE_NAME_EN: "ชื่อบทบาท (ภาษาอังกฤษ)",
  ROLE_NAME_CN: "ชื่อบทบาท (ภาษาจีน)",
  ROLE_NAME_TH: "ชื่อบทบาท (ภาษาไทย)",
  ROLE_NAME_VN: "ชื่อบทบาท (ภาษาเวียดนาม)",
  ROLE_NAME_IS_REQUIRED: "จำเป็นต้องระบุชื่อบทบาท (ภาษาอังกฤษ)",
  TRANSLATING: "กำลังแปล",
  PERMISSIONS: "สิทธิ์การใช้งาน",
  SELECTED: "ที่เลือก",
  CLEAR_ALL: "ล้างทั้งหมด",
  SEARCH_PERMISSIONS: "ค้นหาสิทธิ์การใช้งาน",
  NO_PERMISSIONS_FOUND: "ไม่พบสิทธิ์การใช้งาน",
  X_PERMISSIONS_ASSIGNED: "กำหนดสิทธิ์แล้ว {{X}} รายการ",
  X_PERMISSIONS_ADDED: "เพิ่ม {{X}} รายการ",
  X_PERMISSIONS_REMOVED: "ลบ {{X}} รายการ",
  REMOVED: "ลบแล้ว",
  PERMISSION_DIFF_VS_CURRENT_HINT: "แสดงความแตกต่างของสิทธิ์ของบทบาทนี้เทียบกับบทบาทปัจจุบันของผู้ปฏิบัติงาน",
  NO_PERMISSIONS_ADDED_VS_CURRENT: "ไม่มีสิทธิ์ที่เพิ่มขึ้นเมื่อเทียบกับบทบาทปัจจุบัน",
  NO_PERMISSIONS_REMOVED_VS_CURRENT: "ไม่มีสิทธิ์ที่ถูกลบเมื่อเทียบกับบทบาทปัจจุบัน",
  DELETE_ROLE: "ลบบทบาท",
  ROLE_NAME: "ชื่อบทบาท",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "คุณแน่ใจหรือไม่ว่าต้องการลบบทบาทนี้",
  NO_DATA: "ไม่มีข้อมูล",
  ROLE_CREATE_SUCCESS: "สร้างบทบาทสำเร็จแล้ว",

  PERMISSION_ASSIGNMENT: "การกำหนดสิทธิ์",
  CURRENT_ROLE: "บทบาทปัจจุบัน",
  CURRENT_PERMISSIONS: "สิทธิ์ปัจจุบัน",
  VIEW_PERMISSIONS: "ดูสิทธิ์",
  RESET_TO_CURRENT_ROLE: "กลับไปที่บทบาทปัจจุบัน",
  SWITCH_TO_THIS_ROLE: "เปลี่ยนไปใช้สิทธิ์ของบทบาทนี้",
  NO_PERMISSIONS_ASSIGNED: "ยังไม่มีการกำหนดสิทธิ์",
  REASSIGN_ROLE: "กำหนดบทบาทใหม่",
  SELECT_ROLE_TO_ASSIGN: "เลือกบทบาท",
  PREVIEW_ROLE_PERMISSIONS: "ดูตัวอย่างสิทธิ์ของบทบาทนี้",
}

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...packagePages,
    ...cmasaImport,
    ...camera,
    ...bookingPage,
    ...guide,
    ...patientConsent,
    ...agreements,
    ...freeTrialTerms,
    ...dashboard,
    ...patientList,
    ...templateEditor,
    BODY_MAP: "แผนที่ร่างกาย",
    CLICK_BODY_PART_TO_SELECT_TECHNIQUE: "คลิกส่วนของร่างกายในภาพเพื่อเลือกเทคนิค",
    CLINICAL_RECORD: "บันทึกทางคลินิก",
    DOC_CHECKLIST: "เอกสารบันทึก",
    ENTER_TREATMENT_NAME: "กรอกชื่อการรักษา",
    GST: "ภาษีสินค้าและบริการ (GST)",
    GUIDED_CONFIRM_PAYMENT: "ยืนยันการชำระเงิน",
    GUIDED_DOC_TITLE: "เอกสารทางคลินิก",
    GUIDED_GROUP_ASSESSMENT: "การประเมิน",
    GUIDED_GROUP_COMPLETE: "เสร็จสมบูรณ์",
    GUIDED_GROUP_NOT_STARTED: "ยังไม่เริ่ม",
    GUIDED_GROUP_PAYMENT: "การชำระเงิน",
    GUIDED_GROUP_SYMPTOMS: "อาการ",
    GUIDED_GROUP_TREATMENT: "การรักษา",
    GUIDED_HINT_BODY_MAP: "ทำเครื่องหมายบริเวณที่มีอาการบนแผนที่ร่างกาย",
    GUIDED_HINT_CHECKOUT: "ตรวจสอบค่าใช้จ่าย เพิ่มค่าบริการเพิ่มเติม และยืนยันการชำระเงิน",
    GUIDED_HINT_CONSULT_NOTES: "บันทึกอาการที่ผู้ป่วยมาพบด้วยคำพูดของผู้ป่วยเอง",
    GUIDED_HINT_DURATION: "กรอกระยะเวลาการรักษาและบันทึกที่เกี่ยวข้อง",
    GUIDED_HINT_MEDICAL_SAFETY: "บันทึกประวัติการแพ้และสถานะการตั้งครรภ์ก่อนการรักษา",
    GUIDED_HINT_MODALITY: "ตรวจสอบหรือเพิ่มการรักษาที่ให้ในการเข้ารับบริการครั้งนี้",
    GUIDED_HINT_OUTCOME: "บันทึกการตอบสนองของผู้ป่วยต่อการรักษา",
    GUIDED_HINT_OVERVIEW: "ตรวจสอบการรักษาของวันนี้ หรือเลือกรายการเพื่อบันทึก",
    GUIDED_HINT_PAIN_CONDITIONS: "เพิ่มภาวะที่เกี่ยวข้อง จัดกลุ่มตามระบบร่างกาย",
    GUIDED_HINT_PAIN_LEVEL: "ประเมินระดับความเจ็บปวดปัจจุบันของผู้ป่วยตั้งแต่ 0 (ไม่ปวด) ถึง 10 (ปวดมากที่สุด)",
    GUIDED_HINT_PAIN_TYPE: "เลือกลักษณะความเจ็บปวดทั้งหมดที่ผู้ป่วยแจ้ง",
    GUIDED_HINT_PAYMENT_FEE: "ยืนยันค่าใช้จ่ายสำหรับการรักษาแต่ละรายการ",
    GUIDED_HINT_PAYMENT_OTHER: "เพิ่มค่าใช้จ่ายเพิ่มเติมและตรวจสอบยอดรวม",
    GUIDED_HINT_PRECAUTION: "บันทึกข้อควรระวังหรือข้อห้ามในการรักษา",
    GUIDED_HINT_RECOMMENDATION: "บันทึกคำแนะนำและการติดตามผลที่แนะนำ",
    GUIDED_HINT_TECHNIQUES: "เลือกบริเวณที่ทำการรักษาและเทคนิคที่ใช้ในแต่ละบริเวณ",
    GUIDED_HINT_TODAYS_TREATMENTS: "การรักษาวันนี้",
    GUIDED_HINT_TREATMENT_DETAILS: "เลือกบริเวณและจุด เลือกเทคนิค และกำหนดระยะเวลา",
    GUIDED_HINT_TREATMENT_NOTE: "บันทึกหมายเหตุและแผนการรักษา",
    GUIDED_HINT_TREATMENT_POINTS: "ค้นหาและเลือกจุดที่ใช้ในการรักษาครั้งนี้",
    GUIDED_HINT_UPLOAD_PHOTOS: "แนบรูปภาพที่เกี่ยวข้องกับการปรึกษาครั้งนี้",
    GUIDED_LABEL_AFFECTED_AREAS: "บริเวณที่มีอาการ",
    GUIDED_LABEL_ALLERGY: "การแพ้",
    GUIDED_LABEL_ASSESSMENT_PHOTOS: "อัปโหลดรูปภาพ",
    GUIDED_LABEL_CHIEF_COMPLAINT: "บันทึกการซักประวัติ",
    GUIDED_LABEL_FOLLOW_UP_RECOMMENDATION: "คำแนะนำการติดตามผล",
    GUIDED_LABEL_MEDICAL_SAFETY: "การแพ้ / การตั้งครรภ์",
    GUIDED_LABEL_PAIN_CHARACTER: "ลักษณะความเจ็บปวด",
    GUIDED_LABEL_PAIN_SEVERITY: "ระดับความเจ็บปวด",
    GUIDED_LABEL_PAYMENT: "การชำระเงิน",
    GUIDED_LABEL_PRECAUTIONS_ADVICE: "ข้อควรระวังและคำแนะนำ",
    GUIDED_LABEL_RELATED_CONDITIONS: "ภาวะที่เกี่ยวข้องกับความเจ็บปวด",
    GUIDED_LABEL_TREATMENT_AREA_TECHNIQUE: "บริเวณและเทคนิคการรักษา",
    GUIDED_LABEL_TREATMENT_DURATION: "ระยะเวลาการรักษา",
    GUIDED_LABEL_TREATMENT_NOTE_PLAN: "หมายเหตุและแผนการรักษา",
    GUIDED_LABEL_TREATMENT_OUTCOME: "ผลลัพธ์การรักษา",
    GUIDED_LABEL_TREATMENT_OVERVIEW: "ภาพรวมการรักษา",
    GUIDED_LABEL_TREATMENT_POINTS: "จุดที่ใช้รักษา",
    GUIDED_MISSING: "ขาดหาย",
    GUIDED_MODALITY_TAB_DESC: "เลือกการ์ดการรักษาด้านบนเพื่อแก้ไข หรือเพิ่มการรักษาใหม่ แท็บด้านล่างใช้บันทึกการรักษาที่เลือก",
    GUIDED_SAVE_AND_CONTINUE_TO_PAYMENT: "บันทึกและไปยังหน้าชำระเงิน",
    GUIDED_SKIP_TOOLTIP: "ข้ามไปโดยไม่กรอกส่วนนี้ให้ครบ",
    GUIDED_STEP_1_SYMPTOMS: "ขั้นตอนที่ 1: อาการ",
    GUIDED_STEP_2_TREATMENT: "ขั้นตอนที่ 2: การรักษา",
    GUIDED_STEP_3_PAYMENT: "ขั้นตอนที่ 3: การชำระเงิน",
    GUIDED_TAB_HELPER: "เลือกแท็บด้านบนเพื่อสลับระหว่างส่วนต่างๆ ของเอกสาร",
    GUIDED_TAB_TOOLTIP: "เปิดส่วนนี้",
    GUIDED_TREATMENT_DETAILS: "รายละเอียดการรักษา",
    GUIDED_TREATMENT_OVERVIEW: "ภาพรวม",
    GUIDED_X_OF_Y_REQUIRED_COMPLETED: "เสร็จสิ้น {{X}} จาก {{Y}} รายการที่จำเป็น",
    GUIDED_X_REQUIRED_REMAINING: "เหลืออีก {{X}} รายการที่จำเป็น",
    NO_INFO_RECORDED: "ไม่มีข้อมูลที่บันทึกไว้",
    RECEIPT: "ใบเสร็จ",
    RECORD_NO: "หมายเลขบันทึก",
    RESPONSE: "การตอบสนอง",
    SAVE_AND_NEXT: "บันทึกและถัดไป",
    PRESCRIBE_X_TO_THE_PATIENT: "สั่ง {{X}} ให้ผู้ป่วย",
    ADD_ASSITANT_EXAMINATION: "เพิ่มการตรวจเพิ่มเติม",
    CN: "จีน",
    EN: "อังกฤษ",
    NO_AVAILABLE_TREATMENT:
      "ยังไม่ได้ตั้งค่าหมวดหมู่บริการนวดหรือฝังเข็มใด ๆ กรุณาตั้งค่าผ่าน Healthnex เดสก์ท็อป → จัดการคลินิกและพนักงาน",
    BACK: "กลับ",
    CLOSE: "ปิด",
    ONLINE_ZOOM_MEETING: "ประชุมออนไลน์ผ่าน Zoom",
    KEY_MEMBERS: "สมาชิกคนสำคัญ",
    INTRODUCTION: " แนะนำโดยย่อ",
    LOAD_MORE: "โหลดเพิ่มเติม",
    CURRENT: "ปัจจุบัน",
    HISTORY_EVENT: "เหตุการณ์ประวัติศาสตร์",
    HISTORY_CPD: "ประวัติ CPD",
    HISTORY: "ในอดีต",
    EXPIRED: "หมดอายุแล้ว",
    MONTH_FORMAT: "MMMM",
    EDIT: "แก้ไข",
    FROM: "จาก",
    TO: "ถึง",
    TOTAL_X: "รวม {{X}} บันทึก",
    OTHER_LANGUAGE_VERSION: "EN",
    CLINIC: "คลินิก",
    HRS: "ชม.",
    VIEW: "ดู",
    LOADING: "กำลังโหลด",
    VIEW_ALL: "ดูทั้งหมด",
    NO_INPUT_YET: "[ไม่มีข้อมูล]",
    U_ARE_EDITING: "คุณกำลังแก้ไข",
    X_WEBSITE: "{{X}} เวอร์ชัน. ของเว็บไซต์",
    SWITCH_TEMPLATE: "สลับเทมเพลต",
    TERMS_AND_CONDITIONS: "ข้อกำหนดและเงื่อนไข",
    PRIVACY_POLICY: "นโยบายความเป็นส่วนตัว",
    INITIATING: "กำลังเริ่มต้น",
    FAILED_TO_ACCESS_MICROPHONE: "ไม่สามารถเข้าถึงไมโครโฟน",
    LISTENING: "การฟัง",
    TRANSCRIBING: "กำลังถอดเสียง",
    SPEECH_TO_TEXT: "แปลงเสียงเป็นข้อความ",
    STOP_RECORDING: "หยุดการบันทึก",
    DISPLAYED: "แสดงแล้ว",
    RECORDS: "บันทึก",
    X_RECORDS: "{{X}} บันทึก",
    WITH_TOTAL_X_RECORDS: "พร้อมบันทึกทั้งหมด {{X}}",
    ALL_X_RECORDS_LOADED: "โหลดบันทึกทั้งหมด {{X}} แล้ว",
    AI_AUTO_TRANSLATE: "แปลอัตโนมัติด้วย AI",
    ADD_TO_CLINIC_FORMULA: "เพิ่มลงในสูตรคลินิก",
    NON_PREMIUM: "ไม่ใช่พรีเมี่ยม",
    NON_TOXIC: "ปลอดสารพิษ",
    APPOINTMENT_HISTORY: "ประวัติการนัดหมาย",
    ADJUST_APPOINTMENT_TIME: "ปรับเวลานัดหมาย",
    ADJUST_NOW: "ปรับทันที",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED: "ฉันเข้าใจการดำเนินการและตกลงที่จะดำเนินการต่อไป",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "โปรดทราบว่าการเปลี่ยนแปลงระยะเวลาการนัดหมายอาจทำให้เกิดการจองมากกว่าการนัดหมายอื่นที่มีอยู่",
    NEXT_WEEK: "สัปดาห์หน้า",
    JUMP_TO_TODAY: "ข้ามไปที่วันนี้",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "การนัดหมายที่รอดำเนินการตามกำหนดการ",
    X_APPOINTMENTS_PENDING_FOR_YOUR_SCHEDULE: "{{X}} การจองเกินที่รอดำเนินการสำหรับกำหนดการของคุณ",
    RELOAD: "โหลดซ้ำ",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "ไม่สามารถกำหนดเวลาใหม่ได้ภายใน 24 ชั่วโมง",
    PREV_WEEK: "สัปดาห์ก่อน",
    PENDING_APPROVAL: "รอการอนุมัติ",
    SUBSCRIBE: "สมัครสมาชิก",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC: "รายการนี้จะไม่สามารถใช้ในคลินิกนี้ได้อีกต่อไป",
    PLEASE_SELECT_A_VIDEO: "โปรดเลือกวิดีโอ",
    PLEASE_SELECT_A_COVER_IMAGE: "โปรดเลือกภาพหน้าปก",
    RESCHEDULE: "กำหนดเวลาใหม่",
    RESCHEDULE_APPOINTMENT: "กำหนดเวลาการนัดหมายใหม่",
    CURRENT_APPOINTMENT_TIME: "เวลานัดหมายปัจจุบัน",
    NEW_APPOINTMENT_TIME: "เวลานัดหมายใหม่",
    NOT_SELECTED: "ไม่ได้เลือก",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS: "การนัดหมายเชื่อมโยงกับผู้ป่วยสำเร็จ",
    LINK_APPOINTMENT_TO_PATIENT: "เชื่อมโยงการนัดหมายกับคนไข้",
    ACCEPT_APPOINTMENT: "ตอบรับการนัดหมาย",
    PROCEED_TO_PATIENT_INFO: "ดำเนินการต่อไปยังข้อมูลผู้ป่วย",
    CONFIRM_RESCHEDULE: "ยืนยันกำหนดการใหม่",
    APPOINTMENT_DATE: "วันที่นัดหมาย",
    PENDING_APPOINTMENT: "รอการนัดหมาย",
    PENDING_APPOINTMENTS: "รอการนัดหมาย",
    PENDING_SCHEDULE: "กำหนดการที่รอดำเนินการ",
    LINK_TO_PATIENT: "ลิงก์ไปยังผู้ป่วย",
    LINK_TO_ANOTHER_PATIENT: "เชื่อมโยงไปยังผู้ป่วยรายอื่น",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT: "เชื่อมโยงผู้ป่วยรายอื่นจากคลินิกของคุณกับการนัดหมายนี้",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE: "แพ็คเกจนี้ใช้ได้กับคลินิกของคุณ โปรดสร้างแพ็คเกจก่อน",
    CLEAR: "ล้าง",
    YOUR_WORKING_CLINICS: "คลินิกที่ทำงานของคุณ",
    ALL: "ทั้งหมด",
    SEARCH_PACKAGE: "ค้นหาแพ็คเกจ",
    SEARCH_TREATMENT: "การรักษาการค้นหา",
    X_APPOINTMENTS_PENDING: "{{X}} การนัดหมายที่รอดำเนินการ",
    X_MODALITIES_INCLUDES: "{{X}} รวมวิธีการต่างๆ แล้ว",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE: "คุณแน่ใจหรือไม่ว่าต้องการยอมรับกำหนดการนัดหมายนี้?",
    OVERBOOKING_ACCEPTED: "ยอมรับการจองเกินแล้ว",
    RESCHEDULE_SUCCESS: "กำหนดเวลาใหม่สำเร็จ",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE: "คำยืนยัน SMS จะส่งให้ผู้ป่วยอีกครั้ง",
    CONTINUE: "ดำเนินการต่อ",
    VIEW_THIS_DATE_SCHEDULE: "ดูกำหนดการของวันที่นี้",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL: "โปรดทราบว่าข้อมูลคลินิกนี้จะถูกส่งเพื่อขออนุมัติ",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE: "คุณจะได้รับแจ้งเมื่อการอนุมัติเสร็จสิ้น",
    SUBMIT_CONFIRM: "ส่งคำยืนยัน",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    CLINIC_CREATE_REQUEST_SENT: "ส่งคำขอสร้างคลินิกแล้ว",
    UPDATE_CONFIRM: "ยืนยันการอัพเดต",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO: "คุณแน่ใจหรือไม่ว่าต้องการอัพเดตข้อมูลคลินิกของคุณ?",
    CLINIC_UPDATED: "อัพเดทข้อมูลคลินิก",
    CLOSED_CLINIC_SUCCESS: "ปิดคลินิกสำเร็จแล้ว",
    PROTECTED_PAGE: "หน้านี้จำเป็นต้องเข้าถึงคลินิก",
    PROTECTED_PAGE_WARNING: "คุณต้องมีสิทธิ์เข้าถึงที่เหมาะสมเพื่อดูหน้านี้",
    TO_START_YOUR_WORK_PLS_IDENTIFY_YOUR_ROLE:
      "เพื่อให้คำแนะนำที่ถูกต้องแก่คุณ โปรดเลือกบทบาทของคุณ (เจ้าของคลินิกหรือผู้ประกอบวิชาชีพ)",
    IF_UR_CLINIC_OWNER: "หากคุณเป็นเจ้าของคลินิก/สถานพยาบาลส่วนบุคคล",
    IF_UR_CLINIC_OWNER_CREATE_UR_CLINIC:
      "หากคุณเป็นเจ้าของคลินิก / สถานประกอบการส่วนบุคคล โปรดสร้างคลินิกของคุณและข้อมูลที่เกี่ยวข้อง หลังจากนั้นคุณสามารถเชิญสมาชิกคลินิกคนอื่นให้เข้าร่วมคลินิกของคุณได้",
    IF_UR_CLINIC_PRACTITIONER: "หากท่านเป็นสมาชิกคลินิก",
    IF_UR_CLINIC_PRACTITIONER_SEARCH_FOR_THE_CLINIC_YOU_WISH_TO_JOIN_AND_SUBMIT_A_JOIN_REQUEST: "หากคุณเป็นสมาชิกคลินิก โปรดค้นหาคลินิกที่คุณต้องการเข้าร่วมและส่งคำขอเข้าร่วม",
    SKIP_USER_GUIDE: "ข้ามคำแนะนำระบบ",
    USER_GUIDE_WILL_GUIDE_THROUGH_HOW_AND_WHERE_TO_CREATE_JOIN_A_CLINIC: "คู่มือผู้ใช้จะแนะนำคุณเกี่ยวกับวิธีการและสถานที่ในการสร้างและเข้าร่วมคลินิก",
    START_NOW: "เริ่มเลย",
    ACCEPT_INVITE: "ยอมรับคำเชิญ",
    ARE_YOU_SURE_TO_ACCEPT_INVITE: "คุณแน่ใจหรือไม่ว่าต้องการยอมรับคำเชิญจากคลินิกนี้?",
    REJECT_INVITE: "ปฏิเสธคำเชิญ",
    ARE_YOU_SURE_TO_REJECT_INVITE: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธคำเชิญจากคลินิกนี้?",
    RESPONSE_SUCCESS: "ตอบกลับสำเร็จ",
    JOIN_REQUEST_SENT: "ส่งคำขอเข้าร่วมแล้ว",
    SEND_JOIN_REQUEST: "ส่งคำขอเข้าร่วม",
    JOIN_REQUEST_SENT_SHORT: "ส่งคำขอเข้าร่วมแล้ว",
    REQUEST_ACCEPTED: "ยอมรับคำขอแล้ว",
    INVITATION_SENT: "ส่งคำเชิญแล้ว",
    NO_PACKAGES: "ไม่มีแพ็คเกจ",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "{{X}} ผู้ปฏิบัติงานไม่ได้ใช้งานแล้ว",
    ACTIVE_CONFIRM: "ใช้งานอยู่ ยืนยัน",
    ACTIVATE: "เปิดใช้งาน",
    INACTIVE_CONFIRM: "ไม่ใช้งาน ยืนยัน",
    ARE_YOU_SURE_TO_INACTIVE: "คุณแน่ใจหรือไม่ว่าต้องการตั้งค่าเป็นไม่ใช้งาน?",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT: "ผู้ป่วยไม่สามารถจองผู้ปฏิบัติงานที่ไม่ใช้งานได้",
    REJECTED: "ถูกปฏิเสธ",
    RESUBMIT: "ส่งอีกครั้ง",
    DELETE_APPLICATION: "ลบแอปพลิเคชัน",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION: "คุณแน่ใจหรือไม่ว่าต้องการลบแอปพลิเคชันนี้",
    REBUILD_CLINIC: "ส่งคลินิกอีกครั้ง",
    DELETE_APPLICATION_SUCCESS: "ลบแอปพลิเคชันเรียบร้อยแล้ว",
    SEARCH_CLINIC_BY_NAME: "ค้นหาคลินิกตามชื่อ",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE: "ผู้ประกอบวิชาชีพรายอื่นจะไม่ปรากฏแก่ผู้ปฏิบัติงานที่ไม่ใช่คลินิก",
    DECLINE_JOIN_INVITATION_CONFIRM: "ปฏิเสธการยืนยันคำเชิญเข้าร่วม",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC: "แน่ใจหรือว่าต้องการยกเลิกการลาออกจากคลินิก?",
    SECTION_UNPUBLISHED: "ส่วนที่ไม่ได้เผยแพร่",
    SECTION_PUBLISHED: "ส่วนที่เผยแพร่แล้ว",
    REFRESH: "รีเฟรช",
    CHANGE_THIS_BOOKING_DURATION: "เปลี่ยนระยะเวลาการจองนี้",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนระยะเวลาการนัดหมายนี้สำหรับ {{X}}?",
    BOOKING_DURATION_ADJUST_SUCCESS: "ปรับระยะเวลาการจองเรียบร้อยแล้ว",
    NO_PENDING_APPOINTMENTS: "ไม่มีการนัดหมายที่ค้างอยู่",
    ASSIGN_OWNERSHIP: "ตั้งผู้ใช้รายนี้เป็นเจ้าของร่วมของคลินิก",
    STOP_BEING_CLINIC_OWNER: "เลิกเป็นเจ้าของคลินิก",
    CONFIRM_TO_ADD_CLINIC_CO_OWNER: "คุณแน่ใจหรือไม่ว่าต้องการตั้ง {{name}} เป็นเจ้าของร่วมของคลินิก?",
    CLINIC_CO_OWNER_ADDED_SUCCESS: "เพิ่มเจ้าของร่วมของคลินิกเรียบร้อยแล้ว",
    TRANSFER_OWNERSHIP: "โอนสิทธิ์เจ้าของคลินิก",
    CONFIRM_TO_TRANSFER_CLINIC_OWNERSHIP: "คุณแน่ใจหรือไม่ว่าต้องการโอนสิทธิ์เจ้าของคลินิกให้ {{name}}?",
    CLINIC_OWNERSHIP_TRANSFERRED_SUCCESS: "โอนสิทธิ์เจ้าของคลินิกเรียบร้อยแล้ว",
    TRANSFER_OWNERSHIP_AND_QUIT_CLINIC: "โอนสิทธิ์เจ้าของและออกจากคลินิก",
    SELECT_A_SUCCESSOR_TO_TRANSFER_OWNERSHIP_AND_QUIT_HINT: "เลือกผู้ปฏิบัติงานเพื่อโอนสิทธิ์เจ้าของคลินิกให้ เมื่อโอนสำเร็จ คุณจะออกจากคลินิกนี้",
    CLINIC_OWNERSHIP_TRANSFERRED_AND_QUIT_SUCCESS: "โอนสิทธิ์เจ้าของและออกจากคลินิกเรียบร้อยแล้ว",
    CONFIRM_TO_EXIT_CLINIC_OWNERSHIP: "คุณแน่ใจหรือไม่ว่าต้องการเลิกเป็นเจ้าของ {{name}}?",
    EXIT_CLINIC_OWNERSHIP_SUCCESS: "คุณไม่ได้เป็นเจ้าของคลินิกนี้แล้ว",
    CANNOT_EXIT_OWNERSHIP_NO_OTHER_OWNER: "ขณะนี้คุณเป็นเจ้าของคลินิกนี้เพียงคนเดียว จึงไม่สามารถเลิกเป็นเจ้าของได้ หากต้องการหยุดดำเนินการคลินิกนี้ กรุณาใช้ \"ปิดคลินิก\" แทน",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO: "คุณแน่ใจหรือไม่ว่าต้องการมอบหมายความเป็นเจ้าของ",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC: "คุณจะสูญเสียสิทธิ์ของเจ้าของทั้งหมดในคลินิกนี้",
    ACTIONS_REQUIRED_OWNER_PERMISSION: "การดำเนินการนี้ต้องใช้สิทธิ์ของเจ้าของ",
    SUBSCRIBE_PACKAGE_TO_UNLOCK_FEATURE: "โปรดอัปเกรดหรือสมัครสมาชิกเพื่อปลดล็อคการเข้าถึง",
    FEATURE_LOCKED: "บริการถูกล็อคอยู่ในขณะนี้",
    PAY_SUCCESSFUL: "ชำระเงินสำเร็จ",
    OWNER_CHANGED: "ความเป็นเจ้าของมีการเปลี่ยนแปลง",
    VIEW_PATIENT_INFO: "ดูข้อมูลผู้ป่วย",
    VIEW_PATIENT_INFO: "ดูข้อมูลผู้ป่วย",
    CLINIC_QR_CODE: "คิวอาร์โค้ดคลินิก",
    APPOINTMENT_QR_CODE: "คิวอาร์โค้ดนัดหมาย",
    DOWNLOAD: "ดาวน์โหลด",
    SIGNATURE: "ลายเซ็น",
    MANAGE_YOUR_SIGNATURE: "จัดการลายเซ็นของคุณ",
    UPLOAD_SIGNATURE_FROM_DEVICE: "อัปโหลดไฟล์ลายเซ็นจากอุปกรณ์",
    VIEW_SIGNATURE: "ดาวน์โหลดลายเซ็น",
    SIGNATURE_USAGE_MSG: "ลายเซ็นของคุณจะถูกใช้สำหรับการลงนามอัตโนมัติเมื่อออกใบสั่งยา",
    UPLOAD_SIGNATURE_CONSENT: "การอัพโหลดลายเซ็นของคุณ แสดงว่าคุณยินยอมให้ใช้ลายเซ็นภายในระบบ Healthnex หากมี",
    ARE_YOU_SURE_TO_CLEAR_ALL_SELECTED_ITEMS: "คุณแน่ใจหรือไม่ว่าต้องการล้างรายการที่เลือกทั้งหมด?",
    RECORD_VIDEO: "บันทึกวิดีโอ",
    NO_RESULTS_FOUND: "ไม่พบผลลัพธ์",
    PRESS_ENTER_TO_CREATE: "กด Enter เพื่อสร้าง",
    CREATING: "กำลังสร้าง",
    CREATE_CLINIC_ITEM: "สร้างรายการคลินิก",
    NAME_CN: "ชื่อ (ภาษาจีน)",
    NAME_EN: "ชื่อ (ภาษาอังกฤษ)",
    CREATE: "สร้าง",
    YOU_CAN_EDIT_THIS_LATER:
      "คุณจะต้องระบุชื่อในตอนนี้เท่านั้น คุณสามารถกรอกรายละเอียดของรายการคลินิกนี้ได้ในภายหลังในส่วนการจัดการทรัพยากรคลินิก",
    OPTION: "ตัวเลือก",
    CONFIGURE_CLINIC_OPTION: "กำหนดค่าตัวเลือกคลินิก",
    CLINIC_OPTIONS: "ทางเลือกของคลินิก",
    OPTION_ITEM_INFO: "ข้อมูลรายการตัวเลือก",
    ADD_ITEM: "เพิ่มรายการ",
    PLZ_INPUT_ITEM_NAME_CN: "กรุณาระบุชื่อรายการเป็นภาษาจีน",
    PLZ_INPUT_ITEM_NAME_EN: "กรุณากรอกชื่อรายการเป็นภาษาอังกฤษ",
    PLZ_INPUT_ITEM_NAME_X: "กรุณากรอกชื่อรายการเป็น{{X}}",
    SEARCH_OPTION_ITEM_NAME: "ค้นหาชื่อรายการตัวเลือก",
    SIGN_AND_UPLOAD: "ลงชื่อและอัพโหลด",
    DRAW_YOUR_SIGNATURE: "วาดลายเซ็นของคุณ",
    SIGNATURE_UPLOADED: "อัปโหลดลายเซ็นแล้ว",
    SIGNATURE_DELETED: "ลบลายเซ็นแล้ว",
    NO_RECORDS_FOUND: "ไม่พบบันทึก",
    CLINIC_POINT_GROUPS: "กลุ่มคะแนนคลินิก",
    CONFIGURE_CLINIC_POINT_GROUPS: "กำหนดค่ากลุ่มคะแนนคลินิก",
    ADD_POINT_GROUP: "เพิ่มพอยต์ กลุ่ม",
    ALL_POINTS_IN_X_HAS_ADDED: "เพิ่มจุดทั้งหมดใน {{X}} แล้ว",
    POINT_GROUPS_NAME: "ชื่อกลุ่มคะแนน",
    POINT_GROUPS_NAME_IN_X: "ชื่อกลุ่มคะแนน({{X}})",
    POINT_GROUP_INFO: "ข้อมูลกลุ่มจุด",
    PLZ_INPUT_POINT_GROUP_NAME_CN: "กรุณากรอกชื่อกลุ่มคะแนนเป็นภาษาจีน",
    PLZ_INPUT_POINT_GROUP_NAME_EN: "กรุณากรอกชื่อกลุ่มคะแนนเป็นภาษาอังกฤษ",
    PLZ_INPUT_POINT_GROUP_NAME_X: "กรุณากรอกชื่อกลุ่มคะแนนเป็น{{X}}",
    SEARCH_POINT_NAME_HERE: "ค้นหาชื่อจุดที่นี่",
    POINTS_IN_THIS_GROUP: "คะแนนในกลุ่มนี้",
    ADD_TO_CLINIC_POINT_GROUPS: "เพิ่มในกลุ่มคะแนนคลินิก",
    NO_POINT_ADDED: "ไม่มีการเพิ่มประเด็น",
    CONTINUE: "ดำเนินการต่อ",
    REMOVE_PRACTITIONER_SUCCESS: "ลบผู้ประกอบวิชาชีพเรียบร้อยแล้ว",
    SEARCHING_CLINICS: "กำลังค้นหาคลินิก...",
    INVITE_SUCCESS: "ส่งคำเชิญเรียบร้อยแล้ว",
    ITEM_CREATED: "สร้างรายการสำเร็จแล้ว",
    PRACTITIONER_QUIT_REJECTED: "การลาออกของผู้ประกอบวิชาชีพถูกปฏิเสธ",
    PRACTITIONER_QUIT_ACCEPTED: "ยอมรับการลาออกของผู้ประกอบวิชาชีพแล้ว",
    PLEASE_ADD_AT_LEAST_ONE_HERB: "โปรดเพิ่มสมุนไพรอย่างน้อยหนึ่งชนิด",
    PLEASE_ADD_AT_LEAST_ONE_POINT: "โปรดเพิ่มอย่างน้อยหนึ่งจุด",
    INSURANCE_INFO_UPDATED: "อัปเดตข้อมูลประกันภัยแล้ว",
    REPORTING: "การรายงาน",
    CHECK_YOUR_REPORTING: "ตรวจสอบการรายงานของคุณ",
    CLINIC_REPORTING: "การรายงานทางคลินิก",
    CHECK_YOUR_CLINIC_REPORTING: "ตรวจสอบการรายงานของคลินิกของคุณ",
    SELECT_DEFAULT_DATE_UNIT: "เลือกหน่วยวันที่เริ่มต้น",
    DAY: "วัน",
    MONTH: "เดือน",
    YEAR: "ปี",
    PATIENTS_AND_REVENUE: "ผู้ป่วยและรายได้",
    PATIENTS: "ผู้ป่วย",
    REVENUE: "รายได้",
    PEOPLE_UNIT: "คน",
    AVERAGE_REVENUE: "รายได้เฉลี่ย",
    PLEASE_SELECT_VALID_DATE_RANGE_90_DAYS: "โปรดเลือกช่วงวันที่ที่ถูกต้องภายใน 90 วัน",
    PLEASE_SELECT_VALID_DATE_RANGE_36_MONTHS: "โปรดเลือกช่วงวันที่ที่ถูกต้องภายใน 36 เดือน",
    PLEASE_SELECT_VALID_DATE_RANGE_10_YEARS: "โปรดเลือกช่วงวันที่ที่ถูกต้องภายใน 10 ปี",
    PRINT_INSTRUCTION: "ดาวน์โหลดใบสั่งยา",
    PRINT_TCM_INSTRUCTION: "ดาวน์โหลดใบสั่งยาจีน",
    PRINT_MASSAGE_INSTRUCTION: "ดาวน์โหลดคู่มือจุดฝังเข็ม",
    MAXIMUM_NUMBER_OF_USERS: "ถึงจำนวนผู้ใช้สูงสุดแล้ว",
    HERB_WITH_ZERO_RAW_EXISTS_PLS_CHECK: "ปริมาณต้องไม่เป็นศูนย์ โปรดตรวจสอบใบสั่งยาของคุณ",
    NO_GST: "ไม่รวม GST",
    INC_GST: "รวม GST",
    PRESCRIPTION_RECORDS: "บันทึกใบสั่งยา",
    CLINIC_SERVICES: "บริการคลินิก",
    LOADING_SERVICES: "กำลังโหลดบริการ",
    AND_OTHER_COUNT: " และอื่นๆ {{count}}",
    WHO_IS_THIS_APPOINTMENT_FOR: "นัดนี้เหมาะกับใครบ้าง?",
    MYSELF: "ตัวฉันเอง",
    SOMEONE_ELSE: "คนอื่น",
    ABOUT_YOU: "เกี่ยวกับคุณ",
    ABOUT_THE_PATIENT: "เกี่ยวกับผู้ป่วย",
    PREVIOUS: "ก่อนหน้า",
    APPROVED: "อนุมัติแล้ว",
    I_AGREE_TO_RECEIVE_SMS: "ฉันตกลงที่จะรับการแจ้งเตือน SMS เกี่ยวกับการอัปเดตการนัดหมายนี้",
    I_AGREE_TO_RECEIVE_SMS_EMAIL: "ฉันตกลงที่จะรับ SMS / อีเมลแจ้งเตือนเกี่ยวกับการอัปเดตการนัดหมายนี้",
    SELECT_PRACTITIONER: "เลือกผู้ประกอบวิชาชีพ",
    CREATE_APPOINTMENT: "การนัดหมาย",
    ADD_APPOINTMENT: "สร้างการนัดหมาย",
    NO_AVAILABLE_CLINIC: "ไม่มีคลินิกให้บริการ",
    NO_SERVICES_AVAILABLE: "ไม่มีบริการ",
    IS_ALREADY_BOOKED: "มีคนอื่นจองแล้ว",
    TIME_ALREADY_BOOKED: "เวลาที่จองไว้แล้ว",
    YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
      "การจองนี้จะทริกเกอร์การจองเกิน แต่เนื่องจากคุณ (ผู้ประกอบวิชาชีพ) เป็นผู้สร้างการจอง จึงจะได้รับการอนุมัติโดยอัตโนมัติจากระบบ",
    ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME: "คุณแน่ใจหรือไม่ว่าต้องการจองในครั้งนี้?",
    PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "โปรดเลือกอย่างน้อยหนึ่งบริการ",
    May: "พฤษภาคม",
    June: "มิถุนายน",
    July: "กรกฎาคม",
    August: "สิงหาคม",
    September: "กันยายน",
    October: "ตุลาคม",
    November: "พฤศจิกายน",
    December: "ธันวาคม",
    January: "มกราคม",
    February: "กุมภาพันธ์",
    March: "มีนาคม",
    April: "เมษายน",
    Mon: "จ.",
    Tue: "อ.",
    Wed: "พ.",
    Thu: "พฤ.",
    Fri: "ศ.",
    Sat: "ส.",
    Sun: "อา.",
    Jan: "ม.ค.",
    Feb: "ก.พ.",
    Mar: "มี.ค.",
    Apr: "เม.ย.",
    Jun: "มิ.ย.",
    Jul: "ก.ค.",
    Aug: "ส.ค.",
    Sep: "ก.ย.",
    Oct: "ต.ค.",
    Nov: "พ.ย.",
    Dec: "ธ.ค.",
    REMEDIAL_MASSAGE: "การนวดบำบัด",
    REMEDIAL_MASSAGE_OPTION: "การนวดบำบัด",
    DEEP_TISSUE_MASSAGE: "นวดเนื้อเยื่อชั้นลึก",
    SPORTS_MASSAGE: "นวดกีฬา",
    DRY_NEEDLING: "การรักษาด้วยเข็มแห้ง",
    CUPPING: "ครอบแก้ว",
    PREGNANCY_MASSAGE: "นวดสำหรับหญิงตั้งครรภ์",
    MYOTHERAPY: "ไมโอเธอราพี",
    ASSISTED_STRETCHING: "การยืดเหยียดแบบมีผู้ช่วย",
    TRIGGER_PT_THERAPY: "การบำบัดจุดกดเจ็บ",
    MYOFASCIAL_RELEASE: "การคลายพังผืดกล้ามเนื้อ",
    JOINT_MOBILISATION: "การขยับข้อต่อ",
    PHYSIO: "กายภาพบำบัด",
    CHIRO: "ไคโรแพรคติก",
    BEAUTY: "ความงาม",
    COSMETIC_MEDICINE: "เวชศาสตร์ความงาม",

    SELECT_SERVICE: "เลือก {{service}} บริการ",
    MAXIMUM_NUMBER_OF_FILES: "ถึงจำนวนไฟล์สูงสุดแล้ว ({{X}})",
    MULTIPLE_SELECT: "เลือกหลายรายการ",
    CANCEL_MULTIPLE_SELECT: "ยกเลิกการเลือกหลายรายการ",
    ARE_YOU_SURE_TO_DELETE_THIS_APPOINTMENT_FOR_X:
      "คุณแน่ใจหรือไม่ว่าต้องการลบการนัดหมายนี้สำหรับ {{X}}? การแจ้งเตือนการยกเลิกจะถูกส่งไปยังผู้ป่วย",
    DELETE_APPOINTMENT: "ลบการนัดหมาย",
    REJECT_APPOINTMENT: "ปฏิเสธการนัดหมาย",
    SYSTEM_OPTIMIZED_FOR_DESKTOP: "ระบบนี้ได้รับการปรับให้เหมาะสมสำหรับการใช้งานเดสก์ท็อป",
    RECOMMEND_DESKTOP_FOR_BEST_EXPERIENCE: "เพื่อประสบการณ์ที่ดีที่สุด เราขอแนะนำให้เข้าถึงเว็บไซต์ผ่านพอร์ทัลเดสก์ท็อป",
    PROMOTION_CODE: "รหัสโปรโมชั่น",
    PLEASE_SELECT_VALID_DATE_RANGE: "โปรดเลือกช่วงวันที่ที่ถูกต้อง",
    PLEASE_CHECK_THE_FORM: "กรุณาตรวจสอบแบบฟอร์ม",
    TIMESLOT_HAS_BOOKED_BY_OTHER_PATIENT: "ช่วงเวลานี้ถูกจองโดยผู้ป่วยรายอื่นแล้ว",
    NO_AVAILABLE_TIMESLOT_FOUND_IN_THIS_DATE: "ไม่มีช่วงเวลาที่ว่างสำหรับวันที่นี้",
    APPOINTMENT_SCHEDULE_APPROVED: "อนุมัติการนัดหมายแล้ว",
    FORGOT_PASSWORD: "ลืมรหัสผ่าน",
    WE_SENT_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS: "เราได้ส่งรหัสยืนยันแล้ว กรุณาตรวจสอบ SMS ของคุณ",
    SEND_VERIFY_CODE: "ส่งรหัสยืนยัน",
    RESEND_VERIFY_CODE: "ส่งรหัสยืนยันอีกครั้ง",
    PLEASE_ENTER_YOUR_VERIFICATION_CODE: "กรุณากรอกรหัสยืนยันของคุณ",
    VERIFICATION_CODE: "รหัสยืนยัน",
    PLEASE_ENTER_YOUR_NEW_PASSWORD: "กรุณากรอกรหัสผ่านใหม่ของคุณ",
    PLEASE_ENTER_YOUR_NEW_PASSWORD_AGAIN: "กรุณากรอกรหัสผ่านใหม่ของคุณอีกครั้ง",
    NEW_PASSWORD: "รหัสผ่านใหม่",
    SEND_TO: "ส่งไปที่",
    OR: "หรือ",
    WE_WILL_SEND_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS: "เราจะส่งรหัสยืนยันไปให้ กรุณาตรวจสอบ SMS ของคุณ",
    WRONG_VERIFY_CODE: "รหัสยืนยันไม่ถูกต้อง",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY: "SMS ส่งบ่อยเกินไป โปรดรอ 3 นาทีก่อนลองอีกครั้ง",
    USERNAME_NOT_FOUND: "ไม่พบข้อมูลผู้ใช้ กรุณาตรวจสอบข้อมูลของคุณ",
    CHANGE_PASSWORD_SUCCESS: "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
    SMS_SENT: "SMS ส่งแล้ว",
    REQUEST_REJECTED: "คำขอถูกปฏิเสธ",
    INVITED_SUCCESS: "ส่งคำเชิญเรียบร้อยแล้ว",
    CONTINUE: "ดำเนินการต่อ",
    VIP_PACKAGE_EXPIRED:
      "การสมัครสมาชิก VIP ของคุณหมดอายุหรือถูกปิดใช้งาน คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้อีกต่อไป",
    RECORDING_TOO_SHORT: "บันทึกสั้นเกินไป ไม่สามารถดึงข้อมูลได้!",
    TRANSCRIPT_EMPTY_TRY_AGAIN: "เนื้อหาว่างเปล่า กรุณาลองใหม่อีกครั้ง",
    MORNING: "ยามเช้า",
    AFTERNOON: "ช่วงบ่าย",
    DOWNLOAD_INVOICE: "ดาวน์โหลดใบแจ้งหนี้",
    OTHER_PHOTO: "รูปภาพอื่นๆ",
    DIAGNOSIS_DESCRIPTION: "คำอธิบาย",
    SET_AS_HOME: "ตั้งเป็นหน้ารายการ",
    APPOINTMENT_DETAILS: "รายละเอียดการนัดหมาย",
    SEARCH_AND_USE_EXISTING_PATIENT_INFO: "ค้นหาและใช้ข้อมูลผู้ป่วยที่มีอยู่",
    OP_TYPE: "ประเภทตัวเลือก",
    CANCEL_INVITATION: "ยกเลิกคำเชิญ",
    ARE_U_SURE_TO_CANCEL_THIS_INVITATION: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำเชิญนี้",
    ARE_YOU_SURE_TO_DELETE_X_ITEMS: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการ {{X}}?",
    PROFILE: "โปรไฟล์",
    UPDATE: "อัปเดต",
    PROFILE_UPDATED: "อัปเดตโปรไฟล์แล้ว",
    INVITE_PRACTITIONER_TO_JOIN_CLINIC:
      "ผู้ประกอบวิชาชีพที่คุณค้นหาอาจยังไม่ได้เป็นผู้ใช้ของเรา คลิกปุ่มด้านล่างเพื่อเชิญพวกเขาให้สร้างบัญชีและเข้าร่วมคลินิกของคุณ",
    PRACTITIONER_U_SEARCHED_MAY_NOT_BE_USER_YET: "ผู้ประกอบวิชาชีพที่คุณค้นหาอาจไม่ใช่ผู้ใช้ระบบของเรา",
    CLICK_BUTTON_BELOW_TO_INVITE: "คลิกปุ่มด้านล่างเพื่อเชิญพวกเขาให้สร้างบัญชีและเข้าร่วมคลินิกของคุณ!",
    INVITE_NEW_USER: "เชิญผู้ใช้ใหม่",
    NEW_REQUESTS: "คำขอที่รอดำเนินการ",
    PLZ_SIGN_IN: "กรุณาเข้าสู่ระบบก่อน",
    SELECT_YOUR_SPECIALTY: "โปรดเลือกประเภทบริการของคุณ",
    EXPIRED_AT: "หมดอายุเมื่อ",
    PENDING_USER_SIGNUP: "การลงทะเบียนผู้ใช้ที่รอดำเนินการ",
    RESEND_EMAIL: "ส่งอีเมลอีกครั้ง",
    RESEND_EMAIL_SUCCESS: "ส่งอีเมลเรียบร้อยแล้ว",
    DAYS_LEFT_X: "หมดอายุใน {{X}} วัน",
    ASSIGN_A_PACKAGE: "กำหนดแพ็คเกจสำหรับผู้ประกอบวิชาชีพรายนี้",
    ASSIGN_A_ROLE: "กำหนดบทบาท",
    PATIENT_CONSENT: "ความยินยอมของผู้ป่วย",
    PLEASE_SELECT_A_PACKAGE: "กรุณาเลือกแพ็กเกจ",
    REJECT_SUCCESS: "คำขอถูกปฏิเสธ",
    ACCEPT_SUCCESS: "ยอมรับคำขอแล้ว",
    ARE_YOU_SURE_TO_DELETE_THIS_TEST: "คุณแน่ใจที่จะลบการทดสอบนี้หรือไม่?",
    FILE_TOO_LARGE_MAX_100MB: "ไฟล์มีขนาดใหญ่เกินไป ขนาดสูงสุดที่อนุญาตคือ 100MB",
    BEST_UPLOAD_PRACTICE:
      "เพื่อประสบการณ์ที่ดีที่สุด โปรดเก็บแต่ละไฟล์ไว้ไม่เกิน 100MB และตรวจสอบให้แน่ใจว่าวิดีโอที่บันทึกไว้จะใช้เวลาภายใน 30 วินาที",
    REVIEW_REVIEW: "รีวิว",
    CAN_NOT_START_WITH_NUMBER: "ไม่สามารถขึ้นต้นด้วยตัวเลขได้",
    PACKAGE_NAME: "ชื่อแพ็คเกจ",
    OG_PRICE: "ราคาเดิม",
    INSURANCE_NAME: "ชื่อประกัน",
    USER_ALREADY_BEEN_TAKEN: "ชื่อผู้ใช้ถูกใช้ไปแล้ว โปรดลองชื่อผู้ใช้อื่น",
    INVALID_FORMAT:
      "ชื่อผู้ใช้อาจไม่ถูกต้อง (เช่น ชื่อผู้ใช้ไม่สามารถเริ่มต้นด้วยตัวเลขหรือมีการเว้นวรรค)",
    LOGIN_USERNAME: "ชื่อผู้ใช้เข้าสู่ระบบ",
    CONNECT_FAILED: "ไม่สามารถเชื่อมต่อกับบริการ AI ได้",
    CONNECTING_AI: "กำลังเชื่อมต่อกับ AI",
    U_CAN_NOW_START_SPEAKING: "ตอนนี้คุณสามารถเริ่มพูดได้แล้ว",
    UNIT_NO_SHOP_NO: "หมายเลขยูนิต/หมายเลขร้านค้า",
    STREET_NO: "ถนนเลขที่",
    STREET_NAME: "ชื่อถนน",
    CLINIC_NAME_IS_REQUIRED: "ต้องระบุชื่อคลินิก",
    CLINIC_CREATED: "สร้างคลินิกแล้ว",
    PERSONAL_WEB: "เว็บไซต์ของฉัน",
    SLUG_CHAR_TYPE_LIMIT: "อนุญาตให้ใช้เฉพาะตัวอักษร ตัวเลข และ '-' เท่านั้น",
    CHECK_THIS_CLINIC_PACKAGES: "ตรวจสอบแพ็คเกจปัจจุบันของคลินิกนี้",
    TYPE_TO_SEARCH: "พิมพ์เพื่อค้นหา",
    PLEASE_ENTER_VALID_PHONE_NUMBER: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    NO_AVAILABLE_PACKAGES: "ไม่พบแพ็คเกจที่ใช้ได้",
    PLEASE_PURCHASE_PACKAGE_FIRST: "โปรดซื้อแพ็คเกจ VIP ก่อนที่จะเชิญผู้ใช้",
    ASSIGNED_TO: "มอบหมายให้",
    PERSONAL: "ผู้ใช้ส่วนตัว (ตัวฉันเอง)",
    RECEIPT_GENERATING: "กำลังสร้างใบเสร็จรับเงิน",
    RECEIPT_GENERATING_PLZ_WAIT: "กำลังสร้างใบเสร็จ โปรดรอสักครู่",
    INSTRUCTION_GENERATING: "กำลังสร้างคำสั่ง",
    STREET_TYPE: "ประเภทถนน",
    SUMMARY: "ทบทวนและสรุป",
    FEATURE_PREVIEW_VIDEO_NOTE:
      "วิดีโอนี้เป็นการแสดงตัวอย่างคุณลักษณะ ซื้อแผนวีไอพีที่เกี่ยวข้องเพื่อปลดล็อคฟังก์ชันนี้",
    FEATURE_PURCHASE_HINT_FOR_CLINIC_OWNER: "หากคุณเป็นเจ้าของคลินิก กรุณาคลิกปุ่มด้านล่างเพื่อซื้อ",
    TODAY: "วันนี้",
    CLOSED_TODAY: "วันนี้ไม่ทำงานที่นี่",
    GENERATING_NEW_WINDOW_MSG:
      "ไฟล์จะเปิดขึ้นมาในหน้าต่างใหม่ โปรดตรวจสอบการตั้งค่าเบราว์เซอร์ของคุณและอนุญาตป๊อปอัป",
    DISCONNECTED_SUCCESSFULLY: "ตัดการเชื่อมต่อเรียบร้อยแล้ว",
    PATIENT_VISIT_FLOW: "บทช่วยสอนคู่มือการเยี่ยมผู้ป่วย",
    PATIENT_CHECKIN_AND_VISIT:
      "ภาพรวมของขั้นตอนการเยี่ยมผู้ป่วยที่สมบูรณ์ รวมถึงการนัดหมายและการเข้าพบ การเช็คอินของผู้ป่วย การสร้างบันทึก และการเข้าร่วมการให้คำปรึกษา",
    SYSTEM_SETTING_SUMMARY: "บทแนะนำภาพรวมการตั้งค่าระบบ",
    SYSTEM_SETTING_OVERVIEW: "ภาพรวมโดยย่อของคุณสมบัติการกำหนดค่าหลักและจุดเริ่มต้นใน Healthnex",
    SYSTEM_SETTING_WORK_TIME_SETTING: "การตั้งค่าระบบ - บทช่วยสอนการตั้งค่าเวลาทำงาน",
    SYSTEM_SETTING_WORKTIME:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการตั้งค่าและจัดการตารางเวลาการทำงานของผู้ปฏิบัติงานภายในระบบ",
    APPOINTMENT_SUMMARY: "บทช่วยสอนภาพรวมการนัดหมาย",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "ภาพรวมเกี่ยวกับวิธีการทำงานของการนัดหมายใน Healthnex และวิธีการต่างๆ ที่สามารถสร้างได้",
    APPOINTMENT_CREATE: "การนัดหมาย - การสร้างบทช่วยสอนการนัดหมาย",
    HOW_TO_CREATE_APPOINTMENT:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการสร้างการนัดหมายสำหรับผู้ป่วย รวมถึงการเลือกบริการ ผู้ปฏิบัติงาน และช่วงเวลา เรียนรู้วิธีสร้างการนัดหมายผ่านพอร์ทัลผู้ประกอบวิชาชีพ เว็บไซต์ส่วนตัว หรือหน้าแรกของ Healthnex",
    APPOINTMENT_MANAGE: "การนัดหมาย - บทช่วยสอนการจัดการการนัดหมาย",
    VIEW_EDIT_CANCEL_APPOINTMENT: "เรียนรู้วิธีดู แก้ไข กำหนดเวลาใหม่ และยกเลิกการนัดหมายภายในระบบ Healthnex",
    PRESCRIPTION_SUMMARY: "บทแนะนำภาพรวมการสั่งยา",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "ภาพรวมของการให้คำปรึกษาอันชาญฉลาดและเวิร์กโฟลว์การสั่งยาตามใบสั่งแพทย์ และขั้นตอนหลัก 5 ขั้นตอน",
    PRESCRIPTION_SYMPTOM: "ใบสั่งยา - การสอนเกี่ยวกับอาการ",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "บันทึกอาการของผู้ป่วยอย่างรวดเร็วโดยใช้เสียงหรือข้อความ โดยมี AI-ช่วยจัดโครงสร้างและการแปล",
    PRESCRIPTION_DIAGNOSIS: "ใบสั่งยา - บทช่วยสอนการวินิจฉัย",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION: "บันทึกการประเมินทางคลินิก เลือกหลักการรักษา และสร้างเนื้อหาการวินิจฉัยที่เป็นมาตรฐาน",
    PRESCRIPTION_TREATMENT: "ใบสั่งยา - บทแนะนำการรักษา",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "เลือกวิธีการรักษา เช่น ยาสมุนไพรหรือการฝังเข็ม กรอกใบสั่งยาให้ครบถ้วน และบันทึกเทมเพลตคลินิกที่ใช้ซ้ำได้",
    PRESCRIPTION_PAYMENT: "ใบสั่งยา - บทแนะนำการชำระเงิน",
    PRESCRIPTION_PAYMENT_DESCRIPTION: "ตรวจสอบค่าธรรมเนียม ทำประกัน ถ้ามี และชำระเงินค่าเข้าชมให้เสร็จสิ้น",
    PRESCRIPTION_CONCLUSION: "ใบสั่งยา - บทช่วยสอนแบบสรุป",
    PRESCRIPTION_CONCLUSION_DESCRIPTION: "ตรวจสอบเวชระเบียนให้ครบถ้วน พิมพ์ใบสั่งยาและใบเสร็จรับเงิน และสรุปการนัดตรวจ",
    PERSONAL_WEBSITE_SUMMARY: "บทช่วยสอนภาพรวมเว็บไซต์ส่วนตัว",
    PERSONAL_WEBSITE_OVERVIEW: "ภาพรวมของเว็บไซต์ส่วนตัวของผู้ประกอบวิชาชีพ รวมถึงส่วนโปรไฟล์และคุณลักษณะการจอง",
    EDIT_AND_PUBLISH: "เว็บไซต์ส่วนตัว - แก้ไขและเผยแพร่บทช่วยสอน",
    EDIT_AND_PUBLISH_WEBSITE:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการแก้ไขเนื้อหาเว็บไซต์ส่วนตัวของคุณ ดูตัวอย่างเค้าโครง และเผยแพร่สำหรับการจองของผู้ป่วย",
    PATIENT_VISIT_FLOW: "บทช่วยสอนคู่มือการเยี่ยมผู้ป่วย",
    PATIENT_CHECKIN_AND_VISIT:
      "ภาพรวมของขั้นตอนการเยี่ยมผู้ป่วยที่สมบูรณ์ รวมถึงการนัดหมายและการเข้าพบ การเช็คอินของผู้ป่วย การสร้างบันทึก และการเข้าร่วมการให้คำปรึกษา",
    SYSTEM_SETTING_SUMMARY: "บทแนะนำภาพรวมการตั้งค่าระบบ",
    SYSTEM_SETTING_OVERVIEW: "ภาพรวมโดยย่อของคุณสมบัติการกำหนดค่าหลักและจุดเริ่มต้นใน Healthnex",
    SYSTEM_SETTING_WORK_TIME_SETTING: "การตั้งค่าระบบ - บทช่วยสอนการตั้งค่าเวลาทำงาน",
    SYSTEM_SETTING_WORKTIME:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการตั้งค่าและจัดการตารางเวลาการทำงานของผู้ปฏิบัติงานภายในระบบ",
    APPOINTMENT_SUMMARY: "บทช่วยสอนภาพรวมการนัดหมาย",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "ภาพรวมเกี่ยวกับวิธีการทำงานของการนัดหมายใน Healthnex และวิธีการต่างๆ ที่สามารถสร้างได้",
    APPOINTMENT_CREATE: "การนัดหมาย - การสร้างบทช่วยสอนการนัดหมาย",
    HOW_TO_CREATE_APPOINTMENT:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการสร้างการนัดหมายสำหรับผู้ป่วย รวมถึงการเลือกบริการ ผู้ปฏิบัติงาน และช่วงเวลา เรียนรู้วิธีสร้างการนัดหมายผ่านพอร์ทัลผู้ประกอบวิชาชีพ เว็บไซต์ส่วนตัว หรือหน้าแรกของ Healthnex",
    APPOINTMENT_MANAGE: "การนัดหมาย - บทช่วยสอนการจัดการการนัดหมาย",
    VIEW_EDIT_CANCEL_APPOINTMENT: "เรียนรู้วิธีดู แก้ไข กำหนดเวลาใหม่ และยกเลิกการนัดหมายภายในระบบ Healthnex",
    PRESCRIPTION_SUMMARY: "บทแนะนำภาพรวมการสั่งยา",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "ภาพรวมของการให้คำปรึกษาอันชาญฉลาดและเวิร์กโฟลว์การสั่งยาตามใบสั่งแพทย์ และขั้นตอนหลัก 5 ขั้นตอน",
    PRESCRIPTION_SYMPTOM: "ใบสั่งยา - การสอนเกี่ยวกับอาการ",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "บันทึกอาการของผู้ป่วยอย่างรวดเร็วโดยใช้เสียงหรือข้อความ โดยมี AI-ช่วยจัดโครงสร้างและการแปล",
    PRESCRIPTION_DIAGNOSIS: "ใบสั่งยา - บทช่วยสอนการวินิจฉัย",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION: "บันทึกการประเมินทางคลินิก เลือกหลักการรักษา และสร้างเนื้อหาการวินิจฉัยที่เป็นมาตรฐาน",
    PRESCRIPTION_TREATMENT: "ใบสั่งยา - บทแนะนำการรักษา",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "เลือกวิธีการรักษา เช่น ยาสมุนไพรหรือการฝังเข็ม กรอกใบสั่งยาให้ครบถ้วน และบันทึกเทมเพลตคลินิกที่ใช้ซ้ำได้",
    PRESCRIPTION_PAYMENT: "ใบสั่งยา - บทแนะนำการชำระเงิน",
    PRESCRIPTION_PAYMENT_DESCRIPTION: "ตรวจสอบค่าธรรมเนียม ทำประกัน ถ้ามี และชำระเงินค่าเข้าชมให้เสร็จสิ้น",
    PRESCRIPTION_CONCLUSION: "ใบสั่งยา - บทช่วยสอนแบบสรุป",
    PRESCRIPTION_CONCLUSION_DESCRIPTION: "ตรวจสอบเวชระเบียนให้ครบถ้วน พิมพ์ใบสั่งยาและใบเสร็จรับเงิน และสรุปการนัดตรวจ",
    PERSONAL_WEBSITE_SUMMARY: "บทช่วยสอนภาพรวมเว็บไซต์ส่วนตัว",
    PERSONAL_WEBSITE_OVERVIEW: "ภาพรวมของเว็บไซต์ส่วนตัวของผู้ประกอบวิชาชีพ รวมถึงส่วนโปรไฟล์และคุณลักษณะการจอง",
    EDIT_AND_PUBLISH: "เว็บไซต์ส่วนตัว - แก้ไขและเผยแพร่บทช่วยสอน",
    EDIT_AND_PUBLISH_WEBSITE:
      "คำแนะนำทีละขั้นตอนเกี่ยวกับวิธีการแก้ไขเนื้อหาเว็บไซต์ส่วนตัวของคุณ ดูตัวอย่างเค้าโครง และเผยแพร่สำหรับการจองของผู้ป่วย",
    RESET_PASSWORD: "รีเซ็ตรหัสผ่าน",
    PLEASE_ENTER_YOUR_CURRENT_PASSWORD: "กรุณากรอกรหัสผ่านปัจจุบันของคุณ",
    PLEASE_ENTER_DIFFERENT_PASSWORD: "โปรดป้อนรหัสผ่านอื่นจากรหัสผ่านปัจจุบัน",
    CONFIG_PRINT_UNIT_IN_EACH_CMT: "หมายเหตุ: หน่วยขนาดยาที่พิมพ์จะเป็นไปตามการตั้งค่าภายในใบสั่งยาจีนแต่ละราย",
    AT_LEAST_ONE_PRINT_OPTION_REQUIRED: "โปรดเลือกอย่างน้อยหนึ่งหน่วยที่จะแสดง",
    CHECKBOX_SHOW_RAW_UNIT_IN_PRINT: "เลือกเพื่อแสดงปริมาณสมุนไพรดิบเมื่อพิมพ์",
    CHECKBOX_SHOW_GRAN_UNIT_IN_PRINT: "เลือกเพื่อแสดงปริมาณเม็ดเมื่อพิมพ์",
    SHOW_RAW_UNIT_IN_PRINT: "แสดงหน่วยสมุนไพรดิบในการพิมพ์",
    HIDE_RAW_UNIT_IN_PRINT: "ซ่อนหน่วยสมุนไพรดิบในการพิมพ์",
    SHOW_GRAN_UNIT_IN_PRINT: "แสดงหน่วยเม็ดในการพิมพ์",
    HIDE_GRAN_UNIT_IN_PRINT: "ซ่อนหน่วยเม็ดเล็กในการพิมพ์",
    CONNECTION_FAILED: "การเชื่อมต่อล้มเหลว",
    PURCHASED_AT: "ซื้อได้ที่",
    SELECTED: "เลือกแล้ว",
    PERSONALIZATION: "การปรับแต่งส่วนบุคคล",
    PERSONALIZE_YOUR_SYSTEM: "ปรับแต่งระบบของคุณ",
    APPOINTMENT_TIMESLOT_STYLE: "รูปแบบช่วงเวลาการนัดหมาย",
    DROPDOWN_STYLE: "รูปแบบแบบเลื่อนลง",
    SLIDE_STYLE: "ลักษณะปุ่ม",
    PERSONALIZE_YOUR_TIMESLOT_STYLE: "ปรับแต่งสไตล์ช่วงเวลาของคุณ",
    FORM_HAS_NOT_BEEN_SAVED_U_SURE_LEAVE_NOW: "แบบฟอร์มนี้ยังไม่ได้ถูกบันทึก คุณแน่ใจหรือว่าจะออกไปตอนนี้?",
    PAGE_NOT_FOUND: "ไม่พบเพจ",
    THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED: "ไม่พบหน้าที่ร้องขอ",
    WE_COULDNT_FIND_THE_PAGE_YOU_ARE_LOOKING_FOR_IT_MAY_HAVE_BEEN_MOVED_DELETED_OR_THE_URL_MIGHT_BE_INCORRECT: "เราไม่พบหน้าที่คุณกำลังมองหา อาจถูกย้าย ลบ หรือ URL อาจไม่ถูกต้อง",
    WHAT_YOU_CAN_DO: "สิ่งที่คุณสามารถทำได้",
    CHECK_THE_URL_FOR_TYPOS_AND_TRY_AGAIN: "ตรวจสอบ URL ว่ามีการพิมพ์ผิดแล้วลองอีกครั้ง",
    USE_THE_NAVIGATION_MENU_TO_FIND_WHAT_YOU_NEED: "ใช้เมนูนำทางเพื่อค้นหาสิ่งที่คุณต้องการ",
    CONTACT_SUPPORT_IF_THE_PROBLEM_PERSISTS: "ติดต่อฝ่ายสนับสนุนหากปัญหายังคงมีอยู่",
    NEED_ASSISTANCE_CONTACT_SYSTEM_SUPPORT: "ต้องการความช่วยเหลือหรือไม่? ติดต่อเราผ่านทางเว็บไซต์อย่างเป็นทางการของ Healthnex",
    GO_TO_LOGIN: "ไปที่เข้าสู่ระบบ",
    CUSTOMER_SERVICE: "บริการลูกค้า",
    TECHNICAL_SUPPORT: "การสนับสนุนด้านเทคนิค",
    PATIENT_LIST: "รายชื่อผู้ป่วย",
    CREATED_AT: "สร้างเมื่อ",
    FILTER_BY_LAST_NAME: "กรองตามนามสกุล",
    VIEW_PATIENT_INFO: "ดูข้อมูลผู้ป่วย",
    TOTAL_PATIENTS: "ผู้ป่วยทั้งหมด",
    THIS_IS_A_X_USER_PACKAGE: "{{X}}-แพ็คเกจผู้ใช้",
    THIS_IS_A_X_USER_PACKAGE_MSG: "แพ็คเกจนี้มีราคาสำหรับผู้ใช้ {{X}} และมีส่วนลดรวมอยู่แล้ว",
    X_USERS_PER_YEAR: "{{X}} ผู้ใช้ / ปี",
    X_USERS_PER_Y_YEAR: "{{X}} ผู้ใช้ / {{Y}} ปี",
    X_USERS_PER_MONTH: "{{X}} ผู้ใช้ / เดือน",
    SECTION_CHANGED_TO: "ส่วนเปลี่ยนเป็น",
    OTHER_NON_ENGLISH_PATIENT_FIRST_NAME: "ชื่ออื่นที่ไม่ใช่ภาษาอังกฤษ",
    WELCOME_TO_HEATHNEX: "ยินดีต้อนรับสู่ Healthnex!",
    THIS_PLATFORM_IS_DESIGNED_TO_PROVIDE_A_MODERN_AND_EFFICIENT_WAY_TO_MANAGE_YOUR_CLINIC_PRESCRIPTION:
      "Healthnex เป็นแพลตฟอร์มการจัดการทางคลินิกที่ทันสมัย ​​ซึ่งได้รับการออกแบบมาเพื่อปรับปรุงขั้นตอนการทำงานของใบสั่งยาและปรับปรุงประสิทธิภาพการปฏิบัติงานในแต่ละวัน",
    ALSO_AIMS_TO_BUILD_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES:
      "สร้างขึ้นโดยเฉพาะสำหรับผู้ปฏิบัติงานด้านการแพทย์แผนจีน (TCM) Healthnex นำการจัดการใบสั่งยา การวางแผนการรักษา และบันทึกทางคลินิกมารวมกันไว้ในระบบเดียว",
    TO_START_LET_US_QUICK_INTRODUCE_WUT_WE_HAVE_IN_THIS_SYSTEM: "มาดูการแนะนำสั้นๆ เพื่อช่วยคุณในการเริ่มต้นกันดีกว่า",
    SYSTEM_NOTICE: "ประกาศของระบบ",
    THIS_REQUIRED_U_TO_HAVE_CLINIC_PACKAGE_SUBSCRIPTION: "การเข้าถึงคุณลักษณะนี้จำเป็นต้องสมัครสมาชิกแพ็คเกจคลินิก",
    CURRENT_WORKING_CLINIC: "คลินิกการทำงานปัจจุบัน",
    IF_U_WORKING_IN_MULTIPLE_CLINICS_YOU_CAN_SELECT_THE_CURRENT_WORKING_CLINIC_HERE: "หากคุณทำงานกับคลินิกหลายแห่ง คุณสามารถเลือกคลินิกที่คุณกำลังทำงานอยู่ที่นี่ได้",
    UR_CURRENT_PACKAGE: "แพ็คเกจการสมัครสมาชิกปัจจุบัน",
    PACKAGE_SUBSCRIPTION_ALLOW_YOU_TO_ACCESS_PREMIUM_SERVICE:
      "แพ็คเกจการสมัครสมาชิกให้สิทธิ์การเข้าถึงคุณสมบัติระดับพรีเมียม ตัวอย่างเช่น แพ็คเกจคลินิกช่วยให้สามารถจัดการใบสั่งยาและการจัดการผู้ป่วยได้ ในขณะที่แพ็คเกจเว็บไซต์ส่วนตัวช่วยให้คุณเผยแพร่เว็บไซต์ส่วนตัวที่เข้าถึงได้แบบสาธารณะ",
    CHANGE_UR_SYSTEM_LANGUAGE_HERE: "เปลี่ยนภาษาของระบบ UR ที่นี่",
    ACCOUNT_MENU: "เมนูบัญชี",
    U_CAN_VIEW_UPDATE_UR_ACCOUNT_DETAIL_HERE_LIKE_PASSWORD: "ดูและอัปเดตข้อมูลบัญชีของคุณ รวมถึงรหัสผ่านและการตั้งค่าความปลอดภัย",
    VIEW_ALL_UR_PATIENTS_HERE: "ดูและจัดการผู้ป่วยทั้งหมดที่เกี่ยวข้องกับคลินิกของคุณ",
    CREATE_JOIN_MANAGE_UR_CLINIC_HERE: "สร้าง เข้าร่วม หรือจัดการคลินิกของคุณจากที่นี่",
    CONFIGURE_WORKING_TIME_IN_CLINIC_FOR_PATIENT_TO_SCHEDULE_APPOINTMENT: "กำหนดเวลาทำการของคลินิกเพื่อให้ผู้ป่วยสามารถกำหนดเวลาการนัดหมายได้",
    THIS_REQUIRED_U_TO_HAVE_PERSOANL_WEBSITE_PACKAGE_SUBSCRIPTION_TO_PUBLISH: "การเผยแพร่จำเป็นต้องมีการสมัครสมาชิกแพ็คเกจเว็บไซต์ส่วนตัวที่ใช้งานอยู่",
    MORE_TUTORIALS_TO_FOLLOW: "บทช่วยสอนเพิ่มเติมที่ต้องปฏิบัติตาม",
    ALTERNATIVELY_HERE_YOU_CAN_FIND_MORE_TUTORIALS_TO_FOLLOW_ABOUT_HOW_TO_USE_THIS_PLATFORM_IN_DETAIL: "สำรวจบทช่วยสอนแบบทีละขั้นตอนเพื่อช่วยให้คุณเข้าใจและใช้งานแพลตฟอร์มได้ดียิ่งขึ้น",
    VER: "เวอร์ชัน",
    URL_NOT_SET: "ยังไม่ได้ตั้งค่า URL",
    TCM_MODE: "โหมดการวินิจฉัยแบบละเอียด",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE: "โหมดฝังเข็ม / นวด / ยาจีน",
    THIS_PACKAGE_IS_NOT_LONGER_PROVIDED_PLS_CHOOSE_ANOTHER_PACKAGE: "แพ็คเกจนี้ไม่สามารถต่ออายุได้อีกต่อไป",
    LOADING_PACKAGES: "กำลังโหลดแพ็คเกจ",
    OWNER_BUSINESS_SIGNUP: "เจ้าของธุรกิจ",
    CMBA_INFO: "ข้อมูล CMBA",
    CMBA_NUMBER: "หมายเลข CMBA",
    PLEASE_ENTER_YOUR_CMBA_NUMBER_HERE: "กรุณากรอกหมายเลข CMBA ของคุณที่นี่",
    NOTE_YOUR_CMBA_NUMBER_WILL_BE_SHOWN_ON_THE_MEDICAL_INVOICE: "หมายเหตุ: หมายเลข CMBA ที่คุณป้อนจะปรากฏบนใบเสร็จรับเงินตามใบสั่งแพทย์",
    UPDATING_CMBA_INFO: "กำลังอัปเดต CMBA ข้อมูล",
    CMBA_INFO_UPDATED: "CMBA อัปเดตข้อมูลแล้ว",
    PLEASE_ENTER_YOUR_CMBA_NUMBER: "กรุณากรอกหมายเลข CMBA ของคุณ",
    U_CAN_ENTER_MODIFY_UR_CMBA_NUMBER_HERE: "คุณสามารถป้อนหรือแก้ไขหมายเลข CMBA ของคุณได้ที่นี่",
    VIEW_EDIT_INSURANCE: "ดู/แก้ไขประกันภัย",
    IF_U_NEED_TO_RENEW_PLS_CONTACT_CLINIC_OWNER: "หากต้องการต่ออายุหรือสมัครแพ็กเกจใหม่โปรดติดต่อเจ้าของคลินิก",
    INVITE_U_TO_JOIN_THE_CLINIC: "ขอเชิญร่วมคลินิก",
    U_HAD_LEFT_FROM_BELOW_CLINICS: "คุณได้ออกจากคลินิกต่อไปนี้",
    GO_CLINIC: "ดูในคลินิก",
    FROM_X_CLINIC: "จาก {{X}}",
    CREATED_IN_CLINIC: "สร้างในคลินิก",
    PLEASE_SELECT_A_PACKAGE_FOR_THIS_PRACTITIONER: "โปรดเลือกแพ็คเกจสำหรับผู้ประกอบวิชาชีพรายใหม่นี้:",
    NEW_DURATION: "ระยะเวลา",
    OTHER_PHONE: "โทรศัพท์อื่นๆ",
    GST_INCLUDED: "รวม GST แล้ว",
    SHOW_GST_DETAIL: "แสดง GST รายละเอียด",
    COLLAPSE: "ยุบ",
    THIS_PRICE_INCLUDES_GST: "ราคานี้รวม GST แล้ว",
    FILTER_BY_INSURANCE_PROVIDER: "กรองตามกองทุนการรักษาพยาบาล",
    FILTER_BY_COMPLETION_STATUS: "กรองตามสถานะความสมบูรณ์",
    PATIENT_INSURANCES: "ประกันคนไข้",
    OTHER_PROVIDERS: "ผู้ให้บริการรายอื่น",
    WELCOME_BACK: "ยินดีต้อนรับการกลับมา",
    CREATED_IN: "สร้างใน",
    COLLAPSE_NAVIGATION: "ยุบการนำทาง",
    EXPAND_NAVIGATION: "ขยายการนำทาง",
    PRESCRIPTION_HISTORY: "ประวัติการสั่งยา",
    SEARCH_HISTORY_BY_ID_OR_PATIENT_NAME: "ค้นหาบันทึกด้วย ID หรือชื่อผู้ป่วย",
    VIEW_ALL_PRESCRIPTION_HISTORIES: "ดูวันนี้ / บันทึกใบสั่งยาทั้งหมด",
    SEARCH_PACKAGE_BY_ORDER_ID_PACKAGE_NAME: "ค้นหาแพ็คเกจตามรหัสคำสั่งซื้อ / ชื่อแพ็คเกจ",
    ORDER_NUMBER: "หมายเลขคำสั่งซื้อ",
    FILL_IN_DETAILS: "กรอกรายละเอียด",
    NOT_SCHEDULED: "ไม่ได้กำหนดเวลาไว้",
    NO_CLINICS_TO_CREATE_OR_JOIN: "ไม่มีคลินิกให้สร้างหรือเข้าร่วม",
    ACU_POINT_INFO: "ข้อมูลจุดฝังเข็ม",
    ACU_POINT_CN: "ชื่อจุดฝังเข็ม (ภาษาจีน)",
    ACU_POINT_EN: "ชื่อจุดฝังเข็ม (ภาษาอังกฤษ)",
    PLZ_INPUT_ACU_POINT_CN: "กรุณากรอกชื่อจุดฝังเข็มเป็นภาษาจีน",
    PLZ_INPUT_ACU_POINT_EN: "กรุณากรอกชื่อจุดฝังเข็มเป็นภาษาอังกฤษ",
    PLZ_INPUT_ACU_POINT_X: "กรุณากรอกชื่อจุดฝังเข็มเป็น{{X}}",
    ADD_ACU_POINT: "เพิ่มจุดฝังเข็ม",
    POINT_CREATED: "สร้างจุดฝังเข็มแล้ว",
    ONLY_PAID_HISTORY_WILL_BE_SHOWN_BELOW: "หมายเหตุ: เฉพาะบันทึกการชำระเงินเท่านั้นที่จะแสดงด้านล่าง",
    ME_ONLY: "ฉันเท่านั้น",
    PREFERRED_NAME: "ชื่อที่ต้องการ",
    SELECT_PAIN_CONDITION: "เลือกสภาพความเจ็บปวด",
    CLICK_TO_ADD_CONDITION: "คลิกเพิ่มอาการเจ็บปวด",
    SELECT_CATEGORY_BELOW_TO_ADD_CONDITION: "เลือกหมวดหมู่ด้านล่างเพื่อเพิ่มอาการ",
    PAIN_CONDITIONS: "สภาวะความเจ็บปวด",
    SELECT_POINTS_FOR_THIS_TREATMENT: "เลือกคะแนนสำหรับการรักษานี้",
    THIS_IS_OPTIONAL: "นี่เป็นทางเลือก คุณสามารถคลิกปุ่มเพื่อข้ามขั้นตอนนี้",
    COMMON_ACU_GROUP_TITLE: "กลุ่มจุดฝังเข็มทั่วไป",
    SEARCH_ACU_GROUP_PLACEHOLDER: "ค้นหาชื่อกลุ่มจุดฝังเข็ม",
    NO_ACU_GROUP_FOUND: "ไม่พบกลุ่มจุดฝังเข็ม",
    NO_TREATMENT_ADDED: "ไม่มีการเพิ่มการรักษา",
    TREATMENT_AMOUNT: "จำนวนการรักษา",
    ENTER_TREATMENT: "เข้าสู่การรักษา",
    CLINIC_GROUP: "กลุ่มคลินิก",
    FROM_RECORD: "จากบันทึก",
    X_RELATED_RECORDS: "{{X}} บันทึกที่เกี่ยวข้อง",
    RELATED_RECORDS: "บันทึกที่เกี่ยวข้อง",
    REFRESHING: "สดชื่น",
    CONFIGURE_PRODUCTS: "กำหนดค่ารายการและบริการผลิตภัณฑ์",
    SYSTEM_ACU_GROUP: "ระบบกลุ่มจุดฝังเข็ม",
    COMPLETED: "เสร็จสมบูรณ์",
    IS_RECORD_COMPLETED: "สถานะการบันทึกเสร็จสมบูรณ์",
    RECORD_INCOMPLETE: "ยังไม่เสร็จสมบูรณ์",
    HIDE_INSTRUCTION: "ซ่อนคำแนะนำ",
    VIEW_INSTRUCTION: "ดูคำแนะนำ",
    HIDE_DETAIL: "ซ่อนรายละเอียด",
    PRICE_REQUIRED: "ราคาปัจจุบันคือ 0",
    PLEASE_FILL_IN_TREATMENT_PRICE: "กรุณากรอกราคา",
    TREATMENT_SUBTOTAL: "ผลรวมย่อยของการรักษา",
    OTHER_FEE_SUBTOTAL: "ยอดรวมค่าธรรมเนียมอื่นๆ",
    POINTS: "คะแนน",
    TREATMENT_INSTRUCTION: "คำแนะนำการรักษา",
    CONFIGURE_CLINIC_POINTS: "กำหนดค่าคะแนนคลินิก",
    CLINIC_POINTS: "คะแนนคลินิก",
    POINTS_NAME: "ชื่อคะแนน",
    POINTS_NAME_IN_X: "ชื่อจุด ({{X}})",
    QUICK_PAY: "สร้างเคสด่วน",
    TREATMENT_FEE: "ค่ารักษา",
    UPLOAD_PHOTOS: "อัพโหลดรูปภาพ",
    CLICK_TO_EXPAND: "คลิกเพื่อขยาย",
    CLICK_TO_COLLAPSE: "คลิกเพื่อยุบ",
    SELECT_TREATMENT_TYPE: "เลือกประเภทการรักษา",
    QUICK_CREATE_TREATMENT: "สร้างการรักษาอย่างรวดเร็ว",
    SELECT_ACU_GROUP: "เลือกกลุ่มจุดฝังเข็ม",
    SELECT_TREATMENT: "เลือกการรักษา",
    NO_AVAILABLE_TREATMENTS: "ไม่มีการรักษา โปรดเพิ่มบริการการทำงานในคลินิกก่อน",
    FREQUENTLY_USED_ACU_GROUP: "กลุ่มจุดฝังเข็มที่ใช้บ่อย",
    USED: "เวลาที่ใช้",
    MOST_USED: "ใช้มากที่สุด",
    EXPAND: "ขยาย",
    FILTERED_BY_PAID_AT: "กรองโดย ชำระแล้ว",
    FILTERED_BY_CREATED_AT: "กรองตามเวลาที่สร้าง",
    NO_NEW_PATIENT_CREATED_WITHIN_X: "ไม่มีการสร้างบันทึกผู้ป่วยใหม่ในระหว่าง {{X}}",
    NO_NEW_PRESCRIPTION_PAID_WITHIN_X: "ไม่มีการชำระเงินบันทึกใบสั่งยาใหม่ในระหว่าง {{X}}",
    HEAD_FACE: "ศีรษะ/ใบหน้า",
    SHOULDER_NECK_BACK: "ไหล่/คอ/หลัง",
    ABDOMEN: "หน้าท้อง",
    HAND: "มือ",
    LEG: "ขา",
    FOOT: "ตีนผี",
    WAIST: "เอว",
    SHOULDER_NECK: "ไหล่/คอ",
    NECK_BACK: "คอ/หลัง",
    ARM: "แขน",
    YOU_HAVE_EXCEEDED_THE_MAXIMUM_NUMBER_OF_RETRIES: "คุณลองใหม่เกินจำนวนสูงสุดแล้ว โปรดลองอีกครั้งในภายหลัง",
    PRESCRIPTION_NOT_READY: "ใบสั่งยายังไม่พร้อม โปรดลองอีกครั้งในภายหลัง",
    PRODUCT_MANAGEMENT: "การจัดการผลิตภัณฑ์และบริการ",
    SERVICE: "บริการ",
    PRODUCT: "สินค้า",
    NO_SERVICE_FOUND: "ไม่มีบริการเพิ่ม",
    NO_PRODUCT_FOUND: "ไม่มีการเพิ่มสินค้า",
    CREATE_SERVICE_AND_PRODUCT: "เพิ่มรายการบริการและผลิตภัณฑ์บริการ",
    CREATE_SERVICE: "เพิ่มรายการบริการ",
    CREATE_PRODUCT: "เพิ่มผลิตภัณฑ์บริการ",
    EDIT_SERVICE: "แก้ไขรายการบริการ",
    EDIT_PRODUCT: "แก้ไขผลิตภัณฑ์บริการ",
    NO_SERVICE_OR_PRODUCT_FOUND:
      "โปรดเลือกรายการบริการที่มีอยู่ทางด้านซ้ายเพื่อดู หรือคลิกปุ่มด้านล่างเพื่อสร้างรายการบริการหรือผลิตภัณฑ์บริการใหม่",
    SERVICE_BASIC_INFO: "รายการบริการ ข้อมูลพื้นฐาน",
    SERVICE_DESCRIPTION: "คำอธิบายรายการบริการ",
    NAME_ENGLISH: "ชื่อ (ภาษาอังกฤษ)",
    NAME_CHINESE: "ชื่อ (ภาษาจีน)",
    DESCRIPTION_CHINESE: "คำอธิบาย (ภาษาจีน)",
    DESCRIPTION_ENGLISH: "คำอธิบาย (ภาษาอังกฤษ)",
    DETAILS: "รายละเอียด",
    PRACTITIONERS_PRODUCT_SETTING: "การมอบหมายผู้ประกอบวิชาชีพ",
    CONFIGURE_PRACTITIONERS_FOR_THIS_PRODUCT: "กำหนดค่าผู้ปฏิบัติงานสำหรับผลิตภัณฑ์บริการนี้",
    DEFAULT_PRICE: "ราคาเริ่มต้น",
    ENABLED: "ถูกเปิดใช้งาน",
    ENABLE: "ถูกเปิดใช้งาน",
    CUSTOM_PRICE: "ราคาที่กำหนดเอง",
    NEW_PRACTITIONERS_ARE_ABLED_BY_DEFAULT: "ผู้ปฏิบัติงานใหม่จะถูกเปิดใช้งานตามค่าเริ่มต้น",
    CUSTOM_PRICE_OVERRIDES_DEFAULT_PRICE: "ราคาที่กำหนดเองจะแทนที่ราคาเริ่มต้น",
    LEAVE_CUSTOM_PRICE_EMPTY_TO_USE_DEFAULT_PRICE: "ปล่อยราคาที่กำหนดเองให้ว่างไว้เพื่อใช้ราคาเริ่มต้น",
    PRODUCT_DESCRIPTION: "บริการ รายละเอียดสินค้า",
    NO_MODALITY_SELECTED: "ไม่ได้เลือกประเภทบริการ",
    PRODUCTS: "ผลิตภัณฑ์บริการ",
    SERVICE_INFO: "ข้อมูลรายการบริการ",
    FIELDS_MARKED_WITH_ASTERISK_ARE_REQUIRED: "ช่องที่มีเครื่องหมาย * จำเป็น",
    SELECT_MODALITY: "เลือกประเภทบริการ",
    PLEASE_ENTER_NAME_ENGLISH: "กรุณากรอกชื่อ (ภาษาอังกฤษ)",
    PLEASE_ENTER_NAME_CHINESE: "กรุณากรอกชื่อ (ภาษาจีน)",
    PLEASE_ENTER_DESCRIPTION_ENGLISH: "กรุณากรอกคำอธิบาย (ภาษาอังกฤษ)",
    PLEASE_ENTER_DESCRIPTION_CHINESE: "กรุณากรอกคำอธิบาย (ภาษาจีน)",
    PRODUCT_INFO: "บริการข้อมูลผลิตภัณฑ์",
    SELECT_SERVICE_TYPE: "เลือกประเภทบริการ",
    PRODUCT_NAME: "ชื่อผลิตภัณฑ์บริการ",
    THIS_ITEM: "รายการนี้",
    ASSIGN_PRACTITIONERS: "การมอบหมายผู้ประกอบวิชาชีพ",
    BED_NUM_IF_APPLIED: "ความจุเตียงสำหรับ MAS / ACU (ถ้ามี)",
    BED_NUM_IF_APPLIED_DESCRIPTION:
      "ใช้เฉพาะเมื่อมีการมอบหมายผลิตภัณฑ์ที่สามารถจองได้ให้กับสมาชิกคลินิก และคลินิกจำเป็นต้องจำกัดความจุพร้อมกันตามเตียงหรือความพร้อมของห้อง หากคลินิกให้บริการเฉพาะ TCM เท่านั้น โดยทั่วไปไม่จำเป็นต้องใช้การตั้งค่านี้ ปล่อยให้เป็น 1 ตามค่าเริ่มต้น ค่าขั้นต่ำคือ 1 เตียง",
    WORK_CAPACITY: "จำนวนไคลเอ็นต์สูงสุดที่ให้บริการพร้อมกัน (MAS / ACU)",
    WORK_CAPACITY_DES:
      "กำหนดจำนวนลูกค้าสูงสุดที่พนักงานคนนี้สามารถให้บริการได้ในเวลาเดียวกัน ขั้นต่ำคือ 1 และต้องไม่เกินความจุเตียงของคลินิก",
    CASE_CREATED: "สร้างเวชระเบียนแล้ว",
    NO_AVAILABLE_TREATMENT_TYPE: "ไม่มีการกำหนดค่าวิธีอื่นๆ การใช้ TCM การนวดเป็นค่าเริ่มต้น",
    PATIENTS_CREATED_BY: "ผู้ป่วยที่สร้างโดย",
    PRESCRIPTION_PAID_AT: "เวลาวินิจฉัยของบันทึก",
    LEFT_ARM: "แขนซ้าย",
    RIGHT_ARM: "แขนขวา",
    LEFT_LEG: "ขาซ้าย",
    RIGHT_LEG: "ขาขวา",
    LEFT_HAND: "มือซ้าย",
    RIGHT_HAND: "มือขวา",
    LEFT_FOOT: "เท้าซ้าย",
    RIGHT_FOOT: "เท้าขวา",
    SERVICE_PRODUCT_LIST: "รายการผลิตภัณฑ์บริการของรายการบริการนี้",
    ASSIGNED_PRACTITIONERS: "จำนวนผู้ปฏิบัติงานที่ได้รับมอบหมาย",
    PRODUCT_SERVICE: "เป็นของบริการ",
    ASSIGNED: "มอบหมายแล้ว",
    UNASSIGNED: "ยังไม่ได้มอบหมาย",
    ASSIGN_OR_NOT: "กำหนดหรือไม่",
    PLEASE_ENTER_NAME: "กรุณากรอกชื่อ",
    PLEASE_ENTER_DESCRIPTION: "กรุณากรอกคำอธิบาย",
    SERVICE_NAME: "ชื่อรายการบริการ",
    PRODUCT_INCLUDED: "หมายเลขผลิตภัณฑ์บริการ",
    EDIT_PRODUCT_INFO: "แก้ไขข้อมูลผลิตภัณฑ์บริการ",
    EDIT_PRACTITIONERS_PRODUCT_SETTING: "แก้ไขการกำหนดผลิตภัณฑ์บริการของผู้ปฏิบัติงาน",
    SERVICE_PROJECT: "รายการบริการ",
    SELECT_WORKING_SERVICES: "เลือกประเภทบริการสำหรับรายการบริการนี้",
    SELECT_SERVICE_PROJECT: "เลือกรายการบริการสำหรับผลิตภัณฑ์บริการนี้",
    SERVICE_EXPLANATION:
      "รายการบริการใช้เพื่อกำหนดประเภทของบริการ เช่น นวดศีรษะ นวดหลัง ฯลฯ ผลิตภัณฑ์บริการที่ตามมาจะขึ้นอยู่กับรายการบริการนี้เพื่อกำหนดราคาและระยะเวลา",
    NO_PRACTITIONERS_FOR_THIS_SERVICE:
      "ไม่มีผู้ประกอบวิชาชีพที่พร้อมให้บริการประเภทนี้ โปรดไปที่การกำหนดค่าประเภทบริการ หรือติดต่อผู้ปฏิบัติงานที่เกี่ยวข้องเพื่อทำการกำหนดค่าให้เสร็จสิ้น",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_TCM:
      "คุณสามารถจัดการข้อมูลผู้ป่วยและเวชระเบียนของคลินิก และสร้างใบสั่งยาสำหรับผู้ป่วยในโหมด TCM",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_TCM: "คู่มือการสั่งยาและประวัติทางการแพทย์ - โหมด TCM",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_MASSAGE: "คู่มือการสั่งยาและประวัติทางการแพทย์ - โหมดการนวด",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_MASSAGE:
      "คุณสามารถจัดการข้อมูลผู้ป่วยและเวชระเบียนของคลินิก และสร้างใบสั่งยาสำหรับผู้ป่วยในโหมดการนวด",
    NAME_IS_REQUIRED: "กรุณากรอกชื่อ",
    INVALID_PRICE: "กรุณากรอกราคาที่ถูกต้อง",
    INVALID_DURATION: "โปรดป้อนระยะเวลาที่ถูกต้อง",
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER: "ไม่มีผลิตภัณฑ์บริการสำหรับผู้ประกอบวิชาชีพรายนี้",
    ADD_CUSTOMISED_SERVICE: "เพิ่มบริการแบบกำหนดเอง",
    CUSTOM_SERVICE_CREATED: "สร้างบริการที่กำหนดเองสำเร็จแล้ว",
    U_CAN_ADD_UR_CUSTOMISED_SERVICE_TO_WORK_WITH: "คุณสามารถสร้างหมวดหมู่บริการแบบกำหนดเองเพื่อใช้ในการสร้างเวชระเบียน",
    INPUT_UR_SERVICE_TYPE_NAME_HERE: "กรอกชื่อหมวดหมู่บริการ",
    PLEASE_NOTE_ONLY_YOU_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "โปรดทราบว่าหมวดหมู่บริการแบบกำหนดเองนี้จะสามารถใช้งานได้เฉพาะคุณเท่านั้น",
    PLEASE_NOTE_ONLY_THIS_CLINIC_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "โโปรดทราบ: บริการที่กำหนดเองนี้สามารถใช้ได้เฉพาะในคลินิกที่คุณเป็นเจ้าของกิจการ (Business Owner) เท่านั้น",
    TREATMENT_INSTRUCTIONS: "คำแนะนำการรักษา",
    DEFAULT_DOB_WARNING: "ไม่ได้ระบุวันเดือนปีเกิด ระบบจึงใช้วันที่เริ่มต้น (01/01/1990)",
    RESIGN_CONSENT_FORM: "ลงนามแบบฟอร์มยินยอมอีกครั้ง",
    CONSENT_FORM_DOES_NOT_COVER_DATE_X: "วันที่ตรวจที่เลือกอยู่ก่อนวันที่แบบฟอร์มยินยอมของผู้ป่วยเริ่มมีผล ({{X}}) กรุณาให้ผู้ป่วยลงนามแบบฟอร์มยินยอมใหม่ก่อนทำการเปลี่ยนแปลง",
    SAVE_APPOINTMENT_INFO_LOCALLY: "บันทึกรายละเอียดการนัดหมายลงในอุปกรณ์",
    TRANSLATING: "กำลังแปลภาษา",
    PROCESSING: "กำลังประมวลผล",
    OTHER_LANG_CONTENT_GOES_HERE: "กรอกเนื้อหาภาษาอื่นที่นี่",
    PLEASE_SELECT_DOWNLOAD_FORMAT: "กรุณาเลือกรูปแบบการดาวน์โหลด",
    PDF_FILE: "ไฟล์ PDF",
    WORD_DOC: "เอกสาร Word",
    NEXT_MONTH: "เดือนถัดไป",
    PREV_MONTH: "เดือนก่อนหน้า",
    ALL_TIME: "ทุกช่วงเวลา",
    TCM_MODE_SERVICE_DESC: "เมื่อเลือกหมวดหมู่บริการต่อไปนี้ ระบบจะใช้โหมดการวินิจฉัยแบบละเอียดในการสร้างเวชระเบียน โหมดนี้มีตัวเลือกเวชระเบียนที่ครอบคลุมมากขึ้น และรองรับการบันทึกข้อมูลทางคลินิกอย่างละเอียด",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE_SERVICE_DESC: "เมื่อเลือกหมวดหมู่บริการต่อไปนี้ ระบบจะใช้โหมดด่วนสำหรับการฝังเข็ม / การนวดทุยหนาในการสร้างเวชระเบียน โหมดนี้ออกแบบมาสำหรับบริการนวดและหัตถบำบัด โดยมีขั้นตอนการสั่งการรักษาที่เรียบง่ายกว่าโหมดการวินิจฉัยแบบละเอียด ช่วยให้บันทึกการรักษาได้รวดเร็วและสะดวกยิ่งขึ้น",
    MASSAGE_QUICK_MODE: "โหมดด่วนสำหรับการฝังเข็ม / การนวดทุยหนา",
    TRY_NEW_UI: "ทดลองใช้แบบฟอร์มเวชระเบียนแบบใหม่",
    TRY_NEW_UI_INTRO: "แบบฟอร์มเวชระเบียนแบบใหม่นี้เป็นการปรับปรุงหน้าตาเฉพาะสำหรับเวชระเบียนประเภทฝังเข็ม/นวดในขณะนี้ ระบบจะเตือนคุณอัตโนมัติว่ายังมีช่องที่ต้องกรอกใดบ้างที่ยังไม่ได้กรอก ข้อมูลที่คุณกรอกเหมือนเดิมทุกอย่าง เปลี่ยนแค่หน้าตาเท่านั้น ฟีเจอร์นี้อยู่ระหว่างทดลองใช้ หากพบปัญหาสามารถแจ้งเราได้ และหากไม่ชอบก็สามารถปิดการทดลองใช้ได้ทุกเมื่อ",
    TRY_NEW_UI_STEP_BY_STEP: "สั่งการรักษาแบบมีคำแนะนำทีละขั้นตอน",
    GUIDED_UI_TOGGLE_OLD: "UI เดิม",
    GUIDED_UI_TOGGLE_NEW: "UI ใหม่",
    I_AGREE_AND_SIGN: "ฉันยอมรับและลงนาม",
    PATIENT_SIGN_IN_PERSON: "ผู้ป่วยลงนามต่อหน้า",
    AND_X_MORE: "และอื่น {{X}} บันทึกที่นี่",
    CLICK_TO_ADD_CONTENT: "คลิกเพื่อเพิ่มเนื้อหา",
    NO_CONTENT_FILLED: "ไม่เพิ่มเนื้อหา",
    CONTENT_FILLED: "เนื้อหาเพิ่มแล้ว",
    TREATMENT_OUTCOME: "ผลลัพธ์การรักษา",
    TREATMENT_RECOMMENDATION: "คำแนะนำการรักษา",
    SHOW_ALL_SERVICES: "แสดงบริการทั้งหมด",
    SHOW_SERVICE_HAS_PRODUCT: "แสดงบริการที่มีสินค้า",
    UP_TO_X_USERS_INCLUDED: "รวมผู้ใช้ได้สูงสุด {{X}} คน",
    PHONE_CONSULTATION: "ปรึกษาทางโทรศัพท์",
    PLEASE_CONTACT_US_FOR_THIS_PACKAGE: "กรุณาติดต่อเราเพื่อจัดทำแพ็กเกจเฉพาะสำหรับคลินิกของคุณ",
    LEFT_CALF: "น่องซ้าย",
    SHOWING: "กำลังแสดง",
    SWIPE_OR_USE_ARROWS_TO_VIEW_MORE_PACKAGES: "ปัดซ้ายขวาหรือใช้ลูกศรเพื่อดูแพ็กเกจเพิ่มเติม",
    DOWNLOAD_SICK_CERTIFICATE: "ดาวน์โหลดใบลาป่วย",
    ISSUE_SICK_CERTIFICATE: "ออกใบลาป่วย",
    DAY: "วัน",
    DAY_VIEW: "มุมมองรายวัน",
    PREV_DAY: "วันก่อนหน้า",
    NEXT_DAY: "วันถัดไป",
    SCROLL_TO_NEXT_BOOKING: "เลื่อนไปยังการนัดหมายถัดไป",
    X_BOOKINGS: "จำนวน {{X}} การนัดหมาย",
    CREATE_APPOINTMENT_FOR_THIS_DAY: "สร้างการนัดหมายสำหรับวันนี้",
    PLEASE_SELECT_SERVICE_TYPE_FROM_LEFT_FIRST: "กรุณาเลือกประเภทบริการจากด้านซ้ายก่อน",
    UNSELECT_THIS_BODY_PART: "ยกเลิกการเลือกส่วนนี้ของร่างกาย",
    UNSAVED_CHANGES: "การเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    UNSAVED_BODY_PART_METHOD_CHANGES_DESC: "คุณมีการเปลี่ยนแปลงในส่วนของร่างกายหรือเทคนิคการนวดที่ยังไม่ได้บันทึก หากปิดตอนนี้ การเปลี่ยนแปลงเหล่านี้จะไม่ถูกบันทึก",
    CONTINUE_EDITING: "แก้ไขต่อ",
    DISCARD_AND_CLOSE: "ไม่บันทึกและปิด",

    EDIT_CUSTOMISED_SERVICE: "แก้ไขบริการที่กำหนดเอง",
    PRIMARY_LANGUAGE: "ภาษาหลัก",
    OTHER_LANGUAGES: "ภาษาอื่น",
    REQUIRED: "จำเป็น",
    OPTIONAL: "ไม่บังคับ",
    TRANSLATE: "แปลภาษา",
    TRANSLATE_TO_OTHER_LANGUAGES: "แปลเป็นภาษาอื่น",
    PLEASE_ENTER_ENGLISH_NAME_FIRST: "กรุณากรอกชื่อภาษาอังกฤษก่อน",
    ENGLISH_NAME_IS_REQUIRED_AND_USED_AS_DEFAULT: "จำเป็นต้องกรอกชื่อภาษาอังกฤษ และจะใช้เป็นชื่อเริ่มต้น",
    OTHER_LANGUAGE_FIELDS_ARE_OPTIONAL: "ภาษาอื่นเป็นตัวเลือก สามารถแก้ไขเองหรือแปลอัตโนมัติได้",
    NAME_MODALITY_IN_ENGLISH: "ชื่อบริการภาษาอังกฤษ",
    NAME_MODALITY_IN_CHINESE: "ชื่อบริการภาษาจีน",
    NAME_MODALITY_IN_THAI: "ชื่อบริการภาษาไทย",
    NAME_MODALITY_IN_VIETNAMESE: "ชื่อบริการภาษาเวียดนาม",
    MODALITY_UPDATED: "อัปเดตบริการเรียบร้อยแล้ว",
    CLICK_TO_EDIT: "คลิกเพื่อแก้ไข",
    PRODUCT_DURATION_CANNOT_EXCEED_5_HOURS: "ระยะเวลาของผลิตภัณฑ์ต้องไม่เกิน 5 ชั่วโมง",
    UNSAVED_CHANGES_WARNING: "การเปลี่ยนแปลงที่ยังไม่ได้บันทึกทั้งหมดจะสูญหาย คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",

    // ---- การเชื่อมต่อ Xero ----
    XERO_SETTINGS: "การตั้งค่า Xero",
    XERO_SETTINGS_HINT: "เชื่อมต่อบัญชี Xero ของคลินิกเพื่อส่งการเข้ารับบริการที่ชำระเงินแล้วเป็นใบแจ้งหนี้ให้นักบัญชีตรวจสอบ",
    XERO_CONNECT: "เชื่อมต่อกับ Xero",
    XERO_RETRY_CONNECT: "ลองอีกครั้ง",
    XERO_NOT_CONNECTED_TITLE: "ยังไม่ได้เชื่อมต่อกับ Xero",
    XERO_NOT_CONNECTED_DESCRIPTION: "เชื่อมต่อ Xero Organisation ของคลินิกนี้เพื่อเริ่มส่งการเข้ารับบริการที่ชำระเงินแล้วเป็นใบแจ้งหนี้",
    XERO_CONNECT_SUCCESS: "เชื่อมต่อกับ Xero แล้ว",
    XERO_CONNECT_SUCCESS_WITH_ORG: 'เชื่อมต่อกับ Xero Organisation "{{org}}" แล้ว',
    XERO_CONNECT_FAILED_ACCESS_DENIED: "คุณยกเลิกการอนุญาตในหน้า Xero",
    XERO_CONNECT_FAILED_EXCHANGE: "การอนุญาตล้มเหลว กรุณาเชื่อมต่อใหม่อีกครั้ง",
    XERO_ORGANISATION: "Xero Organisation",
    XERO_CONNECTED_SINCE: "เชื่อมต่อตั้งแต่",
    XERO_DISCONNECT: "ยกเลิกการเชื่อมต่อ",
    XERO_DISCONNECT_SUCCESS: "ยกเลิกการเชื่อมต่อกับ Xero แล้ว",
    XERO_DISCONNECT_CONFIRM_1: "เมื่อยกเลิกการเชื่อมต่อแล้ว คุณจะไม่สามารถส่งการเข้ารับบริการไปยัง Xero ได้อีก",
    XERO_DISCONNECT_CONFIRM_2: "ใบแจ้งหนี้ที่มีอยู่แล้วใน Xero จะไม่ได้รับผลกระทบ",
    XERO_DISCONNECT_CONFIRM_3: "คุณสามารถเชื่อมต่อใหม่ได้ทุกเมื่อ",
    XERO_ACCOUNT_MAPPING: "การจับคู่บัญชีรายได้",
    XERO_ACCOUNT_MAPPING_HINT: "เลือกว่าค่ารักษาและค่าใช้จ่ายอื่น ๆ จะถูกบันทึกไว้ในบัญชี Xero ใด",
    XERO_ACCOUNT_CODES_INCOMPLETE_WARNING: "ยังตั้งค่าการจับคู่บัญชีไม่ครบถ้วน — จะไม่สามารถส่งใบแจ้งหนี้ไปยัง Xero ได้จนกว่าจะเลือกบัญชีทั้งสองแล้ว",
    XERO_TREATMENT_ACCOUNT_CODE: "บัญชีรายได้ค่ารักษา",
    XERO_OTHER_FEE_ACCOUNT_CODE: "บัญชีค่าใช้จ่ายอื่น ๆ",
    XERO_NO_ACCOUNTS_AVAILABLE: "ไม่มีบัญชีรายได้ที่ใช้งานได้ใน Xero Organisation นี้ กรุณาตั้งค่าใน Xero ก่อน",
    XERO_ACCOUNT_CODES_REQUIRED: "กรุณาเลือกบัญชีทั้งสองก่อนบันทึก",
    XERO_ACCOUNT_CODES_SAVED: "บันทึกการจับคู่บัญชีแล้ว",
    XERO_AUTOMATION_SETTINGS: "การตั้งค่าอัตโนมัติ",
    XERO_AUTOMATION_SETTINGS_HINT: "ไม่บังคับ โดยค่าเริ่มต้นใบแจ้งหนี้จะเข้าสู่ Xero เป็นฉบับร่างเพื่อให้นักบัญชีของคลินิกอนุมัติด้วยตนเอง",
    XERO_AUTO_SYNC_TOGGLE: "อนุมัติและรับชำระเงินอัตโนมัติ",
    XERO_AUTO_SYNC_TOGGLE_HINT: "เมื่อเปิดใช้งาน การเข้ารับบริการที่ชำระเงินแล้วซึ่งถูกส่งไปยัง Xero จะได้รับการอนุมัติและกระทบยอดโดยอัตโนมัติ — ไม่ต้องดำเนินการด้วยตนเองใน Xero",
    XERO_AUTO_SYNC_OFF_LABEL: "ปิด",
    XERO_AUTO_SYNC_OFF_DESCRIPTION: "ใบแจ้งหนี้จะค้างเป็นฉบับร่างใน Xero เพื่อให้นักบัญชีอนุมัติด้วยตนเอง",
    XERO_AUTO_SYNC_ON_LABEL: "เปิด",
    XERO_AUTO_SYNC_ON_DESCRIPTION: "ใบแจ้งหนี้จะได้รับการอนุมัติและทำเครื่องหมายว่าชำระเงินแล้วใน Xero โดยอัตโนมัติ โดยไม่ต้องผ่านขั้นตอนฉบับร่าง",
    XERO_PAYMENT_ACCOUNT_CODE: "บัญชีธนาคารสำหรับรับชำระเงิน",
    XERO_NO_BANK_ACCOUNTS_HINT: 'Xero Organisation นี้ยังไม่มีบัญชีธนาคาร กรุณาเพิ่มใน Xero ("Add Bank Account") ก่อนเปิดใช้การบันทึกการชำระเงินอัตโนมัติ',
    XERO_BANK_ACCOUNT_NOT_PAYABLE: "ไม่รองรับการรับชำระเงิน",
    XERO_AUTO_SYNC_PAYMENT_ACCOUNT_REQUIRED: "กรุณาเลือกบัญชีธนาคารก่อนเปิดใช้การบันทึกการชำระเงินอัตโนมัติ",
    XERO_AUTO_SYNC_SAVED: "บันทึกการตั้งค่าอัตโนมัติแล้ว",
    XERO_INVOICE_SEARCH: "ใบแจ้งหนี้ Xero",
    XERO_PUSH_INVOICE: "ส่งไปยัง Xero",
    XERO_PUSH_NOW: "ส่งทันที",
    XERO_NEVER_PUSHED_HINT: "การเข้ารับบริการนี้ยังไม่เคยถูกส่งไปยัง Xero กดส่งเพื่อสร้างใบแจ้งหนี้",
    XERO_PUSH_SUCCESS: "ส่งไปยัง Xero แล้ว",
    XERO_PUSH_ALREADY_SYNCED: "การเข้ารับบริการนี้ถูกส่งไปยัง Xero แล้ว — แสดงใบแจ้งหนี้ที่มีอยู่",
    XERO_PUSH_DISABLED_NOT_PAID: "ส่งไปยัง Xero ได้เฉพาะการเข้ารับบริการที่ชำระเงินแล้วเท่านั้น",
    XERO_PUSH_DISABLED_NOT_CONNECTED: "คลินิกนี้ยังไม่ได้เชื่อมต่อกับ Xero",
    XERO_INVOICE_NUMBER: "หมายเลขใบแจ้งหนี้",
    XERO_INVOICE_STATUS: "สถานะใบแจ้งหนี้ Xero",
    XERO_INVOICE_STATUS_DRAFT: "ฉบับร่าง",
    XERO_INVOICE_STATUS_SUBMITTED: "ส่งแล้ว",
    XERO_INVOICE_STATUS_DELETED: "ลบแล้ว",
    XERO_INVOICE_STATUS_AUTHORISED: "อนุมัติแล้ว",
    XERO_INVOICE_STATUS_PAID: "ชำระเงินแล้ว",
    XERO_INVOICE_STATUS_VOIDED: "ยกเลิกแล้ว",
    XERO_SYNCED_AT: "เวลาที่ส่ง",
    XERO_SYNC_STATUS_SYNCED: "ส่งสำเร็จ",
    XERO_SYNC_STATUS_PENDING: "กำลังดำเนินการ",
    XERO_SYNC_STATUS_FAILED: "ล้มเหลว",
    XERO_SYNC_STATUS_NEVER_PUSHED: "ยังไม่เคยส่ง",
    XERO_ERROR_CLINIC_NOT_SELECTED: "กรุณาเลือกคลินิกก่อน",
    XERO_ERROR_INVALID_TOKEN: "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
    XERO_UNKNOWN_ERROR: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    XERO_SELECT_ORGANISATION: "เลือก Xero Organisation",
    XERO_SELECT_ORGANISATION_HINT: "การเชื่อมต่อ Xero นี้ครอบคลุมมากกว่าหนึ่ง Organisation กรุณาเลือกว่าคลินิกนี้จะส่งใบแจ้งหนี้ไปยัง Organisation ใด",
    XERO_SWITCH_ORGANISATION: "สลับ Organisation",
    XERO_CURRENT_ORGANISATION: "ปัจจุบัน",
    XERO_SWITCH_ORGANISATION_TO: "กำลังสลับไปยัง",
    XERO_ORG_SWITCH_SUCCESS: 'สลับไปยัง Xero Organisation "{{org}}" แล้ว',
    XERO_SWITCH_ORGANISATION_CONFIRM_INTRO: 'สลับไปยัง "{{org}}" หรือไม่? รายการต่อไปนี้จะถูกล้างเนื่องจากเจาะจงกับ Organisation ปัจจุบัน:',
    XERO_SWITCH_ORGANISATION_WIPE_ACCOUNTS: "การจับคู่บัญชีรายได้ค่ารักษาและค่าใช้จ่ายอื่น ๆ",
    XERO_SWITCH_ORGANISATION_WIPE_AUTOMATION: "บัญชีธนาคารและการตั้งค่าอัตโนมัติ (จะถูกปิด)",
    XERO_SWITCH_ORGANISATION_CONFIRM_OUTRO: "คุณจะต้องตั้งค่าการจับคู่บัญชีใหม่สำหรับ Organisation ใหม่ก่อนจึงจะสามารถส่งใบแจ้งหนี้ได้",
  },
};
